export const topology = {
  "type": "Topology",
  "objects": {
    "default": {
      "type": "GeometryCollection",
      "geometries": [
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                0
              ]
            ],
            [
              [
                1
              ]
            ]
          ],
          "id": "GB.AY",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-ay",
            "hc-a2": "AY",
            "labelrank": "9",
            "iso_3166_2": "GB-AGY",
            "hasc": "GB.AY",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority (wales",
            "region": "East Wales",
            "woe-id": "12602211",
            "longitude": "-4.3787",
            "subregion": "North Wales",
            "woe-name": "Anglesey County",
            "fips": "UK93",
            "latitude": "53.2996",
            "woe-label": null,
            "postal-code": "AY",
            "type": "Unitary Authority (wales)",
            "name": "Anglesey"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                38
              ]
            ],
            [
              [
                39,
                40
              ]
            ]
          ],
          "id": "GB.PS",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-ps",
            "hc-a2": "PS",
            "labelrank": "9",
            "iso_3166_2": "GB-POR",
            "hasc": "GB.PS",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "South East",
            "woe-id": "12696158",
            "longitude": "-0.979793",
            "subregion": "Hampshire",
            "woe-name": "Portsmouth City",
            "fips": "UK23",
            "latitude": "50.8032",
            "woe-label": null,
            "postal-code": "PS",
            "type": "Unitary Authority",
            "name": "Portsmouth"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              54
            ]
          ],
          "id": "GB.7398",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7398",
            "hc-a2": "IO",
            "labelrank": "9",
            "iso_3166_2": "GB-IOS",
            "hasc": "GB.IS",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Single-Tier County",
            "region": "South West",
            "woe-id": "12602181",
            "longitude": "-4.75267",
            "subregion": "Cornwall",
            "woe-name": "Cornwall and Isles of Scilly",
            "fips": "UK08",
            "latitude": "50.4407",
            "woe-label": null,
            "postal-code": null,
            "type": "Unitary Single-Tier County",
            "name": "Isles of Scilly"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              59
            ]
          ],
          "id": "GB.LC",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-lc",
            "hc-a2": "LC",
            "labelrank": "9",
            "iso_3166_2": "GB-LCE",
            "hasc": "GB.LC",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "East Midlands",
            "woe-id": "12696154",
            "longitude": "-1.1183",
            "subregion": "Leicestershire",
            "woe-name": "Leicester City",
            "fips": "UK26",
            "latitude": "52.6114",
            "woe-label": null,
            "postal-code": "LC",
            "type": "Unitary Authority",
            "name": "Leicester"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              60,
              61,
              62,
              63,
              64,
              65,
              66
            ],
            [
              -60
            ]
          ],
          "id": "GB.2393",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-2393",
            "hc-a2": "LE",
            "labelrank": "9",
            "iso_3166_2": "GB-LEC",
            "hasc": "GB.",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Kingdom",
            "region": "East Midlands",
            "woe-id": "12602144",
            "longitude": "-1.11707",
            "subregion": "Leicestershire",
            "woe-name": "Leicestershire",
            "fips": "UK26",
            "latitude": "52.491",
            "woe-label": null,
            "postal-code": null,
            "type": "Home Nation|Constituent Country",
            "name": "Leicestershire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -61,
              67,
              68,
              69,
              70,
              71,
              72,
              73,
              74,
              75
            ],
            [
              76
            ]
          ],
          "id": "GB.DB",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-db",
            "hc-a2": "DB",
            "labelrank": "9",
            "iso_3166_2": "GB-DBY",
            "hasc": "GB.DB",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Administrative County",
            "region": "East Midlands",
            "woe-id": "12602143",
            "longitude": "-1.58946",
            "subregion": "Derbyshire",
            "woe-name": "Derbyshire",
            "fips": "UK10",
            "latitude": "52.9938",
            "woe-label": null,
            "postal-code": "DB",
            "type": "Administrative County",
            "name": "Derbyshire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -77
            ]
          ],
          "id": "GB.DE",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-de",
            "hc-a2": "DE",
            "labelrank": "9",
            "iso_3166_2": "GB-DBY",
            "hasc": "GB.DE",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "East Midlands",
            "woe-id": "12696153",
            "longitude": "-1.47157",
            "subregion": "Derbyshire",
            "woe-name": "Derby City",
            "fips": "UK10",
            "latitude": "52.8904",
            "woe-label": null,
            "postal-code": "DE",
            "type": "Unitary Authority",
            "name": "Derby"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              88
            ]
          ],
          "id": "GB.NG",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-ng",
            "hc-a2": "NG",
            "labelrank": "9",
            "iso_3166_2": "GB-NGM",
            "hasc": "GB.NG",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "East Midlands",
            "woe-id": "12696180",
            "longitude": "-1.16592",
            "subregion": "Nottinghamshire",
            "woe-name": "Nottingham City",
            "fips": "UK33",
            "latitude": "52.9352",
            "woe-label": null,
            "postal-code": "NG",
            "type": "Unitary Authority",
            "name": "Nottingham"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              89,
              90,
              91,
              92,
              93,
              94,
              95,
              96,
              97
            ]
          ],
          "id": "GB.DO",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-do",
            "hc-a2": "DO",
            "labelrank": "9",
            "iso_3166_2": "GB-DEV",
            "hasc": "GB.DO",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Administrative County",
            "region": "South West",
            "woe-id": "12602182",
            "longitude": "-3.85842",
            "subregion": "Devon",
            "woe-name": "Devon",
            "fips": "UK11",
            "latitude": "50.8008",
            "woe-label": null,
            "postal-code": "DO",
            "type": "Administrative County",
            "name": "Devon"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              168,
              169,
              170,
              171,
              172,
              173,
              174,
              175,
              176
            ]
          ],
          "id": "GB.DH",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-dh",
            "hc-a2": "DH",
            "labelrank": "9",
            "iso_3166_2": "GB-DUR",
            "hasc": "GB.DH",
            "alt-name": "County Durham",
            "country": "United Kingdom",
            "type-en": "Unitary Single-Tier County",
            "region": "North East",
            "woe-id": "12602150",
            "longitude": "-1.79965",
            "subregion": "Durham",
            "woe-name": "County Durham",
            "fips": "UK13",
            "latitude": "54.6955",
            "woe-label": null,
            "postal-code": "DH",
            "type": "Unitary Single-Tier County",
            "name": "Durham"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -172,
              177,
              178
            ]
          ],
          "id": "GB.DA",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-da",
            "hc-a2": "DA",
            "labelrank": "9",
            "iso_3166_2": "GB-DAL",
            "hasc": "GB.DA",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "North East",
            "woe-id": "12696152",
            "longitude": "-1.53938",
            "subregion": "Durham",
            "woe-name": "Darlington Borough",
            "fips": "UK13",
            "latitude": "54.5202",
            "woe-label": null,
            "postal-code": "DA",
            "type": "Unitary Authority",
            "name": "Darlington"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -170,
              179,
              180,
              181
            ]
          ],
          "id": "GB.HP",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-hp",
            "hc-a2": "HP",
            "labelrank": "9",
            "iso_3166_2": "GB-HPL",
            "hasc": "GB.HP",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "North East",
            "woe-id": "12696139",
            "longitude": "-1.27662",
            "subregion": "Durham",
            "woe-name": "Hartlepool Borough",
            "fips": "UK07",
            "latitude": "54.6625",
            "woe-label": null,
            "postal-code": "HP",
            "type": "Unitary Authority",
            "name": "Hartlepool"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              182,
              183,
              184
            ]
          ],
          "id": "GB.MB",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-mb",
            "hc-a2": "MB",
            "labelrank": "9",
            "iso_3166_2": "GB-MDB",
            "hasc": "GB.MB",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "North East",
            "woe-id": "12696141",
            "longitude": "-1.23971",
            "subregion": "Durham",
            "woe-name": "Middlesbrough",
            "fips": "UK07",
            "latitude": "54.5364",
            "woe-label": null,
            "postal-code": "MB",
            "type": "Unitary Authority",
            "name": "Middlesbrough"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -183,
              185,
              -181,
              186,
              187
            ]
          ],
          "id": "GB.RC",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-rc",
            "hc-a2": "RC",
            "labelrank": "9",
            "iso_3166_2": "GB-RCC",
            "hasc": "GB.RC",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "North East",
            "woe-id": "12696145",
            "longitude": "-0.999287",
            "subregion": "Durham",
            "woe-name": "Redcar and Cleveland Borough",
            "fips": "UK07",
            "latitude": "54.5485",
            "woe-label": null,
            "postal-code": "RC",
            "type": "Unitary Authority",
            "name": "Redcar and Cleveland"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -186,
              -185,
              188,
              -178,
              -171,
              -182
            ]
          ],
          "id": "GB.ZT",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-zt",
            "hc-a2": "ZT",
            "labelrank": "9",
            "iso_3166_2": "GB-STT",
            "hasc": "GB.ZT",
            "alt-name": "Stockton",
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "North East",
            "woe-id": "12696147",
            "longitude": "-1.32309",
            "subregion": "Durham",
            "woe-name": "Stockton-on-Tees Borough",
            "fips": "UK07",
            "latitude": "54.5378",
            "woe-label": null,
            "postal-code": "ZT",
            "type": "Unitary Authority",
            "name": "Stockton-on-Tees"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              189,
              -41,
              190,
              191,
              192,
              193,
              194,
              195,
              196,
              197,
              198,
              199
            ]
          ],
          "id": "GB.HA",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-ha",
            "hc-a2": "HA",
            "labelrank": "9",
            "iso_3166_2": "GB-HAM",
            "hasc": "GB.HA",
            "alt-name": "Southampton",
            "country": "United Kingdom",
            "type-en": "Administrative County",
            "region": "South East",
            "woe-id": "12602169",
            "longitude": "-1.23817",
            "subregion": "Hampshire",
            "woe-name": "Hampshire",
            "fips": "UK19",
            "latitude": "51.1286",
            "woe-label": null,
            "postal-code": "HA",
            "type": "Administrative County",
            "name": "Hampshire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              200,
              -192
            ]
          ],
          "id": "GB.ZH",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-zh",
            "hc-a2": "ZH",
            "labelrank": "9",
            "iso_3166_2": "GB-STH",
            "hasc": "GB.ZH",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "South East",
            "woe-id": "12696160",
            "longitude": "-1.3776",
            "subregion": "Hampshire",
            "woe-name": "Southampton City",
            "fips": "UK19",
            "latitude": "50.9158",
            "woe-label": null,
            "postal-code": "ZH",
            "type": "Unitary Authority",
            "name": "Southampton"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              201,
              202,
              203,
              204,
              205,
              206,
              207,
              208,
              209
            ]
          ],
          "id": "GB.2318",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-2318",
            "hc-a2": "MO",
            "labelrank": "9",
            "iso_3166_2": "GB-MON",
            "hasc": "GB.MM",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority (wales",
            "region": "West Wales and the Valleys",
            "woe-id": "12602223",
            "longitude": "-2.90226",
            "subregion": "South Wales",
            "woe-name": "Monmouthshire",
            "fips": "UK92",
            "latitude": "51.7744",
            "woe-label": null,
            "postal-code": null,
            "type": "Unitary Authority (wales)",
            "name": "Monmouthshire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              210,
              208,
              211,
              212,
              213,
              214,
              215,
              216,
              217,
              218,
              -202
            ]
          ],
          "id": "GB.GC",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-gc",
            "hc-a2": "GC",
            "labelrank": "9",
            "iso_3166_2": "GB-GLS",
            "hasc": "GB.GC",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Administrative County",
            "region": "South West",
            "woe-id": "12602184",
            "longitude": "-2.14862",
            "subregion": "Gloucestershire",
            "woe-name": "Gloucestershire",
            "fips": "UK16",
            "latitude": "51.8153",
            "woe-label": null,
            "postal-code": "GC",
            "type": "Administrative County",
            "name": "Gloucestershire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              219,
              220,
              221,
              222
            ]
          ],
          "id": "GB.MK",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-mk",
            "hc-a2": "MK",
            "labelrank": "9",
            "iso_3166_2": "GB-MIK",
            "hasc": "GB.MK",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "South East",
            "woe-id": "12696156",
            "longitude": "-0.72601",
            "subregion": "Buckinghamshire",
            "woe-name": "Milton Keynes",
            "fips": "UK31",
            "latitude": "52.0571",
            "woe-label": null,
            "postal-code": "MK",
            "type": "Unitary Authority",
            "name": "Milton Keynes"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -220,
              223,
              224,
              225,
              226,
              227,
              228,
              229,
              230,
              231
            ]
          ],
          "id": "GB.BU",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-bu",
            "hc-a2": "BU",
            "labelrank": "9",
            "iso_3166_2": "GB-BKM",
            "hasc": "GB.BU",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Administrative County",
            "region": "South East",
            "woe-id": "12602166",
            "longitude": "-0.806599",
            "subregion": "Buckinghamshire",
            "woe-name": "Buckinghamshire",
            "fips": "UK04",
            "latitude": "51.7717",
            "woe-label": null,
            "postal-code": "BU",
            "type": "Administrative County",
            "name": "Buckinghamshire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              232,
              233,
              234,
              235,
              236
            ]
          ],
          "id": "GB.BN",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-bn",
            "hc-a2": "BN",
            "labelrank": "9",
            "iso_3166_2": "GB-BAS",
            "hasc": "GB.BN",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "South West",
            "woe-id": "12696136",
            "longitude": "-2.49591",
            "subregion": "Bristol",
            "woe-name": "Bath and North East Somerset",
            "fips": "UK01",
            "latitude": "51.3476",
            "woe-label": null,
            "postal-code": "BN",
            "type": "Unitary Authority",
            "name": "Bath and North East Somerset"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -233,
              237,
              238,
              239
            ]
          ],
          "id": "GB.BS",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-bs",
            "hc-a2": "BS",
            "labelrank": "9",
            "iso_3166_2": "GB-BST",
            "hasc": "GB.BS",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "South West",
            "woe-id": "12602180",
            "longitude": "-2.60107",
            "subregion": "Bristol",
            "woe-name": "City of Bristol",
            "fips": "UK01",
            "latitude": "51.4624",
            "woe-label": null,
            "postal-code": "BS",
            "type": "Unitary Authority",
            "name": "Bristol"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -237,
              240,
              241,
              -238
            ]
          ],
          "id": "GB.NS",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-ns",
            "hc-a2": "NS",
            "labelrank": "9",
            "iso_3166_2": "GB-NSM",
            "hasc": "GB.NS",
            "alt-name": "North West Somerset",
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "South West",
            "woe-id": "12696144",
            "longitude": "-2.79158",
            "subregion": "Bristol",
            "woe-name": "North Somerset",
            "fips": "UK01",
            "latitude": "51.4109",
            "woe-label": null,
            "postal-code": "NS",
            "type": "Unitary Authority",
            "name": "North Somerset"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -234,
              -240,
              242,
              -218,
              243
            ]
          ],
          "id": "GB.SJ",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-sj",
            "hc-a2": "SJ",
            "labelrank": "9",
            "iso_3166_2": "GB-SGC",
            "hasc": "GB.SJ",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "South West",
            "woe-id": "12696146",
            "longitude": "-2.462",
            "subregion": "Bristol",
            "woe-name": "South Gloucestershire",
            "fips": "UK01",
            "latitude": "51.5239",
            "woe-label": null,
            "postal-code": "SJ",
            "type": "Unitary Authority",
            "name": "South Gloucestershire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              244,
              245,
              246
            ]
          ],
          "id": "GB.2389",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-2389",
            "hc-a2": "BO",
            "labelrank": "9",
            "iso_3166_2": "GB-BMH",
            "hasc": "GB.BM",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "South West",
            "woe-id": "12696150",
            "longitude": "-1.86297",
            "subregion": "Dorset",
            "woe-name": "Bournemouth Borough",
            "fips": "UK12",
            "latitude": "50.7378",
            "woe-label": null,
            "postal-code": null,
            "type": "Unitary Authority",
            "name": "Bournemouth"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              247,
              -247,
              248,
              249,
              -94,
              250,
              251,
              -194
            ]
          ],
          "id": "GB.DS",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-ds",
            "hc-a2": "DS",
            "labelrank": "9",
            "iso_3166_2": "GB-DOR",
            "hasc": "GB.DS",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Administrative County",
            "region": "South West",
            "woe-id": "12602183",
            "longitude": "-2.31103",
            "subregion": "Dorset",
            "woe-name": "Dorset",
            "fips": "UK12",
            "latitude": "50.8569",
            "woe-label": null,
            "postal-code": "DS",
            "type": "Administrative County",
            "name": "Dorset"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -246,
              252,
              -249
            ]
          ],
          "id": "GB.2391",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-2391",
            "hc-a2": "PO",
            "labelrank": "9",
            "iso_3166_2": "GB-POL",
            "hasc": "GB.BM",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "South West",
            "woe-id": "12696157",
            "longitude": "-1.96155",
            "subregion": "Dorset",
            "woe-name": "Poole Borough",
            "fips": "UK12",
            "latitude": "50.7427",
            "woe-label": null,
            "postal-code": null,
            "type": "Unitary Authority",
            "name": "Poole"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              253,
              254,
              255,
              256,
              257,
              258,
              -225,
              259,
              260,
              261
            ]
          ],
          "id": "GB.HT",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-ht",
            "hc-a2": "HT",
            "labelrank": "9",
            "iso_3166_2": "GB-HRT",
            "hasc": "GB.HT",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Administrative County",
            "region": "East",
            "woe-id": "12602170",
            "longitude": "-0.26543",
            "subregion": "Hertfordshire",
            "woe-name": "Hertfordshire",
            "fips": "UK21",
            "latitude": "51.8113",
            "woe-label": null,
            "postal-code": "HT",
            "type": "Administrative County",
            "name": "Hertfordshire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -254,
              262,
              263,
              264,
              265,
              266,
              267,
              268,
              269
            ]
          ],
          "id": "GB.CM",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-cm",
            "hc-a2": "CM",
            "labelrank": "9",
            "iso_3166_2": "GB-CAM",
            "hasc": "GB.CM",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Administrative County",
            "region": "East",
            "woe-id": "12602140",
            "longitude": "0.015806",
            "subregion": "Cambridgeshire",
            "woe-name": "Cambridgeshire",
            "fips": "UK05",
            "latitude": "52.3476",
            "woe-label": null,
            "postal-code": "CM",
            "type": "Administrative County",
            "name": "Cambridgeshire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              270,
              271
            ]
          ],
          "id": "GB.KH",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-kh",
            "hc-a2": "KH",
            "labelrank": "9",
            "iso_3166_2": "GB-KHL",
            "hasc": "GB.KH",
            "alt-name": "Hull",
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "Yorkshire and the Humber",
            "woe-id": "12696140",
            "longitude": "-0.372646",
            "subregion": "Kingston upon Hull",
            "woe-name": "Kingston upon Hull City",
            "fips": "UK22",
            "latitude": "53.7577",
            "woe-label": null,
            "postal-code": "KH",
            "type": "Unitary Authority",
            "name": "Kingston upon Hull"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              272,
              273,
              274
            ]
          ],
          "id": "GB.NE",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-ne",
            "hc-a2": "NE",
            "labelrank": "9",
            "iso_3166_2": "GB-NEL",
            "hasc": "GB.NE",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "Yorkshire and the Humber",
            "woe-id": "12696142",
            "longitude": "-0.130193",
            "subregion": "Kingston upon Hull",
            "woe-name": "North East Lincolnshire",
            "fips": "UK22",
            "latitude": "53.5168",
            "woe-label": null,
            "postal-code": "NE",
            "type": "Unitary Authority",
            "name": "North East Lincolnshire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              275,
              276,
              277,
              278,
              279
            ]
          ],
          "id": "GB.BA",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-ba",
            "hc-a2": "BA",
            "labelrank": "9",
            "iso_3166_2": "GB-BDG",
            "hasc": "GB.BA",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough",
            "region": "Greater London",
            "woe-id": "12695820",
            "longitude": "0.133951",
            "subregion": "Greater London",
            "woe-name": "London Borough of Barking and Dagenham",
            "fips": "UK17",
            "latitude": "51.5379",
            "woe-label": null,
            "postal-code": "BA",
            "type": "London Borough",
            "name": "Barking and Dagenham"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -276,
              280,
              281,
              282,
              283,
              284
            ]
          ],
          "id": "GB.XB",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-xb",
            "hc-a2": "XB",
            "labelrank": "9",
            "iso_3166_2": "GB-BEX",
            "hasc": "GB.XB",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough",
            "region": "Greater London",
            "woe-id": "12695822",
            "longitude": "0.152477",
            "subregion": "Greater London",
            "woe-name": "London Borough of Bexley",
            "fips": "UK17",
            "latitude": "51.4546",
            "woe-label": null,
            "postal-code": "XB",
            "type": "London Borough",
            "name": "Bexley"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                -283,
                285,
                286,
                287,
                288,
                289,
                290,
                291
              ]
            ],
            [
              [
                292
              ]
            ]
          ],
          "id": "GB.KE",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-ke",
            "hc-a2": "KE",
            "labelrank": "9",
            "iso_3166_2": "GB-KEN",
            "hasc": "GB.KE",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Administrative County",
            "region": "South East",
            "woe-id": "12602173",
            "longitude": "0.718915",
            "subregion": "Kent",
            "woe-name": "Kent",
            "fips": "UK24",
            "latitude": "51.1979",
            "woe-label": null,
            "postal-code": "KE",
            "type": "Administrative County",
            "name": "Kent"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -284,
              -292,
              293,
              294,
              295,
              296,
              297,
              298
            ]
          ],
          "id": "GB.BZ",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-bz",
            "hc-a2": "BZ",
            "labelrank": "9",
            "iso_3166_2": "GB-BRY",
            "hasc": "GB.BZ",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough",
            "region": "Greater London",
            "woe-id": "12695824",
            "longitude": "0.046372",
            "subregion": "Greater London",
            "woe-name": "London Borough of Bromley",
            "fips": "UK17",
            "latitude": "51.3652",
            "woe-label": null,
            "postal-code": "BZ",
            "type": "London Borough",
            "name": "Bromley"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              299,
              300,
              301,
              302,
              303,
              304
            ]
          ],
          "id": "GB.BE",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-be",
            "hc-a2": "BE",
            "labelrank": "9",
            "iso_3166_2": "GB-BEN",
            "hasc": "GB.BE",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough",
            "region": "Greater London",
            "woe-id": "12695823",
            "longitude": "-0.252266",
            "subregion": "Greater London",
            "woe-name": "London Borough of Brent",
            "fips": "UK17",
            "latitude": "51.5578",
            "woe-label": null,
            "postal-code": "BE",
            "type": "London Borough",
            "name": "Brent"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -300,
              305,
              306,
              307,
              308,
              309,
              310,
              311
            ]
          ],
          "id": "GB.CN",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-cn",
            "hc-a2": "CN",
            "labelrank": "9",
            "iso_3166_2": "GB-CMD",
            "hasc": "GB.CN",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough",
            "region": "Greater London",
            "woe-id": "12695807",
            "longitude": "-0.150541",
            "subregion": "Greater London",
            "woe-name": "London Borough of Camden",
            "fips": "UK17",
            "latitude": "51.5491",
            "woe-label": null,
            "postal-code": "CN",
            "type": "London Borough",
            "name": "Camden"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -303,
              312,
              313,
              314,
              315
            ]
          ],
          "id": "GB.EG",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-eg",
            "hc-a2": "EG",
            "labelrank": "9",
            "iso_3166_2": "GB-EAL",
            "hasc": "GB.EG",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough",
            "region": "Greater London",
            "woe-id": "12695826",
            "longitude": "-0.321254",
            "subregion": "Greater London",
            "woe-name": "London Borough of Ealing",
            "fips": "UK17",
            "latitude": "51.5198",
            "woe-label": null,
            "postal-code": "EG",
            "type": "London Borough",
            "name": "Ealing"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -256,
              316,
              317,
              318,
              319
            ]
          ],
          "id": "GB.EF",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-ef",
            "hc-a2": "EF",
            "labelrank": "9",
            "iso_3166_2": "GB-ENF",
            "hasc": "GB.EF",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough",
            "region": "Greater London",
            "woe-id": "12695827",
            "longitude": "-0.091145",
            "subregion": "Greater London",
            "woe-name": "London Borough of Enfield",
            "fips": "UK17",
            "latitude": "51.644",
            "woe-label": null,
            "postal-code": "EF",
            "type": "London Borough",
            "name": "Enfield"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -299,
              320,
              321,
              322,
              -277,
              -285
            ]
          ],
          "id": "GB.GR",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-gr",
            "hc-a2": "GR",
            "labelrank": "9",
            "iso_3166_2": "GB-GRE",
            "hasc": "GB.GR",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough (royal)",
            "region": "Greater London",
            "woe-id": "12695828",
            "longitude": "0.047328",
            "subregion": "Greater London",
            "woe-name": "London Borough of Greenwich",
            "fips": "UK17",
            "latitude": "51.4634",
            "woe-label": null,
            "postal-code": "GR",
            "type": "London Borough (royal)",
            "name": "Greenwich"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -313,
              -302,
              323,
              324,
              325,
              326
            ]
          ],
          "id": "GB.HF",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-hf",
            "hc-a2": "HF",
            "labelrank": "9",
            "iso_3166_2": "GB-HMF",
            "hasc": "GB.HF",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough",
            "region": "Greater London",
            "woe-id": "12695809",
            "longitude": "-0.20785",
            "subregion": "Greater London",
            "woe-name": "London Borough of Hammersmith and Fulham",
            "fips": "UK17",
            "latitude": "51.4894",
            "woe-label": null,
            "postal-code": "HF",
            "type": "London Borough",
            "name": "Hammersmith and Fulham"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -327,
              327,
              328,
              329,
              -314
            ]
          ],
          "id": "GB.HU",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-hu",
            "hc-a2": "HU",
            "labelrank": "9",
            "iso_3166_2": "GB-HNS",
            "hasc": "GB.HU",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough",
            "region": "Greater London",
            "woe-id": "12695832",
            "longitude": "-0.339069",
            "subregion": "Greater London",
            "woe-name": "London Borough of Hounslow",
            "fips": "UK17",
            "latitude": "51.473",
            "woe-label": null,
            "postal-code": "HU",
            "type": "London Borough",
            "name": "Hounslow"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -308,
              330,
              331,
              332
            ]
          ],
          "id": "GB.IT",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-it",
            "hc-a2": "IT",
            "labelrank": "9",
            "iso_3166_2": "GB-ISL",
            "hasc": "GB.IT",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough",
            "region": "Greater London",
            "woe-id": "12695811",
            "longitude": "-0.098038",
            "subregion": "Greater London",
            "woe-name": "London Borough of Islington",
            "fips": "UK17",
            "latitude": "51.5396",
            "woe-label": null,
            "postal-code": "IT",
            "type": "London Borough",
            "name": "Islington"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -324,
              333,
              334
            ]
          ],
          "id": "GB.KC",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-kc",
            "hc-a2": "KC",
            "labelrank": "9",
            "iso_3166_2": "GB-KEC",
            "hasc": "GB.KC",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough (royal)",
            "region": "Greater London",
            "woe-id": "12695812",
            "longitude": "-0.179557",
            "subregion": "Greater London",
            "woe-name": "Royal Borough of Kensington and Chelsea",
            "fips": "UK17",
            "latitude": "51.4919",
            "woe-label": null,
            "postal-code": "KC",
            "type": "London Borough (royal)",
            "name": "Kensington and Chelsea"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              335,
              336,
              -295,
              337,
              338
            ]
          ],
          "id": "GB.CY",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-cy",
            "hc-a2": "CY",
            "labelrank": "9",
            "iso_3166_2": "GB-CRY",
            "hasc": "GB.CY",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough",
            "region": "Greater London",
            "woe-id": "12695825",
            "longitude": "-0.075261",
            "subregion": "Greater London",
            "woe-name": "London Borough of Croydon",
            "fips": "UK17",
            "latitude": "51.3625",
            "woe-label": null,
            "postal-code": "CY",
            "type": "London Borough",
            "name": "Croydon"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -336,
              339,
              340,
              341,
              342
            ]
          ],
          "id": "GB.ME",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-me",
            "hc-a2": "ME",
            "labelrank": "9",
            "iso_3166_2": "GB-MRT",
            "hasc": "GB.ME",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough",
            "region": "Greater London",
            "woe-id": "12695834",
            "longitude": "-0.181508",
            "subregion": "Greater London",
            "woe-name": "London Borough of Merton",
            "fips": "UK17",
            "latitude": "51.4087",
            "woe-label": null,
            "postal-code": "ME",
            "type": "London Borough",
            "name": "Merton"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -279,
              343,
              344,
              345,
              346
            ]
          ],
          "id": "GB.RB",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-rb",
            "hc-a2": "RB",
            "labelrank": "9",
            "iso_3166_2": "GB-RDB",
            "hasc": "GB.RB",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough",
            "region": "Greater London",
            "woe-id": "12695835",
            "longitude": "0.085233",
            "subregion": "Greater London",
            "woe-name": "London Borough of Redbridge",
            "fips": "UK17",
            "latitude": "51.5732",
            "woe-label": null,
            "postal-code": "RB",
            "type": "London Borough",
            "name": "Redbridge"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -328,
              -326,
              347,
              348,
              349
            ]
          ],
          "id": "GB.RU",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-ru",
            "hc-a2": "RU",
            "labelrank": "9",
            "iso_3166_2": "GBRIC",
            "hasc": "GB.RU",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough",
            "region": "Greater London",
            "woe-id": "12695836",
            "longitude": "-0.298542",
            "subregion": "Greater London",
            "woe-name": "London Borough of Richmond upon Thames",
            "fips": "UK17",
            "latitude": "51.4072",
            "woe-label": null,
            "postal-code": "RU",
            "type": "London Borough",
            "name": "Richmond upon Thames"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -340,
              -339,
              350,
              351
            ]
          ],
          "id": "GB.SU",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-su",
            "hc-a2": "SU",
            "labelrank": "9",
            "iso_3166_2": "GB-STN",
            "hasc": "GB.SU",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough",
            "region": "Greater London",
            "woe-id": "12695837",
            "longitude": "-0.176573",
            "subregion": "Greater London",
            "woe-name": "London Borough of Sutton",
            "fips": "UK17",
            "latitude": "51.3606",
            "woe-label": null,
            "postal-code": "SU",
            "type": "London Borough",
            "name": "Sutton"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -322,
              352,
              353,
              354,
              355
            ]
          ],
          "id": "GB.TH",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-th",
            "hc-a2": "TH",
            "labelrank": "9",
            "iso_3166_2": "GB-TWH",
            "hasc": "GB.TH",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough",
            "region": "Greater London",
            "woe-id": "12695817",
            "longitude": "-0.026298",
            "subregion": "Greater London",
            "woe-name": "London Borough of Tower Hamlets",
            "fips": "UK17",
            "latitude": "51.5162",
            "woe-label": null,
            "postal-code": "TH",
            "type": "London Borough",
            "name": "Tower Hamlets"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -345,
              356,
              357,
              358,
              -318,
              359
            ]
          ],
          "id": "GB.WF",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-wf",
            "hc-a2": "WF",
            "labelrank": "9",
            "iso_3166_2": "GB-WFT",
            "hasc": "GB.WF",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough",
            "region": "Greater London",
            "woe-id": "12695838",
            "longitude": "-0.012552",
            "subregion": "Greater London",
            "woe-name": "London Borough of Waltham Forest",
            "fips": "UK17",
            "latitude": "51.5949",
            "woe-label": null,
            "postal-code": "WF",
            "type": "London Borough",
            "name": "Waltham Forest"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -342,
              -348,
              -325,
              -335,
              360,
              361
            ]
          ],
          "id": "GB.WW",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-ww",
            "hc-a2": "WW",
            "labelrank": "9",
            "iso_3166_2": "GB-WND",
            "hasc": "GB.WW",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough",
            "region": "Greater London",
            "woe-id": "12695818",
            "longitude": "-0.184208",
            "subregion": "Greater London",
            "woe-name": "London Borough of Wandsworth",
            "fips": "UK17",
            "latitude": "51.4523",
            "woe-label": null,
            "postal-code": "WW",
            "type": "London Borough",
            "name": "Wandsworth"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -361,
              -334,
              -301,
              -312,
              362
            ]
          ],
          "id": "GB.WE",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-we",
            "hc-a2": "WE",
            "labelrank": "9",
            "iso_3166_2": "GB-WSM",
            "hasc": "GB.WE",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough (city)",
            "region": "Greater London",
            "woe-id": "12695819",
            "longitude": "-0.161651",
            "subregion": "Greater London",
            "woe-name": "City of Westminster",
            "fips": "UK17",
            "latitude": "51.5115",
            "woe-label": null,
            "postal-code": "WE",
            "type": "London Borough (city)",
            "name": "Westminster"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -267,
              363,
              364,
              365,
              -366,
              366,
              -63,
              367,
              368,
              -274,
              369,
              370
            ]
          ],
          "id": "GB.LI",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-li",
            "hc-a2": "LI",
            "labelrank": "9",
            "iso_3166_2": "GB-LIN",
            "hasc": "GB.LI",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Administrative County",
            "region": "East Midlands",
            "woe-id": "12602145",
            "longitude": "-0.222474",
            "subregion": "Lincolnshire",
            "woe-name": "Lincolnshire",
            "fips": "UK32",
            "latitude": "53.1152",
            "woe-label": null,
            "postal-code": "LI",
            "type": "Administrative County",
            "name": "Lincolnshire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              424,
              425,
              426
            ]
          ],
          "id": "GB.PE",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-pe",
            "hc-a2": "PE",
            "labelrank": "9",
            "iso_3166_2": "GB-PEM",
            "hasc": "GB.PE",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority (wales",
            "region": "East Wales",
            "woe-id": "12602226",
            "longitude": "-4.90281",
            "subregion": "West Wales",
            "woe-name": "Pembrokeshire County",
            "fips": "UK91",
            "latitude": "51.6602",
            "woe-label": null,
            "postal-code": "PE",
            "type": "Unitary Authority (wales)",
            "name": "Pembrokeshire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -425,
              427,
              428,
              429,
              430
            ]
          ],
          "id": "GB.2301",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-2301",
            "hc-a2": "CE",
            "labelrank": "9",
            "iso_3166_2": "GB-CGN",
            "hasc": "GB.",
            "alt-name": "Cardiganshire",
            "country": "United Kingdom",
            "type-en": "Principality",
            "region": "East Wales",
            "woe-id": "12602217",
            "longitude": "-4.17527",
            "subregion": "Mid Wales",
            "woe-name": "Ceredigion County",
            "fips": "UK91",
            "latitude": "52.1793",
            "woe-label": null,
            "postal-code": null,
            "type": "Unitary Authority (wales",
            "name": "Ceredigion"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -429,
              431,
              432,
              433,
              434
            ]
          ],
          "id": "GB.GD",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-gd",
            "hc-a2": "GD",
            "labelrank": "9",
            "iso_3166_2": "GB-GWN",
            "hasc": "GB.GD",
            "alt-name": "Caernarfonshire and Merionethshire",
            "country": "United Kingdom",
            "type-en": "Unitary Authority (wales",
            "region": "East Wales",
            "woe-id": "12602221",
            "longitude": "-3.92029",
            "subregion": "North Wales",
            "woe-name": "Gwynedd",
            "fips": "UK93",
            "latitude": "52.8484",
            "woe-label": null,
            "postal-code": "GD",
            "type": "Unitary Authority (wales)",
            "name": "Gwynedd"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              435,
              436,
              437,
              438,
              439,
              440,
              441,
              442,
              443,
              444,
              445
            ]
          ],
          "id": "GB.SP",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-sp",
            "hc-a2": "SP",
            "labelrank": "9",
            "iso_3166_2": "GB-SHR",
            "hasc": "GB.SP",
            "alt-name": "Salop",
            "country": "United Kingdom",
            "type-en": "Unitary Single-Tier County",
            "region": "West Midlands",
            "woe-id": "12602188",
            "longitude": "-2.72133",
            "subregion": "Shropshire",
            "woe-name": "Shropshire",
            "fips": "UK35",
            "latitude": "52.6167",
            "woe-label": null,
            "postal-code": "SP",
            "type": "Unitary Single-Tier County",
            "name": "Shropshire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              446,
              -444,
              447,
              -207,
              448,
              449,
              450,
              451,
              452,
              453,
              -430,
              -435,
              454,
              455
            ]
          ],
          "id": "GB.PO",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-po",
            "hc-a2": "PO",
            "labelrank": "9",
            "iso_3166_2": "GB-POW",
            "hasc": "GB.PO",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority (wales",
            "region": "West Wales and the Valleys",
            "woe-id": "12602227",
            "longitude": "-3.4415",
            "subregion": "Mid Wales",
            "woe-name": "Powys County",
            "fips": "UK95",
            "latitude": "52.338",
            "woe-label": null,
            "postal-code": "PO",
            "type": "Unitary Authority (wales)",
            "name": "Powys"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -451,
              456,
              457
            ]
          ],
          "id": "GB.MT",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-mt",
            "hc-a2": "MT",
            "labelrank": "9",
            "iso_3166_2": "GB-MTY",
            "hasc": "GB.MT",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority (wales",
            "region": "East Wales",
            "woe-id": "12602222",
            "longitude": "-3.35678",
            "subregion": "South Wales",
            "woe-name": "Merthyr Tydfil County Borough",
            "fips": "UK94",
            "latitude": "51.7461",
            "woe-label": null,
            "postal-code": "MT",
            "type": "Unitary Authority (wales)",
            "name": "Merthyr Tydfil"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              458,
              459,
              460,
              461
            ]
          ],
          "id": "GB.BJ",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-bj",
            "hc-a2": "BJ",
            "labelrank": "9",
            "iso_3166_2": "GB-BGE",
            "hasc": "GB.BJ",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority (wales",
            "region": "East Wales",
            "woe-id": "12602213",
            "longitude": "-3.60687",
            "subregion": "South Wales",
            "woe-name": "Bridgend County Borough",
            "fips": "UK94",
            "latitude": "51.5414",
            "woe-label": null,
            "postal-code": "BJ",
            "type": "Unitary Authority (wales)",
            "name": "Bridgend"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -450,
              462,
              463,
              464,
              465,
              466,
              -457
            ]
          ],
          "id": "GB.CP",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-cp",
            "hc-a2": "CP",
            "labelrank": "9",
            "iso_3166_2": "GB-CAY",
            "hasc": "GB.CP",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority (wales",
            "region": "East Wales",
            "woe-id": "12602214",
            "longitude": "-3.18286",
            "subregion": "South Wales",
            "woe-name": "Caerphilly County Borough",
            "fips": "UK94",
            "latitude": "51.6407",
            "woe-label": null,
            "postal-code": "CP",
            "type": "Unitary Authority (wales)",
            "name": "Caerphilly"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -458,
              -467,
              467,
              468,
              -461,
              469,
              -452
            ]
          ],
          "id": "GB.RT",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-rt",
            "hc-a2": "RT",
            "labelrank": "9",
            "iso_3166_2": "GB-RCT",
            "hasc": "GB.RT",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority (wales",
            "region": "East Wales",
            "woe-id": "12602228",
            "longitude": "-3.40988",
            "subregion": "South Wales",
            "woe-name": "Rhondda Cynon Taff County Borough",
            "fips": "UK94",
            "latitude": "51.617",
            "woe-label": null,
            "postal-code": "RT",
            "type": "Unitary Authority (wales)",
            "name": "Rhondda, Cynon, Taff"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              470,
              471,
              -468,
              -466,
              472
            ]
          ],
          "id": "GB.CA",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-ca",
            "hc-a2": "CA",
            "labelrank": "9",
            "iso_3166_2": "GB-CRF",
            "hasc": "GB.CA",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority (wales",
            "region": "West Wales and the Valleys",
            "woe-id": "12602215",
            "longitude": "-3.1785",
            "subregion": "South Wales",
            "woe-name": "Cardiff County",
            "fips": "UK96",
            "latitude": "51.5049",
            "woe-label": null,
            "postal-code": "CA",
            "type": "Unitary Authority (wales)",
            "name": "Cardiff"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -472,
              473,
              -462,
              -469
            ]
          ],
          "id": "GB.VG",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-vg",
            "hc-a2": "VG",
            "labelrank": "9",
            "iso_3166_2": "GB-VGL",
            "hasc": "GB.VG",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority (wales",
            "region": "West Wales and the Valleys",
            "woe-id": "12602231",
            "longitude": "-3.36772",
            "subregion": "South Wales",
            "woe-name": "Vale of Glamorgan",
            "fips": "UK96",
            "latitude": "51.4474",
            "woe-label": null,
            "postal-code": "VG",
            "type": "Unitary Authority (wales)",
            "name": "Vale of Glamorgan"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -453,
              -470,
              -460,
              474,
              475,
              476
            ]
          ],
          "id": "GB.NP",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-np",
            "hc-a2": "NP",
            "labelrank": "9",
            "iso_3166_2": "GB-NTL",
            "hasc": "GB.NP",
            "alt-name": "Neath and Port Talbot",
            "country": "United Kingdom",
            "type-en": "Unitary Authority (wales",
            "region": "East Wales",
            "woe-id": "12602224",
            "longitude": "-3.73935",
            "subregion": "South Wales",
            "woe-name": "Neath and Port Talbot County Borough",
            "fips": "UK97",
            "latitude": "51.6459",
            "woe-label": null,
            "postal-code": "NP",
            "type": "Unitary Authority (wales)",
            "name": "Neath Port Talbot"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -476,
              477,
              478
            ]
          ],
          "id": "GB.SW",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-sw",
            "hc-a2": "SW",
            "labelrank": "9",
            "iso_3166_2": "GB-SWA",
            "hasc": "GB.SW",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority (wales",
            "region": "East Wales",
            "woe-id": "12602229",
            "longitude": "-4.06364",
            "subregion": "West Wales",
            "woe-name": "Swansea City and County",
            "fips": "UK97",
            "latitude": "51.6203",
            "woe-label": null,
            "postal-code": "SW",
            "type": "Unitary Authority (wales)",
            "name": "Swansea"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              479,
              480,
              481,
              482,
              483,
              484,
              485
            ]
          ],
          "id": "GB.7122",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7122",
            "hc-a2": "BO",
            "labelrank": "9",
            "iso_3166_2": "GB-BOL",
            "hasc": "GB.MN",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "North West",
            "woe-id": "-12602158",
            "longitude": "-2.42876",
            "subregion": "Greater Manchester",
            "woe-name": "Greater Manchester",
            "fips": "UK18",
            "latitude": "53.5887",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Bolton"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              486,
              487,
              488,
              489,
              490,
              -480
            ]
          ],
          "id": "GB.BW",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-bw",
            "hc-a2": "BW",
            "labelrank": "9",
            "iso_3166_2": "GB-BBD",
            "hasc": "GB.BW",
            "alt-name": "Blackburn, Blackburn and Darwen",
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "North West",
            "woe-id": "12696178",
            "longitude": "-2.44291",
            "subregion": "Lancashire",
            "woe-name": "Blackburn with Darwen",
            "fips": "UK25",
            "latitude": "53.705",
            "woe-label": null,
            "postal-code": "BW",
            "type": "Unitary Authority",
            "name": "Blackburn with Darwen"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -490,
              491,
              492,
              -485,
              -484,
              493,
              494,
              495,
              496,
              497,
              498,
              499,
              500,
              501,
              502,
              503,
              504
            ]
          ],
          "id": "GB.LA",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-la",
            "hc-a2": "LA",
            "labelrank": "9",
            "iso_3166_2": "GB-LAN",
            "hasc": "GB.LA",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Administrative County",
            "region": "North West",
            "woe-id": "12602160",
            "longitude": "-2.54458",
            "subregion": "Lancashire",
            "woe-name": "Lancashire",
            "fips": "UK25",
            "latitude": "53.8599",
            "woe-label": null,
            "postal-code": "LA",
            "type": "Administrative County",
            "name": "Lancashire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -272,
              505,
              506,
              507,
              508,
              509,
              510,
              511
            ]
          ],
          "id": "GB.EY",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-ey",
            "hc-a2": "EY",
            "labelrank": "9",
            "iso_3166_2": "GB-ERY",
            "hasc": "GB.EY",
            "alt-name": "East Riding, East Yorkshire",
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "Yorkshire and the Humber",
            "woe-id": "12602193",
            "longitude": "-0.480224",
            "subregion": "Kingston upon Hull",
            "woe-name": "East Riding of Yorkshire",
            "fips": "UK22",
            "latitude": "53.9047",
            "woe-label": null,
            "postal-code": "EY",
            "type": "Unitary Authority",
            "name": "East Riding of Yorkshire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -510,
              512
            ]
          ],
          "id": "GB.YK",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-yk",
            "hc-a2": "YK",
            "labelrank": "9",
            "iso_3166_2": "GB-YOR",
            "hasc": "GB.YK",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "Yorkshire and the Humber",
            "woe-id": "12696148",
            "longitude": "-1.07785",
            "subregion": "North Yorkshire",
            "woe-name": "York City",
            "fips": "UK30",
            "latitude": "53.9488",
            "woe-label": null,
            "postal-code": "YK",
            "type": "Unitary Authority",
            "name": "York"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -455,
              -434,
              513,
              514,
              515,
              516
            ]
          ],
          "id": "GB.DI",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-di",
            "hc-a2": "DI",
            "labelrank": "9",
            "iso_3166_2": "GB-DEN",
            "hasc": "GB.DI",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority (wales",
            "region": "East Wales",
            "woe-id": "12602219",
            "longitude": "-3.34024",
            "subregion": "North Wales",
            "woe-name": "Denbighshire County",
            "fips": "UK90",
            "latitude": "53.0665",
            "woe-label": null,
            "postal-code": "DI",
            "type": "Unitary Authority (wales)",
            "name": "Denbighshire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              517,
              518,
              519,
              -516
            ]
          ],
          "id": "GB.FL",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-fl",
            "hc-a2": "FL",
            "labelrank": "9",
            "iso_3166_2": "GB-FLN",
            "hasc": "GB.FL",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority (wales",
            "region": "West Wales and the Valleys",
            "woe-id": "12602220",
            "longitude": "-3.14709",
            "subregion": "North Wales",
            "woe-name": "Flintshire County",
            "fips": "UK90",
            "latitude": "53.1815",
            "woe-label": null,
            "postal-code": "FL",
            "type": "Unitary Authority (wales)",
            "name": "Flintshire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -517,
              -520,
              520,
              -436,
              -446,
              445,
              -456
            ]
          ],
          "id": "GB.WX",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-wx",
            "hc-a2": "WX",
            "labelrank": "9",
            "iso_3166_2": "GB-WRX",
            "hasc": "GB.WX",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority (wales",
            "region": "West Wales and the Valleys",
            "woe-id": "12602232",
            "longitude": "-3.0538",
            "subregion": "North Wales",
            "woe-name": "Wrexham County Borough",
            "fips": "UK90",
            "latitude": "53.017",
            "woe-label": null,
            "postal-code": "WX",
            "type": "Unitary Authority (wales)",
            "name": "Wrexham"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -463,
              -449,
              -206,
              521
            ]
          ],
          "id": "GB.BG",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-bg",
            "hc-a2": "BG",
            "labelrank": "9",
            "iso_3166_2": "GB-BGW",
            "hasc": "GB.BG",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority (wales",
            "region": "East Wales",
            "woe-id": "12602212",
            "longitude": "-3.1998",
            "subregion": "South Wales",
            "woe-name": "Blaenau Gwent County Borough",
            "fips": "UK92",
            "latitude": "51.7719",
            "woe-label": null,
            "postal-code": "BG",
            "type": "Unitary Authority (wales)",
            "name": "Blaenau Gwent"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              522,
              -473,
              -465,
              523,
              -204
            ]
          ],
          "id": "GB.NO",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-no",
            "hc-a2": "NO",
            "labelrank": "9",
            "iso_3166_2": "GB-NWP",
            "hasc": "GB.NO",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority (wales",
            "region": "West Wales and the Valleys",
            "woe-id": "12602225",
            "longitude": "-2.94989",
            "subregion": "South Wales",
            "woe-name": "Newport City",
            "fips": "UK92",
            "latitude": "51.5866",
            "woe-label": null,
            "postal-code": "NO",
            "type": "Unitary Authority (wales)",
            "name": "Newport"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -524,
              -464,
              -522,
              -205
            ]
          ],
          "id": "GB.TF",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-tf",
            "hc-a2": "TF",
            "labelrank": "9",
            "iso_3166_2": "GB-TOF",
            "hasc": "GB.TF",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority (wales",
            "region": "East Wales",
            "woe-id": "12602230",
            "longitude": "-3.0449",
            "subregion": "South Wales",
            "woe-name": "Torfaen County Borough",
            "fips": "UK92",
            "latitude": "51.6945",
            "woe-label": null,
            "postal-code": "TF",
            "type": "Unitary Authority (wales)",
            "name": "Torfaen"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -189,
              -184,
              -188,
              531,
              -511,
              -513,
              -509,
              532,
              533,
              534,
              535,
              536,
              -502,
              537,
              -173,
              -179
            ]
          ],
          "id": "GB.NY",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-ny",
            "hc-a2": "NY",
            "labelrank": "9",
            "iso_3166_2": "GB-NYK",
            "hasc": "GB.NY",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Administrative County",
            "region": "Yorkshire and the Humber",
            "woe-id": "12602195",
            "longitude": "-1.37567",
            "subregion": "North Yorkshire",
            "woe-name": "North Yorkshire",
            "fips": "UK30",
            "latitude": "54.2158",
            "woe-label": null,
            "postal-code": "NY",
            "type": "Administrative County",
            "name": "North Yorkshire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              538,
              -98
            ]
          ],
          "id": "GB.2420",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-2420",
            "hc-a2": "PL",
            "labelrank": "9",
            "iso_3166_2": "GB-PLY",
            "hasc": "GB.DO",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "South West",
            "woe-id": "12696173",
            "longitude": "-4.11254",
            "subregion": "Devon",
            "woe-name": "Plymouth City",
            "fips": "UK08",
            "latitude": "50.3951",
            "woe-label": null,
            "postal-code": null,
            "type": "Unitary Authority",
            "name": "Plymouth"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              539,
              -96
            ]
          ],
          "id": "GB.TB",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-tb",
            "hc-a2": "TB",
            "labelrank": "9",
            "iso_3166_2": "GB-TOB",
            "hasc": "GB.TB",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "South West",
            "woe-id": "12696174",
            "longitude": "-3.56802",
            "subregion": "Devon",
            "woe-name": "Torbay Borough",
            "fips": "UK11",
            "latitude": "50.4496",
            "woe-label": null,
            "postal-code": "TB",
            "type": "Unitary Authority",
            "name": "Torbay"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              540,
              541,
              542,
              -346,
              -360,
              -317,
              -255,
              -270,
              543,
              544,
              545
            ]
          ],
          "id": "GB.EX",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-ex",
            "hc-a2": "EX",
            "labelrank": "9",
            "iso_3166_2": "GB-ESS",
            "hasc": "GB.EX",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Administrative County",
            "region": "East",
            "woe-id": "12602168",
            "longitude": "0.495656",
            "subregion": "Essex",
            "woe-name": "Essex",
            "fips": "UK15",
            "latitude": "51.7709",
            "woe-label": null,
            "postal-code": "EX",
            "type": "Administrative County",
            "name": "Essex"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -371,
              546,
              547,
              -268
            ]
          ],
          "id": "GB.NF",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-nf",
            "hc-a2": "NF",
            "labelrank": "9",
            "iso_3166_2": "GB-NFK",
            "hasc": "GB.NF",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Administrative County",
            "region": "East",
            "woe-id": "12602141",
            "longitude": "0.953164",
            "subregion": "Norfolk",
            "woe-name": "Norfolk",
            "fips": "UK29",
            "latitude": "52.6602",
            "woe-label": null,
            "postal-code": "NF",
            "type": "Administrative County",
            "name": "Norfolk"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              548,
              549,
              550
            ]
          ],
          "id": "GB.BH",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-bh",
            "hc-a2": "BH",
            "labelrank": "9",
            "iso_3166_2": "GB-BNH",
            "hasc": "GB.BH",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "South East",
            "woe-id": "12696151",
            "longitude": "-0.1065",
            "subregion": "East Sussex",
            "woe-name": "Brighton and Hove City",
            "fips": "UK44",
            "latitude": "50.8421",
            "woe-label": null,
            "postal-code": "BH",
            "type": "Unitary Authority",
            "name": "Brighton and Hove"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -281,
              -280,
              -347,
              -543,
              551
            ]
          ],
          "id": "GB.HV",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-hv",
            "hc-a2": "HV",
            "labelrank": "9",
            "iso_3166_2": "GB-HAV",
            "hasc": "GB.HV",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough",
            "region": "Greater London",
            "woe-id": "12695830",
            "longitude": "0.24211",
            "subregion": "Greater London",
            "woe-name": "London Borough of Havering",
            "fips": "UK15",
            "latitude": "51.5634",
            "woe-label": null,
            "postal-code": "HV",
            "type": "London Borough",
            "name": "Havering"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -282,
              -552,
              -542,
              552,
              -286
            ]
          ],
          "id": "GB.TR",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-tr",
            "hc-a2": "TR",
            "labelrank": "9",
            "iso_3166_2": "GB-THR",
            "hasc": "GB.TR",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "East",
            "woe-id": "12696176",
            "longitude": "0.381907",
            "subregion": "Essex",
            "woe-name": "Thurrock",
            "fips": "UK15",
            "latitude": "51.503",
            "woe-label": null,
            "postal-code": "TR",
            "type": "Unitary Authority",
            "name": "Thurrock"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              553,
              -546
            ]
          ],
          "id": "GB.SS",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-ss",
            "hc-a2": "SS",
            "labelrank": "9",
            "iso_3166_2": "GB-SOS",
            "hasc": "GB.SS",
            "alt-name": "Southend",
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "East",
            "woe-id": "12696175",
            "longitude": "0.73146",
            "subregion": "Essex",
            "woe-name": "Southend-on-Sea Borough",
            "fips": "UK24",
            "latitude": "51.5498",
            "woe-label": null,
            "postal-code": "SS",
            "type": "Unitary Authority",
            "name": "Southend-on-Sea"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -550,
              554,
              -200,
              555,
              556
            ]
          ],
          "id": "GB.WS",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-ws",
            "hc-a2": "WS",
            "labelrank": "9",
            "iso_3166_2": "GB-WSX",
            "hasc": "GB.WS",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Administrative County",
            "region": "South East",
            "woe-id": "12602177",
            "longitude": "-0.457938",
            "subregion": "West Sussex",
            "woe-name": "West Sussex",
            "fips": "UK44",
            "latitude": "50.9489",
            "woe-label": null,
            "postal-code": "WS",
            "type": "Administrative County",
            "name": "West Sussex"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -214,
              557,
              558,
              559,
              560,
              561,
              562,
              563,
              -66,
              564,
              565
            ]
          ],
          "id": "GB.WR",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-wr",
            "hc-a2": "WR",
            "labelrank": "9",
            "iso_3166_2": "GB-WAR",
            "hasc": "GB.WR",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Administrative County",
            "region": "West Midlands",
            "woe-id": "12602190",
            "longitude": "-1.55487",
            "subregion": "Warwickshire",
            "woe-name": "Warwickshire",
            "fips": "UK42",
            "latitude": "52.168",
            "woe-label": null,
            "postal-code": "WR",
            "type": "Administrative County",
            "name": "Warwickshire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -315,
              -330,
              566,
              -226,
              -259,
              567
            ]
          ],
          "id": "GB.HD",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-hd",
            "hc-a2": "HD",
            "labelrank": "9",
            "iso_3166_2": "GB-HIL",
            "hasc": "GB.HD",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough",
            "region": "Greater London",
            "woe-id": "12695831",
            "longitude": "-0.4325",
            "subregion": "Greater London",
            "woe-name": "London Borough of Hillingdon",
            "fips": "UK40",
            "latitude": "51.5338",
            "woe-label": null,
            "postal-code": "HD",
            "type": "London Borough",
            "name": "Hillingdon"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -341,
              -352,
              568,
              -349
            ]
          ],
          "id": "GB.KT",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-kt",
            "hc-a2": "KT",
            "labelrank": "9",
            "iso_3166_2": "GB-KTT",
            "hasc": "GB.KT",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough (royal)",
            "region": "Greater London",
            "woe-id": "12695833",
            "longitude": "-0.2699",
            "subregion": "Greater London",
            "woe-name": "Royal Borough of Kingston upon Thames",
            "fips": "UK40",
            "latitude": "51.3925",
            "woe-label": null,
            "postal-code": "KT",
            "type": "London Borough (royal)",
            "name": "Kingston upon Thames"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -329,
              -350,
              -569,
              -351,
              -338,
              -294,
              -291,
              569,
              -556,
              -199,
              570,
              571,
              572,
              -227,
              -567
            ]
          ],
          "id": "GB.SR",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-sr",
            "hc-a2": "SR",
            "labelrank": "9",
            "iso_3166_2": "GB-SRY",
            "hasc": "GB.SR",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Administrative County",
            "region": "South East",
            "woe-id": "12602176",
            "longitude": "-0.388084",
            "subregion": "Surrey",
            "woe-name": "Surrey",
            "fips": "UK40",
            "latitude": "51.2608",
            "woe-label": null,
            "postal-code": "SR",
            "type": "Administrative County",
            "name": "Surrey"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -570,
              -290,
              573,
              -551,
              -557
            ]
          ],
          "id": "GB.ES",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-es",
            "hc-a2": "ES",
            "labelrank": "9",
            "iso_3166_2": "GB-ESX",
            "hasc": "GB.ES",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Administrative County",
            "region": "South East",
            "woe-id": "12602167",
            "longitude": "0.372063",
            "subregion": "East Sussex",
            "woe-name": "East Sussex",
            "fips": "UK14",
            "latitude": "50.9537",
            "woe-label": null,
            "postal-code": "ES",
            "type": "Administrative County",
            "name": "East Sussex"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              574,
              -215,
              -566,
              575,
              -231,
              576,
              577,
              578
            ]
          ],
          "id": "GB.OX",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-ox",
            "hc-a2": "OX",
            "labelrank": "9",
            "iso_3166_2": "GB-OXF",
            "hasc": "GB.OX",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Administrative County",
            "region": "South East",
            "woe-id": "12602175",
            "longitude": "-1.29123",
            "subregion": "Oxfordshire",
            "woe-name": "Oxfordshire",
            "fips": "UK34",
            "latitude": "51.7912",
            "woe-label": null,
            "postal-code": "OX",
            "type": "Administrative County",
            "name": "Oxfordshire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -575,
              579,
              580,
              -216
            ]
          ],
          "id": "GB.SN",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-sn",
            "hc-a2": "SN",
            "labelrank": "9",
            "iso_3166_2": "GB-SWD",
            "hasc": "GB.SN",
            "alt-name": "Thamesdown",
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "South West",
            "woe-id": "12696162",
            "longitude": "-1.71017",
            "subregion": "Wiltshire",
            "woe-name": "Swindon Borough",
            "fips": "UK46",
            "latitude": "51.567",
            "woe-label": null,
            "postal-code": "SN",
            "type": "Unitary Authority",
            "name": "Swindon"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -366,
              581,
              -265,
              582,
              -221,
              -232,
              -576,
              -565,
              -65,
              583
            ]
          ],
          "id": "GB.NA",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-na",
            "hc-a2": "NA",
            "labelrank": "9",
            "iso_3166_2": "GB-NTH",
            "hasc": "GB.NA",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Administrative County",
            "region": "East Midlands",
            "woe-id": "12602146",
            "longitude": "-0.882413",
            "subregion": "Northamptonshire",
            "woe-name": "Northamptonshire",
            "fips": "UK31",
            "latitude": "52.3083",
            "woe-label": null,
            "postal-code": "NA",
            "type": "Administrative County",
            "name": "Northamptonshire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              365,
              -584,
              -64,
              -367
            ]
          ],
          "id": "GB.RL",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-rl",
            "hc-a2": "RL",
            "labelrank": "9",
            "iso_3166_2": "GB-RUD",
            "hasc": "GB.RL",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "East Midlands",
            "woe-id": "12696159",
            "longitude": "-0.610216",
            "subregion": "Rutland",
            "woe-name": "Rutland County",
            "fips": "UK26",
            "latitude": "52.657",
            "woe-label": null,
            "postal-code": "RL",
            "type": "Unitary Authority",
            "name": "Rutland"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -355,
              584,
              -332,
              585,
              -358,
              586
            ]
          ],
          "id": "GB.HK",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-hk",
            "hc-a2": "HK",
            "labelrank": "9",
            "iso_3166_2": "GB-HCK",
            "hasc": "GB.HK",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough",
            "region": "Greater London",
            "woe-id": "12695808",
            "longitude": "-0.052343",
            "subregion": "Greater London",
            "woe-name": "London Borough of Hackney",
            "fips": "UK17",
            "latitude": "51.5523",
            "woe-label": null,
            "postal-code": "HK",
            "type": "London Borough",
            "name": "Hackney"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -359,
              -586,
              -331,
              -307,
              587,
              -319
            ]
          ],
          "id": "GB.HY",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-hy",
            "hc-a2": "HY",
            "labelrank": "9",
            "iso_3166_2": "GB-HRY",
            "hasc": "GB.HY",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough",
            "region": "Greater London",
            "woe-id": "12695810",
            "longitude": "-0.096332",
            "subregion": "Greater London",
            "woe-name": "London Borough of Haringey",
            "fips": "UK17",
            "latitude": "51.5834",
            "woe-label": null,
            "postal-code": "HY",
            "type": "London Borough",
            "name": "Haringey"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -304,
              -316,
              -568,
              -258,
              588
            ]
          ],
          "id": "GB.HR",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-hr",
            "hc-a2": "HR",
            "labelrank": "9",
            "iso_3166_2": "GB-HRW",
            "hasc": "GB.HR",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough",
            "region": "Greater London",
            "woe-id": "12695829",
            "longitude": "-0.333295",
            "subregion": "Greater London",
            "woe-name": "London Borough of Harrow",
            "fips": "UK17",
            "latitude": "51.5894",
            "woe-label": null,
            "postal-code": "HR",
            "type": "London Borough",
            "name": "Harrow"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -296,
              -337,
              -343,
              -362,
              -363,
              -311,
              589
            ]
          ],
          "id": "GB.LT",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-lt",
            "hc-a2": "LT",
            "labelrank": "9",
            "iso_3166_2": "GB-LBH",
            "hasc": "GB.LT",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough",
            "region": "Greater London",
            "woe-id": "12695813",
            "longitude": "-0.10867",
            "subregion": "Greater London",
            "woe-name": "London Borough of Lambeth",
            "fips": "UK17",
            "latitude": "51.4604",
            "woe-label": null,
            "postal-code": "LT",
            "type": "London Borough",
            "name": "Lambeth"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -321,
              -298,
              590
            ]
          ],
          "id": "GB.LW",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-lw",
            "hc-a2": "LW",
            "labelrank": "9",
            "iso_3166_2": "GB-LEW",
            "hasc": "GB.LW",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough",
            "region": "Greater London",
            "woe-id": "12695814",
            "longitude": "-0.011286",
            "subregion": "Greater London",
            "woe-name": "London Borough of Lewisham",
            "fips": "UK17",
            "latitude": "51.4418",
            "woe-label": null,
            "postal-code": "LW",
            "type": "London Borough",
            "name": "Lewisham"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -278,
              -323,
              -356,
              -587,
              -357,
              -344
            ]
          ],
          "id": "GB.NH",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-nh",
            "hc-a2": "NH",
            "labelrank": "9",
            "iso_3166_2": "GB-NWM",
            "hasc": "GB.NH",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough",
            "region": "Greater London",
            "woe-id": "12695815",
            "longitude": "0.044254",
            "subregion": "Greater London",
            "woe-name": "London Borough of Newham",
            "fips": "UK17",
            "latitude": "51.5273",
            "woe-label": null,
            "postal-code": "NH",
            "type": "London Borough",
            "name": "Newham"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -353,
              -591,
              -297,
              -590,
              -310,
              591
            ]
          ],
          "id": "GB.SQ",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-sq",
            "hc-a2": "SQ",
            "labelrank": "9",
            "iso_3166_2": "GB-SWK",
            "hasc": "GB.SQ",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough",
            "region": "Greater London",
            "woe-id": "12695816",
            "longitude": "-0.06552",
            "subregion": "Greater London",
            "woe-name": "London Borough of Southwark",
            "fips": "UK17",
            "latitude": "51.466",
            "woe-label": null,
            "postal-code": "SQ",
            "type": "London Borough",
            "name": "Southwark"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -209,
              -208,
              -448,
              -443,
              592,
              -212
            ]
          ],
          "id": "GB.HE",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-he",
            "hc-a2": "HE",
            "labelrank": "9",
            "iso_3166_2": "GB-HEF",
            "hasc": "GB.HE",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "West Midlands",
            "woe-id": "12602187",
            "longitude": "-2.73691",
            "subregion": "Herefordshire",
            "woe-name": "Herefordshire",
            "fips": "UK20",
            "latitude": "52.0807",
            "woe-label": null,
            "postal-code": "HE",
            "type": "Unitary Authority",
            "name": "Herefordshire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -67,
              -564,
              593,
              594,
              595,
              596,
              597,
              -441,
              598,
              -439,
              599,
              600,
              601,
              -68
            ]
          ],
          "id": "GB.ST",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-st",
            "hc-a2": "ST",
            "labelrank": "9",
            "iso_3166_2": "GB-STS",
            "hasc": "GB.ST",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Administrative County",
            "region": "West Midlands",
            "woe-id": "12602189",
            "longitude": "-2.01517",
            "subregion": "Staffordshire",
            "woe-name": "Staffordshire",
            "fips": "UK38",
            "latitude": "52.9024",
            "woe-label": null,
            "postal-code": "ST",
            "type": "Administrative County",
            "name": "Staffordshire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -598,
              602,
              603,
              -558,
              -213,
              -593,
              -442
            ]
          ],
          "id": "GB.WC",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-wc",
            "hc-a2": "WC",
            "labelrank": "9",
            "iso_3166_2": "GB-WOR",
            "hasc": "GB.WC",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Administrative County",
            "region": "West Midlands",
            "woe-id": "12602192",
            "longitude": "-2.2004",
            "subregion": "Worcestershire",
            "woe-name": "Worcestershire",
            "fips": "UK20",
            "latitude": "52.21",
            "woe-label": null,
            "postal-code": "WC",
            "type": "Administrative County",
            "name": "Worcestershire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -599,
              -440
            ]
          ],
          "id": "GB.TK",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-tk",
            "hc-a2": "TK",
            "labelrank": "9",
            "iso_3166_2": "GB-TFW",
            "hasc": "GB.TK",
            "alt-name": "The Wrekin, Wrekin",
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "West Midlands",
            "woe-id": "12696181",
            "longitude": "-2.49356",
            "subregion": "Shropshire",
            "woe-name": "Telford and Wrekin Borough",
            "fips": "UK35",
            "latitude": "52.7152",
            "woe-label": null,
            "postal-code": "TK",
            "type": "Unitary Authority",
            "name": "Telford and Wrekin"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -354,
              -592,
              -309,
              -333,
              -585
            ]
          ],
          "id": "GB.6338",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-6338",
            "hc-a2": "CI",
            "labelrank": "9",
            "iso_3166_2": "GB-LND",
            "hasc": "GB.IT",
            "alt-name": "The City|City of London|Square Mile",
            "country": "United Kingdom",
            "type-en": "City Corporation",
            "region": "Greater London",
            "woe-id": "12695806",
            "longitude": "-0.08681",
            "subregion": "City of London",
            "woe-name": "City of London",
            "fips": null,
            "latitude": "51.5169",
            "woe-label": null,
            "postal-code": null,
            "type": "City Corporation",
            "name": "City"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              604,
              605,
              -175,
              606,
              -166,
              607,
              608
            ]
          ],
          "id": "GB.NB",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-nb",
            "hc-a2": "NB",
            "labelrank": "9",
            "iso_3166_2": "GB-NBL",
            "hasc": "GB.NB",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Single-Tier County",
            "region": "North East",
            "woe-id": "12602153",
            "longitude": "-2.07057",
            "subregion": "Northumberland",
            "woe-name": "Northumberland",
            "fips": "UK32",
            "latitude": "55.3152",
            "woe-label": null,
            "postal-code": "NB",
            "type": "Unitary Single-Tier County",
            "name": "Northumberland"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -605,
              609,
              610,
              611
            ]
          ],
          "id": "GB.2367",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-2367",
            "hc-a2": "NU",
            "labelrank": "9",
            "iso_3166_2": "GB-NET",
            "hasc": "GB.TW",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "North East",
            "woe-id": "-12602156",
            "longitude": "-1.5994",
            "subregion": "Tyne and Wear",
            "woe-name": "Tyne and Wear",
            "fips": "UK41",
            "latitude": "54.9931",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Newcastle upon Tyne"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -610,
              -609,
              612,
              613
            ]
          ],
          "id": "GB.7113",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7113",
            "hc-a2": "NT",
            "labelrank": "9",
            "iso_3166_2": "GB-NTY",
            "hasc": "GB.TW",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "North East",
            "woe-id": "-12602156",
            "longitude": "-1.48264",
            "subregion": "Tyne and Wear",
            "woe-name": "Tyne and Wear",
            "fips": "UK41",
            "latitude": "55.0184",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "North Tyneside"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -611,
              -614,
              614,
              615,
              616
            ]
          ],
          "id": "GB.7114",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7114",
            "hc-a2": "ST",
            "labelrank": "9",
            "iso_3166_2": "GB-STY",
            "hasc": "GB.TW",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "North East",
            "woe-id": "-12602156",
            "longitude": "-1.44209",
            "subregion": "Tyne and Wear",
            "woe-name": "Tyne and Wear",
            "fips": "UK41",
            "latitude": "54.9526",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "South Tyneside"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              617,
              -177,
              618,
              -616
            ]
          ],
          "id": "GB.7115",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7115",
            "hc-a2": "SU",
            "labelrank": "9",
            "iso_3166_2": "GB-SND",
            "hasc": "GB.TW",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "North East",
            "woe-id": "-12602156",
            "longitude": "-1.46175",
            "subregion": "Tyne and Wear",
            "woe-name": "Tyne and Wear",
            "fips": "UK41",
            "latitude": "54.8617",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Sunderland"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -612,
              -617,
              -619,
              -176,
              -606
            ]
          ],
          "id": "GB.7116",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7116",
            "hc-a2": "GA",
            "labelrank": "9",
            "iso_3166_2": "GB-GAT",
            "hasc": "GB.TW",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "North East",
            "woe-id": "-12602156",
            "longitude": "-1.66816",
            "subregion": "Tyne and Wear",
            "woe-name": "Tyne and Wear",
            "fips": "UK41",
            "latitude": "54.9391",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Gateshead"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              619,
              620,
              621,
              -496,
              622,
              623
            ]
          ],
          "id": "GB.2364",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-2364",
            "hc-a2": "KN",
            "labelrank": "9",
            "iso_3166_2": "GB-KWL",
            "hasc": "GB.MS",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "North West",
            "woe-id": "-12602161",
            "longitude": "-2.83419",
            "subregion": "Merseyside",
            "woe-name": "Merseyside",
            "fips": "UK28",
            "latitude": "53.4145",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Knowsley"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -622,
              624,
              625,
              -497
            ]
          ],
          "id": "GB.7118",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7118",
            "hc-a2": "SE",
            "labelrank": "9",
            "iso_3166_2": "GB-SFT",
            "hasc": "GB.MS",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "North West",
            "woe-id": "-12602161",
            "longitude": "-3.05568",
            "subregion": "Merseyside",
            "woe-name": "Merseyside",
            "fips": "UK28",
            "latitude": "53.5647",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Sefton"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              626,
              -625,
              -621
            ]
          ],
          "id": "GB.7119",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7119",
            "hc-a2": "LI",
            "labelrank": "9",
            "iso_3166_2": "GB-LIV",
            "hasc": "GB.MS",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "North West",
            "woe-id": "-12602161",
            "longitude": "-2.9327",
            "subregion": "Merseyside",
            "woe-name": "Merseyside",
            "fips": "UK28",
            "latitude": "53.4312",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Liverpool"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              627,
              628,
              629,
              630,
              631,
              632,
              633
            ]
          ],
          "id": "GB.WT",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-wt",
            "hc-a2": "WT",
            "labelrank": "9",
            "iso_3166_2": "GB-WRT",
            "hasc": "GB.WT",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "North West",
            "woe-id": "12696172",
            "longitude": "-2.55468",
            "subregion": "Cheshire",
            "woe-name": "Warrington Borough",
            "fips": "UK06",
            "latitude": "53.3766",
            "woe-label": null,
            "postal-code": "WT",
            "type": "Unitary Authority",
            "name": "Warrington"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -628,
              634,
              -623,
              -495,
              635
            ]
          ],
          "id": "GB.MS",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-ms",
            "hc-a2": "MS",
            "labelrank": "9",
            "iso_3166_2": "GB-",
            "hasc": "GB.MS",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "North West",
            "woe-id": "12602161",
            "longitude": "-2.73472",
            "subregion": "Merseyside",
            "woe-name": "Merseyside",
            "fips": "UK28",
            "latitude": "53.4417",
            "woe-label": null,
            "postal-code": "MS",
            "type": "Metropolitan Borough",
            "name": "Merseyside"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              636,
              -499
            ]
          ],
          "id": "GB.7117",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7117",
            "hc-a2": "BL",
            "labelrank": "9",
            "iso_3166_2": "GB-BPL",
            "hasc": "GB.LA",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "North West",
            "woe-id": "-12602160",
            "longitude": "-3.00469",
            "subregion": "Lancashire",
            "woe-name": "Lancashire",
            "fips": "UK25",
            "latitude": "53.8406",
            "woe-label": null,
            "postal-code": null,
            "type": "Unitary Authority",
            "name": "Blackpool"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -73,
              637,
              638,
              639,
              640,
              641,
              642,
              643
            ]
          ],
          "id": "GB.3265",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-3265",
            "hc-a2": "KI",
            "labelrank": "9",
            "iso_3166_2": "GB-KIR",
            "hasc": "GB.WY",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "Yorkshire and the Humber",
            "woe-id": "-12602197",
            "longitude": "-1.73944",
            "subregion": "West Yorkshire",
            "woe-name": "West Yorkshire",
            "fips": "UK45",
            "latitude": "53.6218",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Kirklees"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -640,
              644,
              -503,
              -537,
              645
            ]
          ],
          "id": "GB.7130",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7130",
            "hc-a2": "CA",
            "labelrank": "9",
            "iso_3166_2": "GB-CLD",
            "hasc": "GB.WY",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "Yorkshire and the Humber",
            "woe-id": "-12602197",
            "longitude": "-1.95182",
            "subregion": "West Yorkshire",
            "woe-name": "West Yorkshire",
            "fips": "UK45",
            "latitude": "53.7446",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Calderdale"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -646,
              -536,
              646,
              -641
            ]
          ],
          "id": "GB.7131",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7131",
            "hc-a2": "BR",
            "labelrank": "9",
            "iso_3166_2": "GB-BRD",
            "hasc": "GB.WY",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "Yorkshire and the Humber",
            "woe-id": "-12602197",
            "longitude": "-1.78384",
            "subregion": "West Yorkshire",
            "woe-name": "West Yorkshire",
            "fips": "UK45",
            "latitude": "53.8466",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Bradford"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -642,
              -647,
              -535,
              647
            ]
          ],
          "id": "GB.7132",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7132",
            "hc-a2": "LE",
            "labelrank": "9",
            "iso_3166_2": "GB-LDS",
            "hasc": "GB.WY",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "Yorkshire and the Humber",
            "woe-id": "-12602197",
            "longitude": "-1.47788",
            "subregion": "West Yorkshire",
            "woe-name": "West Yorkshire",
            "fips": "UK45",
            "latitude": "53.8106",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Leeds"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -643,
              -648,
              -534,
              648,
              649
            ]
          ],
          "id": "GB.7133",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7133",
            "hc-a2": "WA",
            "labelrank": "9",
            "iso_3166_2": "GB-WKF",
            "hasc": "GB.WY",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "Yorkshire and the Humber",
            "woe-id": "-12602197",
            "longitude": "-1.39089",
            "subregion": "West Yorkshire",
            "woe-name": "West Yorkshire",
            "fips": "UK45",
            "latitude": "53.6457",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Wakefield"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -630,
              650,
              -482,
              651,
              652,
              653
            ]
          ],
          "id": "GB.3266",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-3266",
            "hc-a2": "SA",
            "labelrank": "9",
            "iso_3166_2": "GB-SLF",
            "hasc": "GB.MN",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "North West",
            "woe-id": "-12602158",
            "longitude": "-2.40861",
            "subregion": "Greater Manchester",
            "woe-name": "Greater Manchester",
            "fips": "UK18",
            "latitude": "53.5006",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Salford"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -651,
              -629,
              -636,
              -494,
              -483
            ]
          ],
          "id": "GB.7121",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7121",
            "hc-a2": "WI",
            "labelrank": "9",
            "iso_3166_2": "GB-WGN",
            "hasc": "GB.MN",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "North West",
            "woe-id": "-12602158",
            "longitude": "-2.60574",
            "subregion": "Merseyside",
            "woe-name": "Greater Manchester",
            "fips": "UK18",
            "latitude": "53.5317",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Wigan"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -652,
              -481,
              -491,
              -505,
              654,
              655
            ]
          ],
          "id": "GB.7123",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7123",
            "hc-a2": "BU",
            "labelrank": "9",
            "iso_3166_2": "GB-BUR",
            "hasc": "GB.MN",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "North West",
            "woe-id": "-12602158",
            "longitude": "-2.30878",
            "subregion": "Greater Manchester",
            "woe-name": "Greater Manchester",
            "fips": "UK18",
            "latitude": "53.5827",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Bury"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -639,
              656,
              657,
              -655,
              -504,
              -645
            ]
          ],
          "id": "GB.7124",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7124",
            "hc-a2": "RO",
            "labelrank": "9",
            "iso_3166_2": "GB-RCH",
            "hasc": "GB.MN",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "North West",
            "woe-id": "-12602158",
            "longitude": "-2.1438",
            "subregion": "Greater Manchester",
            "woe-name": "Greater Manchester",
            "fips": "UK18",
            "latitude": "53.6277",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Rochdale"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -72,
              658,
              659,
              -657,
              -638
            ]
          ],
          "id": "GB.7125",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7125",
            "hc-a2": "OL",
            "labelrank": "9",
            "iso_3166_2": "GB-OLD",
            "hasc": "GB.MN",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "North West",
            "woe-id": "-12602158",
            "longitude": "-2.03581",
            "subregion": "Greater Manchester",
            "woe-name": "Greater Manchester",
            "fips": "UK18",
            "latitude": "53.5527",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Oldham"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -659,
              -71,
              660,
              661
            ]
          ],
          "id": "GB.7126",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7126",
            "hc-a2": "TA",
            "labelrank": "9",
            "iso_3166_2": "GB-TAM",
            "hasc": "GB.MN",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "North West",
            "woe-id": "-12602158",
            "longitude": "-2.0958",
            "subregion": "Greater Manchester",
            "woe-name": "Greater Manchester",
            "fips": "UK18",
            "latitude": "53.4567",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Tameside"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -661,
              -70,
              662,
              663
            ]
          ],
          "id": "GB.7127",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7127",
            "hc-a2": "ST",
            "labelrank": "9",
            "iso_3166_2": "GB-SKP",
            "hasc": "GB.MN",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "North West",
            "woe-id": "-12602158",
            "longitude": "-2.1408",
            "subregion": "Greater Manchester",
            "woe-name": "Greater Manchester",
            "fips": "UK18",
            "latitude": "53.3787",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Stockport"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -660,
              -662,
              -664,
              664,
              665,
              -653,
              -656,
              -658
            ]
          ],
          "id": "GB.7128",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7128",
            "hc-a2": "MA",
            "labelrank": "9",
            "iso_3166_2": "GB-MAN",
            "hasc": "GB.MN",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "North West",
            "woe-id": "-12602158",
            "longitude": "-2.26678",
            "subregion": "Greater Manchester",
            "woe-name": "Greater Manchester",
            "fips": "UK18",
            "latitude": "53.4597",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Manchester"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -666,
              666,
              -631,
              -654
            ]
          ],
          "id": "GB.7129",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7129",
            "hc-a2": "TR",
            "labelrank": "9",
            "iso_3166_2": "GB-TRF",
            "hasc": "GB.MN",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "North West",
            "woe-id": "-12602158",
            "longitude": "-2.37777",
            "subregion": "Greater Manchester",
            "woe-name": "Greater Manchester",
            "fips": "UK18",
            "latitude": "53.4147",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Trafford"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -667,
              -665,
              -663,
              -69,
              -602,
              667,
              -600,
              -438,
              668,
              -632
            ]
          ],
          "id": "GB.2366",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-2366",
            "hc-a2": "CE",
            "labelrank": "9",
            "iso_3166_2": "GB-CHE",
            "hasc": "GB.CH",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "North West",
            "woe-id": "-12602157",
            "longitude": "-2.21364",
            "subregion": "Cheshire",
            "woe-name": "Cheshire",
            "fips": "UK06",
            "latitude": "53.2396",
            "woe-label": null,
            "postal-code": null,
            "type": "Unitary Authority",
            "name": "Cheshire East"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              669,
              670,
              671,
              -368,
              -62,
              -76
            ],
            [
              -89
            ]
          ],
          "id": "GB.NT",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-nt",
            "hc-a2": "NT",
            "labelrank": "9",
            "iso_3166_2": "GB-NTT",
            "hasc": "GB.NT",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Administrative County",
            "region": "East Midlands",
            "woe-id": "12602147",
            "longitude": "-0.983216",
            "subregion": "Nottinghamshire",
            "woe-name": "Nottinghamshire",
            "fips": "UK33",
            "latitude": "53.1186",
            "woe-label": null,
            "postal-code": "NT",
            "type": "Administrative County",
            "name": "Nottinghamshire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -670,
              -75,
              672,
              673,
              674
            ]
          ],
          "id": "GB.3267",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-3267",
            "hc-a2": "RO",
            "labelrank": "9",
            "iso_3166_2": "GB-ROT",
            "hasc": "GB.SY",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "Yorkshire and the Humber",
            "woe-id": "-12602196",
            "longitude": "-1.29072",
            "subregion": "South Yorkshire",
            "woe-name": "South Yorkshire",
            "fips": "UK37",
            "latitude": "53.3854",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Rotherham"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -673,
              -74,
              675
            ]
          ],
          "id": "GB.7134",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7134",
            "hc-a2": "SH",
            "labelrank": "9",
            "iso_3166_2": "GB-SHF",
            "hasc": "GB.SY",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "Yorkshire and the Humber",
            "woe-id": "-12602196",
            "longitude": "-1.57387",
            "subregion": "South Yorkshire",
            "woe-name": "South Yorkshire",
            "fips": "UK37",
            "latitude": "53.4087",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Sheffield"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -674,
              -676,
              -644,
              -650,
              676
            ]
          ],
          "id": "GB.7135",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7135",
            "hc-a2": "BA",
            "labelrank": "9",
            "iso_3166_2": "GB-BNS",
            "hasc": "GB.SY",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "Yorkshire and the Humber",
            "woe-id": "-12602196",
            "longitude": "-1.45688",
            "subregion": "South Yorkshire",
            "woe-name": "South Yorkshire",
            "fips": "UK37",
            "latitude": "53.5347",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Barnsley"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              677,
              -507,
              678,
              -275,
              -369,
              -672
            ]
          ],
          "id": "GB.NL",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-nl",
            "hc-a2": "NL",
            "labelrank": "9",
            "iso_3166_2": "GB-NLN",
            "hasc": "GB.NL",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "Yorkshire and the Humber",
            "woe-id": "12696143",
            "longitude": "-0.570942",
            "subregion": "Kingston upon Hull",
            "woe-name": "North Lincolnshire",
            "fips": "UK22",
            "latitude": "53.5741",
            "woe-label": null,
            "postal-code": "NL",
            "type": "Unitary Authority",
            "name": "North Lincolnshire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -678,
              -671,
              -675,
              -677,
              -649,
              -533,
              -508
            ]
          ],
          "id": "GB.7136",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7136",
            "hc-a2": "DO",
            "labelrank": "9",
            "iso_3166_2": "GB-DNC",
            "hasc": "GB.SY",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "Yorkshire and the Humber",
            "woe-id": "-12602196",
            "longitude": "-1.08493",
            "subregion": "South Yorkshire",
            "woe-name": "South Yorkshire",
            "fips": "UK37",
            "latitude": "53.5227",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Doncaster"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -559,
              -604,
              679,
              680,
              681,
              -594,
              -563,
              682
            ]
          ],
          "id": "GB.2377",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-2377",
            "hc-a2": "BI",
            "labelrank": "9",
            "iso_3166_2": "GB-BIR",
            "hasc": "GB.WM",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "West Midlands",
            "woe-id": "-12602191",
            "longitude": "-1.81614",
            "subregion": "West Midlands",
            "woe-name": "West Midlands",
            "fips": "UK43",
            "latitude": "52.4782",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Birmingham"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -681,
              683,
              684,
              685
            ]
          ],
          "id": "GB.7137",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7137",
            "hc-a2": "SA",
            "labelrank": "9",
            "iso_3166_2": "GB-SAW",
            "hasc": "GB.WM",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "West Midlands",
            "woe-id": "-12602191",
            "longitude": "-2.00281",
            "subregion": "West Midlands",
            "woe-name": "West Midlands",
            "fips": "UK43",
            "latitude": "52.5118",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Sandwell"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -684,
              -680,
              -603,
              -597,
              686
            ]
          ],
          "id": "GB.7138",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7138",
            "hc-a2": "DU",
            "labelrank": "9",
            "iso_3166_2": "GB-DUD",
            "hasc": "GB.WM",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "West Midlands",
            "woe-id": "-12602191",
            "longitude": "-2.1138",
            "subregion": "West Midlands",
            "woe-name": "West Midlands",
            "fips": "UK43",
            "latitude": "52.4728",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Dudley"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -685,
              -687,
              -596,
              687
            ]
          ],
          "id": "GB.7139",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7139",
            "hc-a2": "WO",
            "labelrank": "9",
            "iso_3166_2": "GB-WLV",
            "hasc": "GB.WM",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "West Midlands",
            "woe-id": "-12602191",
            "longitude": "-2.1108",
            "subregion": "West Midlands",
            "woe-name": "West Midlands",
            "fips": "UK43",
            "latitude": "52.5958",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Wolverhampton"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -688,
              -595,
              -682,
              -686
            ]
          ],
          "id": "GB.7140",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7140",
            "hc-a2": "WA",
            "labelrank": "9",
            "iso_3166_2": "GB-WLL",
            "hasc": "GB.WM",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "West Midlands",
            "woe-id": "-12602191",
            "longitude": "-1.95182",
            "subregion": "West Midlands",
            "woe-name": "West Midlands",
            "fips": "UK43",
            "latitude": "52.6018",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Walsall"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -560,
              -683,
              -562,
              688
            ]
          ],
          "id": "GB.7141",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7141",
            "hc-a2": "SO",
            "labelrank": "9",
            "iso_3166_2": "GB-SOL",
            "hasc": "GB.WM",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "West Midlands",
            "woe-id": "-12602191",
            "longitude": "-1.71185",
            "subregion": "West Midlands",
            "woe-name": "West Midlands",
            "fips": "UK43",
            "latitude": "52.4038",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Solihull"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -689,
              -561
            ]
          ],
          "id": "GB.7142",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7142",
            "hc-a2": "CO",
            "labelrank": "9",
            "iso_3166_2": "GB-COV",
            "hasc": "GB.WM",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "West Midlands",
            "woe-id": "-12602191",
            "longitude": "-1.53187",
            "subregion": "West Midlands",
            "woe-name": "West Midlands",
            "fips": "UK43",
            "latitude": "52.4068",
            "woe-label": null,
            "postal-code": null,
            "type": "Metropolitan Borough",
            "name": "Coventry"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -260,
              -224,
              -223,
              689,
              -263,
              -262,
              690
            ]
          ],
          "id": "GB.2381",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-2381",
            "hc-a2": "CB",
            "labelrank": "9",
            "iso_3166_2": "GB-CBF",
            "hasc": "GB.BD",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "East",
            "woe-id": "-12602163",
            "longitude": "-0.376341",
            "subregion": "Bedfordshire",
            "woe-name": "Bedfordshire",
            "fips": "UK02",
            "latitude": "52.0236",
            "woe-label": null,
            "postal-code": null,
            "type": "Unitary Authority",
            "name": "Central Bedfordshire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -222,
              -583,
              -264,
              -690
            ]
          ],
          "id": "GB.BD",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-bd",
            "hc-a2": "BD",
            "labelrank": "9",
            "iso_3166_2": "GB-BDF",
            "hasc": "GB.BD",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "East",
            "woe-id": "-12602163",
            "longitude": "-0.470004",
            "subregion": "Bedfordshire",
            "woe-name": "Bedfordshire",
            "fips": "UK02",
            "latitude": "52.1788",
            "woe-label": null,
            "postal-code": "BD",
            "type": "Unitary Authority",
            "name": "Bedford"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -578,
              691,
              692
            ]
          ],
          "id": "GB.2388",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-2388",
            "hc-a2": "RE",
            "labelrank": "9",
            "iso_3166_2": "GB-RDG",
            "hasc": "GB.BK",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "South East",
            "woe-id": "-26821262",
            "longitude": "-1.03367",
            "subregion": "Berkshire",
            "woe-name": "Berkshire",
            "fips": "UK03",
            "latitude": "51.4497",
            "woe-label": null,
            "postal-code": null,
            "type": "Unitary Authority",
            "name": "Reading"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -693,
              693,
              -196,
              694,
              -580,
              -579
            ]
          ],
          "id": "GB.7143",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7143",
            "hc-a2": "WB",
            "labelrank": "9",
            "iso_3166_2": "GB-WBK",
            "hasc": "GB.BK",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "South East",
            "woe-id": "-26821262",
            "longitude": "-1.2949",
            "subregion": "Berkshire",
            "woe-name": "Berkshire",
            "fips": "UK03",
            "latitude": "51.4529",
            "woe-label": null,
            "postal-code": null,
            "type": "Unitary Authority",
            "name": "West Berkshire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -197,
              -694,
              -692,
              -577,
              -230,
              695,
              696
            ]
          ],
          "id": "GB.7144",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7144",
            "hc-a2": "WO",
            "labelrank": "9",
            "iso_3166_2": "GB-WOK",
            "hasc": "GB.BK",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "South East",
            "woe-id": "-26821262",
            "longitude": "-0.90795",
            "subregion": "Berkshire",
            "woe-name": "Berkshire",
            "fips": "UK03",
            "latitude": "51.4019",
            "woe-label": null,
            "postal-code": null,
            "type": "Unitary Authority",
            "name": "Wokingham"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -571,
              -198,
              -697,
              697
            ]
          ],
          "id": "GB.7145",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7145",
            "hc-a2": "BF",
            "labelrank": "9",
            "iso_3166_2": "GB-BRC",
            "hasc": "GB.BK",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "South East",
            "woe-id": "-26821262",
            "longitude": "-0.763967",
            "subregion": "Berkshire",
            "woe-name": "Berkshire",
            "fips": "UK03",
            "latitude": "51.3929",
            "woe-label": null,
            "postal-code": null,
            "type": "Unitary Authority",
            "name": "Bracknell Forest"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -572,
              -698,
              -696,
              -229,
              698
            ]
          ],
          "id": "GB.7146",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7146",
            "hc-a2": "RB",
            "labelrank": "9",
            "iso_3166_2": "GB-",
            "hasc": "GB.BK",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "South East",
            "woe-id": "-26821262",
            "longitude": "-0.700975",
            "subregion": "Berkshire",
            "woe-name": "Berkshire",
            "fips": "UK03",
            "latitude": "51.4769",
            "woe-label": null,
            "postal-code": null,
            "type": "Unitary Authority",
            "name": "Royal Borough of Windsor and Maidenhead"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -573,
              -699,
              -228
            ]
          ],
          "id": "GB.7147",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7147",
            "hc-a2": "SL",
            "labelrank": "9",
            "iso_3166_2": "GB-SLG",
            "hasc": "GB.BK",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "South East",
            "woe-id": "-26821262",
            "longitude": "-0.547994",
            "subregion": "Berkshire",
            "woe-name": "Berkshire",
            "fips": "UK03",
            "latitude": "51.4769",
            "woe-label": null,
            "postal-code": null,
            "type": "Unitary Authority",
            "name": "Slough"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -588,
              -306,
              -305,
              -589,
              -257,
              -320
            ]
          ],
          "id": "GB.7149",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7149",
            "hc-a2": "BA",
            "labelrank": "9",
            "iso_3166_2": "GB-BNE",
            "hasc": "GB.EF",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "London Borough",
            "region": "Greater London",
            "woe-id": "12695821",
            "longitude": "-0.204805",
            "subregion": "Greater London",
            "woe-name": "London Borough of Enfield",
            "fips": "UK17",
            "latitude": "51.6115",
            "woe-label": "London Borough of Barnet",
            "postal-code": null,
            "type": "London Borough",
            "name": "Barnet"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -668,
              -601
            ]
          ],
          "id": "GB.SO",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-so",
            "hc-a2": "SO",
            "labelrank": "9",
            "iso_3166_2": "GB-STE",
            "hasc": "GB.SO",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "West Midlands",
            "woe-id": "12696161",
            "longitude": "-2.16701",
            "subregion": "Staffordshire",
            "woe-name": "Stoke-on-Trent City",
            "fips": "UK38",
            "latitude": "53.0034",
            "woe-label": null,
            "postal-code": "SO",
            "type": "Unitary Authority",
            "name": "Stoke-on-Trent"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -437,
              -521,
              -519,
              699,
              700,
              701,
              702,
              -633,
              -669
            ]
          ],
          "id": "GB.7150",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7150",
            "hc-a2": "CW",
            "labelrank": "9",
            "iso_3166_2": "GB-CHW",
            "hasc": "GB.WT",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "North West",
            "woe-id": "-12602157",
            "longitude": "-2.76774",
            "subregion": "Cheshire",
            "woe-name": "Cheshire",
            "fips": "UK06",
            "latitude": "53.1671",
            "woe-label": null,
            "postal-code": null,
            "type": "Unitary Authority",
            "name": "Cheshire West and Chester"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -634,
              -703,
              703,
              -624,
              -635
            ]
          ],
          "id": "GB.7151",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-7151",
            "hc-a2": "HA",
            "labelrank": "9",
            "iso_3166_2": "GB-HAL",
            "hasc": "GB.WT",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "North West",
            "woe-id": "-12602157",
            "longitude": "-2.68727",
            "subregion": "Cheshire",
            "woe-name": "Warrington Borough",
            "fips": "UK06",
            "latitude": "53.331",
            "woe-label": null,
            "postal-code": null,
            "type": "Unitary Authority",
            "name": "Halton"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -582,
              704,
              -364,
              -266
            ]
          ],
          "id": "GB.PB",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-pb",
            "hc-a2": "PB",
            "labelrank": "9",
            "iso_3166_2": "GB-PTE",
            "hasc": "GB.PB",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "East",
            "woe-id": "12696170",
            "longitude": "-0.270107",
            "subregion": "Cambridgeshire",
            "woe-name": "Peterborough City",
            "fips": "UK05",
            "latitude": "52.5833",
            "woe-label": null,
            "postal-code": "PB",
            "type": "Unitary Authority",
            "name": "Peterborough"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              705
            ]
          ],
          "id": "GB.IW",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-iw",
            "hc-a2": "IW",
            "labelrank": "9",
            "iso_3166_2": "GB-IOW",
            "hasc": "GB.IW",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "South East",
            "woe-id": "12602172",
            "longitude": "-1.31588",
            "subregion": "Hampshire",
            "woe-name": "Isle of Wight",
            "fips": "UK23",
            "latitude": "50.6808",
            "woe-label": null,
            "postal-code": "IW",
            "type": "Unitary Authority",
            "name": "Isle of Wight"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              709,
              -241,
              -236,
              710,
              -251,
              -93
            ]
          ],
          "id": "GB.SM",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-sm",
            "hc-a2": "SM",
            "labelrank": "9",
            "iso_3166_2": "GB-SOM",
            "hasc": "GB.SM",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Administrative County",
            "region": "South West",
            "woe-id": "12602185",
            "longitude": "-3.03172",
            "subregion": "Somerset",
            "woe-name": "Somerset",
            "fips": "UK36",
            "latitude": "51.0339",
            "woe-label": null,
            "postal-code": "SM",
            "type": "Administrative County",
            "name": "Somerset"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              711,
              -426,
              -431,
              -454,
              -477,
              -479
            ]
          ],
          "id": "GB.CI",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-ci",
            "hc-a2": "CI",
            "labelrank": "9",
            "iso_3166_2": "GB-CMN",
            "hasc": "GB.CI",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority (wales",
            "region": "East Wales",
            "woe-id": "12602216",
            "longitude": "-4.20485",
            "subregion": "West Wales",
            "woe-name": "Carmarthenshire County",
            "fips": "UK91",
            "latitude": "51.8622",
            "woe-label": null,
            "postal-code": "CI",
            "type": "Unitary Authority (wales)",
            "name": "Carmarthenshire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              712,
              -701
            ]
          ],
          "id": "GB.HL",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-hl",
            "hc-a2": "HL",
            "labelrank": "9",
            "iso_3166_2": "GB-HAL",
            "hasc": "GB.HL",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Metropolitan Borough",
            "region": "North West",
            "woe-id": "12696171",
            "longitude": "-3.05638",
            "subregion": "Merseyside",
            "woe-name": "Halton Borough",
            "fips": "UK28",
            "latitude": "53.3686",
            "woe-label": null,
            "postal-code": "HL",
            "type": "Metropolitan Borough",
            "name": "Halton"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              713,
              -91
            ]
          ],
          "id": "GB.CO",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-co",
            "hc-a2": "CO",
            "labelrank": "9",
            "iso_3166_2": "GB-CON",
            "hasc": "GB.CO",
            "alt-name": "Cornouailles|Cornovaglia|Cornualha|Cornualles|Cornwall and Isles of Scilly",
            "country": "United Kingdom",
            "type-en": "Unitary Single-Tier County",
            "region": "South West",
            "woe-id": "12602181",
            "longitude": "-4.75267",
            "subregion": "Cornwall",
            "woe-name": "Cornwall and Isles of Scilly",
            "fips": "UK08",
            "latitude": "50.4407",
            "woe-label": null,
            "postal-code": "CO",
            "type": "Unitary Single-Tier County",
            "name": "Cornwall"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -433,
              714,
              -514
            ]
          ],
          "id": "GB.CW",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-cw",
            "hc-a2": "CW",
            "labelrank": "9",
            "iso_3166_2": "GB-CWY",
            "hasc": "GB.CW",
            "alt-name": "Aberconwy and Colwyn",
            "country": "United Kingdom",
            "type-en": "Unitary Authority (wales",
            "region": "East Wales",
            "woe-id": "12602218",
            "longitude": "-3.7349",
            "subregion": "North Wales",
            "woe-name": "Conwy County Borough",
            "fips": "UK93",
            "latitude": "53.1274",
            "woe-label": null,
            "postal-code": "CW",
            "type": "Unitary Authority (wales)",
            "name": "Conwy"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              718,
              -717,
              -167,
              -607,
              -174,
              -538,
              -501
            ]
          ],
          "id": "GB.CU",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-cu",
            "hc-a2": "CU",
            "labelrank": "9",
            "iso_3166_2": "GB-CMA",
            "hasc": "GB.CU",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Administrative County",
            "region": "North West",
            "woe-id": "12602148",
            "longitude": "-2.89222",
            "subregion": "Cumbria",
            "woe-name": "Cumbria",
            "fips": "UK09",
            "latitude": "54.6368",
            "woe-label": null,
            "postal-code": "CU",
            "type": "Administrative County",
            "name": "Cumbria"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              719,
              -544,
              -269,
              -548
            ]
          ],
          "id": "GB.SF",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-sf",
            "hc-a2": "SF",
            "labelrank": "9",
            "iso_3166_2": "GB-SFK",
            "hasc": "GB.SF",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Administrative County",
            "region": "East",
            "woe-id": "12602142",
            "longitude": "1.06039",
            "subregion": "Suffolk",
            "woe-name": "Suffolk",
            "fips": "UK39",
            "latitude": "52.159",
            "woe-label": null,
            "postal-code": "SF",
            "type": "Administrative County",
            "name": "Suffolk"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              720,
              -288
            ]
          ],
          "id": "GB.MW",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-mw",
            "hc-a2": "MW",
            "labelrank": "9",
            "iso_3166_2": "GB-MDW",
            "hasc": "GB.MW",
            "alt-name": "Medway Towns",
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "South East",
            "woe-id": "12696177",
            "longitude": "0.584221",
            "subregion": "Kent",
            "woe-name": "Medway",
            "fips": "UK24",
            "latitude": "51.3541",
            "woe-label": null,
            "postal-code": "MW",
            "type": "Unitary Authority",
            "name": "Medway"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -261,
              -691
            ]
          ],
          "id": "GB.LU",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-lu",
            "hc-a2": "LU",
            "labelrank": "9",
            "iso_3166_2": "GB-LUT",
            "hasc": "GB.LU",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Authority",
            "region": "East",
            "woe-id": "12696155",
            "longitude": "-0.406249",
            "subregion": "Bedfordshire",
            "woe-name": "Luton Borough",
            "fips": "UK02",
            "latitude": "51.8763",
            "woe-label": null,
            "postal-code": "LU",
            "type": "Unitary Authority",
            "name": "Luton"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -581,
              -695,
              -195,
              -252,
              -711,
              -235,
              -244,
              -217
            ]
          ],
          "id": "GB.WL",
          "properties": {
            "hc-group": "admin1",
            "hc-key": "gb-wl",
            "hc-a2": "WL",
            "labelrank": "9",
            "iso_3166_2": "GB-WIL",
            "hasc": "GB.WL",
            "alt-name": null,
            "country": "United Kingdom",
            "type-en": "Unitary Single-Tier County",
            "region": "South West",
            "woe-id": "12602186",
            "longitude": "-1.91891",
            "subregion": "Wiltshire",
            "woe-name": "Wiltshire",
            "fips": "UK46",
            "latitude": "51.3289",
            "woe-label": null,
            "postal-code": "WL",
            "type": "Unitary Single-Tier County",
            "name": "Wiltshire"
          }
        },
      ],
      "hc-recommended-transform": {
        "default": {
          "crs": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +towgs84=446.448,-125.157,542.06,0.15,0.247,0.842,-20.489 +units=m +vunits=m +no_defs",
          "scale": 0.000671282186262,
          "jsonres": 15.5,
          "jsonmarginX": -999,
          "jsonmarginY": 9851,
          "xoffset": 137.384849029,
          "yoffset": 1053130.83361
        },
        "gb-all-shetland": {
          "xpan": 350,
          "ypan": 25,
          "crs": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +towgs84=446.448,-125.157,542.06,0.15,0.247,0.842,-20.489 +units=m +vunits=m +no_defs",
          "scale": 0.000804993331371,
          "jsonres": 15.5,
          "jsonmarginX": -999,
          "jsonmarginY": 9851,
          "xoffset": 393862.661213,
          "yoffset": 1218916.28516,
          "geometry": {
            "type": "Polygon",
            "coordinates": [
              [
                [
                  -0.44675777148831874,
                  59.48298640304288
                ],
                [
                  -0.5407059128069326,
                  57.27919198219295
                ],
                [
                  8.789616983459007,
                  56.82033095586859
                ],
                [
                  9.46680356304447,
                  58.98362541783335
                ],
                [
                  -0.44675777148831874,
                  59.48298640304288
                ]
              ]
            ]
          }
        }
      },
      "hc-recommended-mapview": {
        "insets": [
          {
            "id": "gb-shetland",
            "borderPath": {
              "type": "MultiLineString",
              "coordinates": [
                [
                  [
                    75,
                    0
                  ],
                  [
                    75,
                    20
                  ]
                ]
              ]
            },
            "field": {
              "type": "Polygon",
              "coordinates": [
                [
                  [
                    75,
                    0
                  ],
                  [
                    100,
                    0
                  ],
                  [
                    100,
                    20
                  ],
                  [
                    75,
                    20
                  ]
                ]
              ]
            },
            "geoBounds": {
              "type": "Polygon",
              "coordinates": [
                [
                  [
                    -2.5,
                    59.5
                  ],
                  [
                    0,
                    59.5
                  ],
                  [
                    0,
                    61
                  ],
                  [
                    -2.5,
                    61
                  ]
                ]
              ]
            },
            "projection": {
              "name": "LambertConformalConic",
              "parallels": [
                60
              ],
              "rotation": [
                1
              ]
            }
          }
        ]
      }
    }
  },
  "arcs": [
    [
      [
        3537,
        3115
      ],
      [
        29,
        0
      ],
      [
        69,
        -62
      ],
      [
        -24,
        -9
      ],
      [
        -41,
        30
      ],
      [
        -54,
        9
      ],
      [
        -18,
        22
      ],
      [
        39,
        10
      ]
    ],
    [
      [
        3974,
        2989
      ],
      [
        -123,
        -46
      ],
      [
        -70,
        -1
      ],
      [
        28,
        47
      ],
      [
        -64,
        -18
      ],
      [
        -48,
        18
      ],
      [
        -3,
        26
      ],
      [
        -72,
        59
      ],
      [
        13,
        81
      ],
      [
        -12,
        26
      ],
      [
        146,
        31
      ],
      [
        101,
        -6
      ],
      [
        49,
        -17
      ],
      [
        9,
        -30
      ],
      [
        64,
        -64
      ],
      [
        76,
        15
      ],
      [
        85,
        -11
      ],
      [
        -55,
        -48
      ],
      [
        -99,
        -27
      ],
      [
        -25,
        -35
      ]
    ],
    [
      [
        5589,
        8448
      ],
      [
        101,
        -53
      ],
      [
        -84,
        -19
      ],
      [
        -17,
        31
      ],
      [
        -50,
        44
      ],
      [
        50,
        -3
      ]
    ],
    [
      [
        5173,
        8476
      ],
      [
        76,
        0
      ],
      [
        -22,
        -45
      ],
      [
        -91,
        0
      ],
      [
        -50,
        23
      ],
      [
        12,
        29
      ],
      [
        54,
        6
      ],
      [
        21,
        -13
      ]
    ],
    [
      [
        5434,
        8533
      ],
      [
        41,
        -19
      ],
      [
        -33,
        -29
      ],
      [
        26,
        -40
      ],
      [
        -47,
        -7
      ],
      [
        -49,
        51
      ],
      [
        44,
        0
      ],
      [
        -6,
        37
      ],
      [
        24,
        7
      ]
    ],
    [
      [
        5248,
        8162
      ],
      [
        71,
        -6
      ],
      [
        -1,
        -11
      ],
      [
        -43,
        -38
      ],
      [
        16,
        -28
      ],
      [
        -29,
        -16
      ],
      [
        -48,
        24
      ],
      [
        13,
        14
      ],
      [
        -62,
        49
      ],
      [
        83,
        12
      ]
    ],
    [
      [
        5044,
        8114
      ],
      [
        -143,
        -7
      ],
      [
        -28,
        36
      ],
      [
        -52,
        32
      ],
      [
        4,
        13
      ],
      [
        -55,
        7
      ],
      [
        14,
        30
      ],
      [
        66,
        18
      ],
      [
        103,
        -29
      ],
      [
        54,
        -39
      ],
      [
        21,
        -31
      ],
      [
        -76,
        -25
      ],
      [
        117,
        13
      ],
      [
        -25,
        -18
      ]
    ],
    [
      [
        5142,
        8301
      ],
      [
        48,
        23
      ],
      [
        37,
        -16
      ],
      [
        42,
        11
      ],
      [
        68,
        -33
      ],
      [
        75,
        16
      ],
      [
        9,
        -17
      ],
      [
        -56,
        -22
      ],
      [
        62,
        -19
      ],
      [
        -20,
        25
      ],
      [
        68,
        13
      ],
      [
        21,
        -35
      ],
      [
        -78,
        -20
      ],
      [
        -55,
        -25
      ],
      [
        -76,
        15
      ],
      [
        -67,
        56
      ],
      [
        -43,
        -19
      ],
      [
        -61,
        3
      ],
      [
        -32,
        -25
      ],
      [
        -86,
        0
      ],
      [
        -26,
        12
      ],
      [
        -6,
        40
      ],
      [
        27,
        29
      ],
      [
        -21,
        31
      ],
      [
        -38,
        -29
      ],
      [
        10,
        -26
      ],
      [
        -33,
        -25
      ],
      [
        -34,
        6
      ],
      [
        -44,
        54
      ],
      [
        22,
        33
      ],
      [
        -5,
        41
      ],
      [
        26,
        27
      ],
      [
        94,
        19
      ],
      [
        74,
        -5
      ],
      [
        73,
        -13
      ],
      [
        15,
        -25
      ],
      [
        75,
        -25
      ],
      [
        -138,
        -63
      ],
      [
        73,
        -12
      ]
    ],
    [
      [
        5515,
        8508
      ],
      [
        93,
        43
      ],
      [
        -16,
        26
      ],
      [
        90,
        6
      ],
      [
        -56,
        -26
      ],
      [
        60,
        3
      ],
      [
        72,
        17
      ],
      [
        36,
        24
      ],
      [
        15,
        -23
      ],
      [
        -64,
        -14
      ],
      [
        -55,
        -44
      ],
      [
        -19,
        19
      ],
      [
        -71,
        -6
      ],
      [
        -59,
        -34
      ],
      [
        -26,
        9
      ]
    ],
    [
      [
        5182,
        8565
      ],
      [
        -58,
        49
      ],
      [
        70,
        0
      ],
      [
        43,
        25
      ],
      [
        19,
        -10
      ],
      [
        -41,
        -27
      ],
      [
        92,
        -16
      ],
      [
        25,
        -41
      ],
      [
        -50,
        23
      ],
      [
        -55,
        8
      ],
      [
        -14,
        -23
      ],
      [
        -31,
        12
      ]
    ],
    [
      [
        1667,
        6526
      ],
      [
        -91,
        1
      ],
      [
        69,
        19
      ],
      [
        48,
        -12
      ],
      [
        -26,
        -8
      ]
    ],
    [
      [
        2261,
        6747
      ],
      [
        -34,
        -7
      ],
      [
        -55,
        30
      ],
      [
        59,
        4
      ],
      [
        30,
        -27
      ]
    ],
    [
      [
        4519,
        6567
      ],
      [
        -58,
        -17
      ],
      [
        -9,
        -78
      ],
      [
        -51,
        -56
      ]
    ],
    [
      [
        4401,
        6416
      ],
      [
        -82,
        -5
      ],
      [
        -63,
        21
      ],
      [
        -36,
        -48
      ],
      [
        -124,
        0
      ],
      [
        -65,
        13
      ],
      [
        -38,
        -37
      ],
      [
        -165,
        -39
      ],
      [
        -71,
        -44
      ],
      [
        -78,
        24
      ],
      [
        -65,
        -45
      ],
      [
        -8,
        -57
      ],
      [
        -117,
        -21
      ],
      [
        -6,
        -26
      ]
    ],
    [
      [
        3483,
        6152
      ],
      [
        -82,
        11
      ],
      [
        -74,
        -6
      ],
      [
        -59,
        11
      ],
      [
        -97,
        -17
      ],
      [
        -55,
        -30
      ],
      [
        -95,
        21
      ],
      [
        -137,
        9
      ]
    ],
    [
      [
        2884,
        6151
      ],
      [
        -12,
        19
      ],
      [
        98,
        25
      ],
      [
        67,
        -6
      ],
      [
        158,
        32
      ],
      [
        -165,
        -19
      ],
      [
        -78,
        19
      ],
      [
        15,
        23
      ],
      [
        68,
        37
      ],
      [
        35,
        33
      ],
      [
        -114,
        -53
      ],
      [
        -35,
        -44
      ],
      [
        -73,
        -18
      ],
      [
        -47,
        -34
      ],
      [
        -48,
        -12
      ],
      [
        -165,
        -104
      ],
      [
        -68,
        -27
      ],
      [
        -103,
        35
      ],
      [
        -85,
        12
      ],
      [
        -150,
        62
      ],
      [
        -4,
        22
      ],
      [
        74,
        11
      ],
      [
        103,
        -19
      ],
      [
        -34,
        25
      ],
      [
        107,
        36
      ],
      [
        86,
        -15
      ],
      [
        36,
        4
      ],
      [
        -113,
        24
      ],
      [
        -147,
        -36
      ],
      [
        -60,
        12
      ],
      [
        -69,
        -3
      ],
      [
        -99,
        9
      ],
      [
        -39,
        -15
      ],
      [
        -61,
        15
      ],
      [
        -13,
        31
      ],
      [
        56,
        24
      ],
      [
        154,
        7
      ],
      [
        78,
        18
      ],
      [
        97,
        -32
      ],
      [
        -7,
        19
      ],
      [
        58,
        22
      ],
      [
        -50,
        24
      ],
      [
        14,
        17
      ],
      [
        104,
        7
      ],
      [
        -51,
        14
      ],
      [
        49,
        31
      ],
      [
        -45,
        4
      ],
      [
        -94,
        -10
      ],
      [
        43,
        100
      ],
      [
        45,
        22
      ],
      [
        57,
        3
      ],
      [
        42,
        -31
      ],
      [
        63,
        -12
      ],
      [
        18,
        11
      ],
      [
        -79,
        19
      ],
      [
        6,
        24
      ],
      [
        -73,
        4
      ],
      [
        -38,
        17
      ],
      [
        75,
        56
      ],
      [
        71,
        8
      ],
      [
        87,
        -26
      ],
      [
        160,
        5
      ],
      [
        -21,
        14
      ],
      [
        -120,
        -14
      ],
      [
        -46,
        25
      ],
      [
        -83,
        13
      ],
      [
        -5,
        25
      ],
      [
        48,
        38
      ],
      [
        5,
        32
      ],
      [
        76,
        17
      ],
      [
        100,
        -43
      ],
      [
        -57,
        50
      ],
      [
        62,
        38
      ],
      [
        -160,
        -37
      ],
      [
        -57,
        11
      ],
      [
        -65,
        -6
      ],
      [
        19,
        44
      ],
      [
        48,
        19
      ],
      [
        41,
        -10
      ],
      [
        113,
        26
      ],
      [
        44,
        21
      ],
      [
        -7,
        28
      ],
      [
        -99,
        -56
      ],
      [
        -77,
        10
      ],
      [
        30,
        21
      ],
      [
        -15,
        18
      ],
      [
        -83,
        -52
      ],
      [
        -102,
        -4
      ],
      [
        -17,
        36
      ],
      [
        14,
        43
      ],
      [
        -47,
        10
      ],
      [
        -12,
        44
      ],
      [
        31,
        71
      ],
      [
        53,
        -3
      ],
      [
        55,
        -28
      ],
      [
        92,
        -30
      ],
      [
        -13,
        18
      ],
      [
        137,
        3
      ],
      [
        -26,
        19
      ],
      [
        -91,
        2
      ],
      [
        -28,
        -12
      ],
      [
        -103,
        82
      ],
      [
        -43,
        8
      ],
      [
        16,
        49
      ],
      [
        57,
        11
      ],
      [
        29,
        -17
      ],
      [
        31,
        18
      ],
      [
        -47,
        22
      ],
      [
        -83,
        9
      ],
      [
        -5,
        92
      ],
      [
        20,
        16
      ],
      [
        64,
        11
      ],
      [
        52,
        -12
      ],
      [
        13,
        -62
      ],
      [
        76,
        -7
      ],
      [
        0,
        43
      ],
      [
        -67,
        41
      ],
      [
        39,
        47
      ],
      [
        62,
        -13
      ],
      [
        23,
        -42
      ],
      [
        73,
        -14
      ],
      [
        29,
        50
      ],
      [
        58,
        -10
      ],
      [
        41,
        -21
      ],
      [
        107,
        -25
      ],
      [
        -99,
        48
      ],
      [
        -66,
        14
      ],
      [
        19,
        26
      ],
      [
        70,
        -32
      ],
      [
        42,
        7
      ],
      [
        136,
        -43
      ],
      [
        23,
        2
      ],
      [
        -124,
        53
      ],
      [
        16,
        29
      ],
      [
        -88,
        19
      ],
      [
        -95,
        47
      ],
      [
        -61,
        48
      ],
      [
        57,
        7
      ],
      [
        25,
        -24
      ],
      [
        66,
        4
      ],
      [
        21,
        32
      ],
      [
        -18,
        27
      ],
      [
        55,
        11
      ],
      [
        -90,
        31
      ],
      [
        -60,
        58
      ],
      [
        16,
        18
      ],
      [
        66,
        -19
      ],
      [
        73,
        13
      ],
      [
        65,
        -7
      ],
      [
        44,
        20
      ],
      [
        61,
        -19
      ],
      [
        87,
        0
      ],
      [
        55,
        13
      ],
      [
        -83,
        6
      ],
      [
        -40,
        -11
      ],
      [
        -47,
        15
      ],
      [
        -64,
        46
      ],
      [
        -13,
        25
      ],
      [
        30,
        55
      ],
      [
        86,
        -25
      ],
      [
        42,
        1
      ],
      [
        -41,
        31
      ],
      [
        -41,
        -6
      ],
      [
        -9,
        19
      ],
      [
        57,
        16
      ],
      [
        -56,
        31
      ],
      [
        2,
        24
      ],
      [
        76,
        28
      ],
      [
        23,
        67
      ],
      [
        16,
        10
      ],
      [
        130,
        -14
      ],
      [
        41,
        -18
      ],
      [
        28,
        -47
      ],
      [
        14,
        59
      ],
      [
        49,
        -26
      ],
      [
        68,
        -20
      ],
      [
        -6,
        -22
      ],
      [
        -48,
        -24
      ],
      [
        -47,
        -53
      ],
      [
        95,
        50
      ],
      [
        55,
        20
      ],
      [
        26,
        45
      ],
      [
        111,
        -7
      ],
      [
        49,
        -18
      ],
      [
        -69,
        -89
      ],
      [
        61,
        43
      ],
      [
        118,
        46
      ],
      [
        61,
        -17
      ],
      [
        97,
        32
      ],
      [
        80,
        0
      ],
      [
        53,
        27
      ],
      [
        25,
        -20
      ],
      [
        108,
        -4
      ],
      [
        86,
        7
      ],
      [
        113,
        34
      ],
      [
        100,
        15
      ],
      [
        56,
        -6
      ],
      [
        10,
        -17
      ],
      [
        86,
        11
      ],
      [
        84,
        -12
      ],
      [
        13,
        18
      ],
      [
        -62,
        32
      ],
      [
        54,
        18
      ],
      [
        50,
        -25
      ],
      [
        106,
        12
      ],
      [
        52,
        -18
      ],
      [
        100,
        6
      ],
      [
        33,
        -7
      ],
      [
        -30,
        -49
      ],
      [
        -80,
        -68
      ],
      [
        11,
        -26
      ],
      [
        54,
        -1
      ],
      [
        -22,
        -63
      ],
      [
        -44,
        -41
      ],
      [
        -92,
        -58
      ],
      [
        -129,
        -27
      ],
      [
        -89,
        -37
      ],
      [
        -77,
        -61
      ],
      [
        -221,
        -89
      ],
      [
        -93,
        -27
      ],
      [
        -34,
        -39
      ],
      [
        -57,
        -11
      ],
      [
        -99,
        -35
      ],
      [
        -69,
        13
      ],
      [
        7,
        -19
      ],
      [
        62,
        -10
      ],
      [
        29,
        -21
      ],
      [
        -23,
        -37
      ],
      [
        -60,
        5
      ],
      [
        -35,
        -18
      ],
      [
        -114,
        18
      ],
      [
        -82,
        -10
      ],
      [
        -93,
        42
      ],
      [
        52,
        -39
      ],
      [
        71,
        -18
      ],
      [
        62,
        11
      ],
      [
        75,
        -26
      ],
      [
        -6,
        16
      ],
      [
        101,
        -27
      ],
      [
        55,
        22
      ],
      [
        107,
        -23
      ],
      [
        79,
        45
      ],
      [
        9,
        -32
      ],
      [
        -200,
        -124
      ],
      [
        -27,
        25
      ],
      [
        -62,
        6
      ],
      [
        -77,
        -34
      ],
      [
        -141,
        -11
      ],
      [
        -14,
        -23
      ],
      [
        -94,
        -42
      ],
      [
        -26,
        -29
      ],
      [
        48,
        11
      ],
      [
        52,
        34
      ],
      [
        127,
        44
      ],
      [
        106,
        -15
      ],
      [
        88,
        28
      ],
      [
        5,
        -12
      ],
      [
        -175,
        -116
      ],
      [
        -84,
        3
      ],
      [
        54,
        -13
      ],
      [
        -41,
        -37
      ],
      [
        55,
        -6
      ],
      [
        161,
        60
      ],
      [
        -51,
        27
      ],
      [
        121,
        6
      ],
      [
        96,
        -4
      ],
      [
        115,
        34
      ]
    ],
    [
      [
        4443,
        7052
      ],
      [
        46,
        -44
      ],
      [
        -3,
        -41
      ],
      [
        24,
        -9
      ],
      [
        2,
        -70
      ],
      [
        -16,
        -35
      ],
      [
        35,
        21
      ],
      [
        169,
        24
      ],
      [
        61,
        -28
      ],
      [
        41,
        -5
      ],
      [
        12,
        -37
      ],
      [
        -98,
        -75
      ],
      [
        38,
        -12
      ],
      [
        -9,
        -44
      ],
      [
        34,
        -13
      ],
      [
        -32,
        -41
      ],
      [
        -79,
        -14
      ],
      [
        -85,
        -42
      ],
      [
        -64,
        -20
      ]
    ],
    [
      [
        1819,
        6531
      ],
      [
        40,
        2
      ],
      [
        73,
        -29
      ],
      [
        -18,
        -8
      ],
      [
        27,
        -7
      ],
      [
        -14,
        -33
      ],
      [
        -47,
        -27
      ],
      [
        -56,
        3
      ],
      [
        -17,
        21
      ],
      [
        -79,
        30
      ],
      [
        91,
        48
      ]
    ],
    [
      [
        2169,
        6903
      ],
      [
        -21,
        25
      ],
      [
        55,
        7
      ],
      [
        -36,
        -73
      ],
      [
        29,
        -65
      ],
      [
        -65,
        -18
      ],
      [
        -23,
        41
      ],
      [
        15,
        74
      ],
      [
        46,
        9
      ]
    ],
    [
      [
        2066,
        6844
      ],
      [
        -21,
        -22
      ],
      [
        42,
        -38
      ],
      [
        -57,
        -25
      ],
      [
        111,
        3
      ],
      [
        -34,
        -28
      ],
      [
        70,
        8
      ],
      [
        85,
        -18
      ],
      [
        24,
        -22
      ],
      [
        163,
        31
      ],
      [
        16,
        -11
      ],
      [
        75,
        0
      ],
      [
        -12,
        -39
      ],
      [
        -32,
        -30
      ],
      [
        -92,
        -21
      ],
      [
        -18,
        -39
      ],
      [
        -43,
        -14
      ],
      [
        -75,
        -53
      ],
      [
        -89,
        -20
      ],
      [
        -24,
        15
      ],
      [
        28,
        50
      ],
      [
        61,
        51
      ],
      [
        98,
        24
      ],
      [
        -142,
        -7
      ],
      [
        -37,
        20
      ],
      [
        -51,
        -59
      ],
      [
        -29,
        3
      ],
      [
        -11,
        49
      ],
      [
        -53,
        12
      ],
      [
        -12,
        -19
      ],
      [
        -141,
        -18
      ],
      [
        42,
        32
      ],
      [
        -69,
        -7
      ],
      [
        -35,
        32
      ],
      [
        34,
        18
      ],
      [
        -62,
        0
      ],
      [
        -76,
        63
      ],
      [
        67,
        21
      ],
      [
        79,
        -30
      ],
      [
        13,
        9
      ],
      [
        -82,
        36
      ],
      [
        -57,
        -4
      ],
      [
        -13,
        50
      ],
      [
        -47,
        -19
      ],
      [
        -8,
        32
      ],
      [
        -43,
        -36
      ],
      [
        -7,
        -34
      ],
      [
        -92,
        16
      ],
      [
        -43,
        18
      ],
      [
        -17,
        37
      ],
      [
        -53,
        37
      ],
      [
        63,
        -1
      ],
      [
        -25,
        29
      ],
      [
        40,
        21
      ],
      [
        60,
        -47
      ],
      [
        41,
        -14
      ],
      [
        6,
        23
      ],
      [
        -32,
        22
      ],
      [
        20,
        18
      ],
      [
        48,
        -8
      ],
      [
        -35,
        31
      ],
      [
        -56,
        13
      ],
      [
        24,
        22
      ],
      [
        -9,
        28
      ],
      [
        68,
        -23
      ],
      [
        8,
        -21
      ],
      [
        99,
        -42
      ],
      [
        45,
        4
      ],
      [
        -22,
        -27
      ],
      [
        56,
        27
      ],
      [
        78,
        -50
      ],
      [
        -14,
        31
      ],
      [
        -67,
        51
      ],
      [
        31,
        37
      ],
      [
        -41,
        6
      ],
      [
        -16,
        42
      ],
      [
        105,
        53
      ],
      [
        160,
        -104
      ],
      [
        17,
        -117
      ],
      [
        -24,
        -50
      ],
      [
        41,
        -8
      ]
    ],
    [
      [
        2052,
        5668
      ],
      [
        -33,
        -28
      ],
      [
        -8,
        -35
      ],
      [
        -76,
        -11
      ],
      [
        17,
        46
      ],
      [
        51,
        35
      ],
      [
        49,
        -7
      ]
    ],
    [
      [
        2462,
        5714
      ],
      [
        -14,
        14
      ],
      [
        51,
        22
      ],
      [
        14,
        -21
      ],
      [
        -51,
        -15
      ]
    ],
    [
      [
        2575,
        5807
      ],
      [
        -25,
        -68
      ],
      [
        -30,
        30
      ],
      [
        22,
        30
      ],
      [
        33,
        8
      ]
    ],
    [
      [
        2602,
        5863
      ],
      [
        -36,
        -45
      ],
      [
        -25,
        21
      ],
      [
        26,
        23
      ],
      [
        35,
        1
      ]
    ],
    [
      [
        2025,
        5995
      ],
      [
        -78,
        0
      ],
      [
        -27,
        12
      ],
      [
        50,
        19
      ],
      [
        55,
        -31
      ]
    ],
    [
      [
        3516,
        6015
      ],
      [
        38,
        -19
      ]
    ],
    [
      [
        3554,
        5996
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        3554,
        5997
      ],
      [
        -84,
        -16
      ],
      [
        -3,
        -15
      ],
      [
        -78,
        -27
      ],
      [
        -35,
        -35
      ],
      [
        62,
        -25
      ],
      [
        -3,
        -23
      ],
      [
        60,
        9
      ],
      [
        71,
        -6
      ],
      [
        -37,
        -66
      ],
      [
        5,
        -46
      ],
      [
        83,
        -111
      ]
    ],
    [
      [
        3595,
        5636
      ],
      [
        0,
        -107
      ],
      [
        7,
        -17
      ]
    ],
    [
      [
        3602,
        5512
      ],
      [
        -83,
        19
      ],
      [
        -51,
        33
      ],
      [
        -41,
        8
      ],
      [
        -73,
        40
      ],
      [
        48,
        -37
      ],
      [
        5,
        -24
      ],
      [
        -43,
        -2
      ],
      [
        -35,
        19
      ],
      [
        -2,
        58
      ],
      [
        39,
        53
      ],
      [
        70,
        58
      ],
      [
        -23,
        4
      ],
      [
        -72,
        -73
      ],
      [
        -30,
        7
      ],
      [
        -12,
        50
      ],
      [
        -28,
        -6
      ],
      [
        35,
        -80
      ],
      [
        -16,
        -17
      ],
      [
        -5,
        -69
      ],
      [
        -49,
        10
      ],
      [
        41,
        -33
      ],
      [
        -68,
        -83
      ],
      [
        -44,
        3
      ],
      [
        -31,
        34
      ],
      [
        -14,
        44
      ],
      [
        -69,
        40
      ],
      [
        62,
        -84
      ],
      [
        -28,
        -5
      ],
      [
        -67,
        27
      ],
      [
        -9,
        32
      ],
      [
        -62,
        -71
      ],
      [
        42,
        -55
      ],
      [
        -97,
        19
      ],
      [
        -38,
        40
      ],
      [
        9,
        65
      ],
      [
        -13,
        26
      ],
      [
        25,
        15
      ],
      [
        111,
        98
      ],
      [
        110,
        35
      ],
      [
        51,
        54
      ],
      [
        104,
        31
      ],
      [
        -125,
        -20
      ],
      [
        -44,
        -50
      ],
      [
        -121,
        -42
      ],
      [
        -82,
        -65
      ],
      [
        -28,
        -3
      ],
      [
        -18,
        -32
      ],
      [
        -35,
        -13
      ],
      [
        -57,
        16
      ],
      [
        -8,
        -61
      ],
      [
        25,
        -7
      ],
      [
        23,
        -75
      ],
      [
        56,
        -31
      ],
      [
        35,
        -45
      ],
      [
        -117,
        -57
      ],
      [
        -58,
        -69
      ],
      [
        7,
        -32
      ],
      [
        29,
        -17
      ],
      [
        -90,
        -130
      ],
      [
        -39,
        -20
      ],
      [
        69,
        -49
      ],
      [
        -44,
        -39
      ],
      [
        -81,
        -25
      ],
      [
        -42,
        6
      ],
      [
        -73,
        -12
      ],
      [
        -29,
        15
      ],
      [
        -8,
        77
      ],
      [
        76,
        46
      ],
      [
        -7,
        106
      ],
      [
        49,
        70
      ],
      [
        -8,
        31
      ],
      [
        56,
        24
      ],
      [
        45,
        51
      ],
      [
        76,
        30
      ],
      [
        50,
        51
      ],
      [
        -97,
        -56
      ],
      [
        -62,
        -18
      ],
      [
        -33,
        21
      ],
      [
        -28,
        54
      ],
      [
        46,
        54
      ],
      [
        -53,
        -17
      ],
      [
        -16,
        27
      ],
      [
        111,
        87
      ],
      [
        16,
        24
      ],
      [
        -55,
        -12
      ],
      [
        -82,
        -75
      ],
      [
        10,
        36
      ],
      [
        37,
        37
      ],
      [
        90,
        70
      ],
      [
        39,
        -12
      ],
      [
        -28,
        41
      ],
      [
        51,
        53
      ],
      [
        -31,
        -5
      ],
      [
        -66,
        -39
      ],
      [
        58,
        91
      ],
      [
        53,
        12
      ],
      [
        -17,
        16
      ],
      [
        -71,
        -20
      ],
      [
        -15,
        9
      ],
      [
        25,
        63
      ],
      [
        63,
        67
      ],
      [
        53,
        37
      ],
      [
        135,
        12
      ],
      [
        81,
        -11
      ],
      [
        62,
        16
      ],
      [
        55,
        46
      ],
      [
        -76,
        -44
      ],
      [
        -42,
        -2
      ],
      [
        -107,
        12
      ],
      [
        -44,
        -7
      ],
      [
        -16,
        35
      ],
      [
        -59,
        -25
      ],
      [
        41,
        56
      ],
      [
        49,
        -17
      ],
      [
        41,
        5
      ],
      [
        86,
        29
      ],
      [
        -59,
        -4
      ],
      [
        -50,
        -18
      ],
      [
        -53,
        12
      ],
      [
        61,
        62
      ],
      [
        48,
        25
      ]
    ],
    [
      [
        3483,
        6152
      ],
      [
        75,
        7
      ],
      [
        6,
        -34
      ],
      [
        34,
        -4
      ],
      [
        37,
        -35
      ],
      [
        -37,
        5
      ],
      [
        -98,
        -24
      ],
      [
        44,
        -26
      ],
      [
        -28,
        -26
      ]
    ],
    [
      [
        2796,
        5242
      ],
      [
        37,
        39
      ],
      [
        93,
        31
      ],
      [
        66,
        -17
      ],
      [
        38,
        -25
      ],
      [
        35,
        -65
      ],
      [
        -13,
        -12
      ],
      [
        43,
        -24
      ],
      [
        -24,
        -39
      ],
      [
        27,
        -22
      ],
      [
        14,
        -40
      ],
      [
        -40,
        -15
      ],
      [
        -46,
        -4
      ],
      [
        -100,
        11
      ],
      [
        -82,
        32
      ],
      [
        -14,
        50
      ],
      [
        14,
        12
      ],
      [
        -45,
        36
      ],
      [
        -3,
        52
      ]
    ],
    [
      [
        3109,
        5455
      ],
      [
        32,
        -30
      ],
      [
        38,
        -66
      ],
      [
        -18,
        -22
      ],
      [
        20,
        -19
      ],
      [
        -106,
        51
      ],
      [
        -25,
        52
      ],
      [
        -35,
        13
      ],
      [
        -25,
        50
      ],
      [
        34,
        9
      ],
      [
        85,
        -38
      ]
    ],
    [
      [
        1970,
        5224
      ],
      [
        -48,
        -40
      ],
      [
        -49,
        0
      ],
      [
        -8,
        41
      ],
      [
        76,
        30
      ],
      [
        -34,
        40
      ],
      [
        -49,
        10
      ],
      [
        5,
        17
      ],
      [
        72,
        39
      ],
      [
        -52,
        9
      ],
      [
        -48,
        -12
      ],
      [
        -37,
        -46
      ],
      [
        -78,
        -44
      ],
      [
        -41,
        6
      ],
      [
        10,
        53
      ],
      [
        45,
        34
      ],
      [
        -34,
        13
      ],
      [
        30,
        46
      ],
      [
        123,
        44
      ],
      [
        -7,
        -34
      ],
      [
        199,
        82
      ],
      [
        20,
        -11
      ],
      [
        18,
        -90
      ],
      [
        3,
        -28
      ],
      [
        49,
        -32
      ],
      [
        27,
        -76
      ],
      [
        -83,
        -38
      ],
      [
        -109,
        -13
      ]
    ],
    [
      [
        2123,
        5391
      ],
      [
        -25,
        68
      ],
      [
        12,
        29
      ],
      [
        78,
        33
      ],
      [
        78,
        8
      ],
      [
        34,
        15
      ],
      [
        -95,
        -6
      ],
      [
        -3,
        35
      ],
      [
        59,
        44
      ],
      [
        52,
        12
      ],
      [
        128,
        66
      ],
      [
        52,
        5
      ],
      [
        5,
        -32
      ],
      [
        -51,
        -32
      ],
      [
        -41,
        -51
      ],
      [
        -84,
        -87
      ],
      [
        -22,
        -36
      ],
      [
        -59,
        -26
      ],
      [
        -18,
        -49
      ],
      [
        -64,
        -8
      ],
      [
        -36,
        12
      ]
    ],
    [
      [
        1438,
        6039
      ],
      [
        -61,
        -4
      ],
      [
        -1,
        -15
      ],
      [
        -65,
        -16
      ],
      [
        -11,
        -33
      ],
      [
        -85,
        15
      ],
      [
        -25,
        40
      ],
      [
        150,
        28
      ],
      [
        99,
        12
      ],
      [
        -1,
        -27
      ]
    ],
    [
      [
        2466,
        6014
      ],
      [
        67,
        -57
      ],
      [
        -34,
        6
      ],
      [
        31,
        -32
      ],
      [
        -82,
        2
      ],
      [
        -46,
        -26
      ],
      [
        89,
        2
      ],
      [
        -24,
        -21
      ],
      [
        -89,
        -31
      ],
      [
        -73,
        6
      ],
      [
        20,
        30
      ],
      [
        -54,
        -21
      ],
      [
        -233,
        -47
      ],
      [
        -94,
        0
      ],
      [
        -27,
        -19
      ],
      [
        -61,
        13
      ],
      [
        -38,
        41
      ],
      [
        30,
        21
      ],
      [
        45,
        1
      ],
      [
        45,
        -31
      ],
      [
        14,
        23
      ],
      [
        46,
        -6
      ],
      [
        103,
        20
      ],
      [
        64,
        27
      ],
      [
        -159,
        -20
      ],
      [
        -24,
        19
      ],
      [
        45,
        24
      ],
      [
        23,
        32
      ],
      [
        114,
        20
      ],
      [
        5,
        36
      ],
      [
        -111,
        -27
      ],
      [
        -69,
        45
      ],
      [
        -93,
        8
      ],
      [
        -50,
        19
      ],
      [
        48,
        18
      ],
      [
        -35,
        31
      ],
      [
        69,
        12
      ],
      [
        34,
        -6
      ],
      [
        31,
        29
      ],
      [
        73,
        9
      ],
      [
        62,
        -13
      ],
      [
        24,
        -20
      ],
      [
        81,
        -87
      ],
      [
        101,
        1
      ],
      [
        132,
        -31
      ]
    ],
    [
      [
        1731,
        6195
      ],
      [
        -39,
        -44
      ],
      [
        -73,
        -38
      ],
      [
        -53,
        -22
      ],
      [
        -86,
        10
      ],
      [
        55,
        15
      ],
      [
        57,
        46
      ],
      [
        86,
        30
      ],
      [
        53,
        3
      ]
    ],
    [
      [
        7274,
        799
      ],
      [
        -82,
        1
      ],
      [
        47,
        37
      ],
      [
        26,
        -11
      ],
      [
        9,
        -27
      ]
    ],
    [
      [
        7218,
        853
      ],
      [
        -26,
        -3
      ],
      [
        -36,
        -55
      ],
      [
        -48,
        11
      ],
      [
        34,
        44
      ],
      [
        -19,
        6
      ]
    ],
    [
      [
        7123,
        856
      ],
      [
        14,
        7
      ],
      [
        81,
        -10
      ]
    ],
    [
      [
        1182,
        7317
      ],
      [
        -11,
        -23
      ],
      [
        -36,
        11
      ],
      [
        30,
        18
      ],
      [
        17,
        -6
      ]
    ],
    [
      [
        1319,
        7626
      ],
      [
        72,
        -39
      ],
      [
        -70,
        5
      ],
      [
        -26,
        29
      ],
      [
        24,
        5
      ]
    ],
    [
      [
        742,
        6502
      ],
      [
        55,
        -34
      ],
      [
        -95,
        -42
      ],
      [
        -82,
        11
      ],
      [
        41,
        26
      ],
      [
        -8,
        26
      ],
      [
        67,
        20
      ],
      [
        9,
        25
      ],
      [
        34,
        -13
      ],
      [
        -21,
        -19
      ]
    ],
    [
      [
        873,
        6784
      ],
      [
        62,
        -7
      ],
      [
        44,
        -31
      ],
      [
        -33,
        -15
      ],
      [
        -24,
        -35
      ],
      [
        -97,
        6
      ],
      [
        83,
        -25
      ],
      [
        13,
        -32
      ],
      [
        -20,
        -30
      ],
      [
        63,
        -31
      ],
      [
        -24,
        -12
      ],
      [
        -83,
        8
      ],
      [
        -32,
        -9
      ],
      [
        -38,
        27
      ],
      [
        -25,
        48
      ],
      [
        1,
        32
      ],
      [
        -41,
        18
      ],
      [
        66,
        69
      ],
      [
        -39,
        69
      ],
      [
        76,
        19
      ],
      [
        90,
        -31
      ],
      [
        41,
        -31
      ],
      [
        -28,
        -8
      ],
      [
        -82,
        27
      ],
      [
        -39,
        24
      ],
      [
        0,
        -29
      ],
      [
        66,
        -21
      ]
    ],
    [
      [
        783,
        6877
      ],
      [
        -12,
        10
      ],
      [
        37,
        40
      ],
      [
        78,
        -3
      ],
      [
        91,
        -21
      ],
      [
        -61,
        -13
      ],
      [
        57,
        -28
      ],
      [
        -86,
        -12
      ],
      [
        -104,
        27
      ]
    ],
    [
      [
        1073,
        7022
      ],
      [
        -44,
        -29
      ],
      [
        -80,
        -8
      ],
      [
        -27,
        19
      ],
      [
        -56,
        -26
      ],
      [
        132,
        9
      ],
      [
        47,
        -15
      ],
      [
        -24,
        -25
      ],
      [
        -130,
        -1
      ],
      [
        -30,
        7
      ],
      [
        -33,
        34
      ],
      [
        -93,
        23
      ],
      [
        -21,
        -12
      ],
      [
        -82,
        24
      ],
      [
        69,
        63
      ],
      [
        90,
        0
      ],
      [
        -9,
        -24
      ],
      [
        84,
        49
      ],
      [
        -20,
        -25
      ],
      [
        55,
        0
      ],
      [
        97,
        24
      ],
      [
        -8,
        -30
      ],
      [
        97,
        -3
      ],
      [
        27,
        -16
      ],
      [
        -33,
        -25
      ],
      [
        -73,
        31
      ],
      [
        -46,
        0
      ],
      [
        16,
        -25
      ],
      [
        47,
        -24
      ],
      [
        48,
        5
      ]
    ],
    [
      [
        2017,
        7711
      ],
      [
        -82,
        -30
      ],
      [
        -4,
        -18
      ],
      [
        -65,
        -24
      ],
      [
        0,
        -21
      ],
      [
        -49,
        -7
      ],
      [
        56,
        -20
      ],
      [
        68,
        7
      ],
      [
        83,
        33
      ],
      [
        0,
        -38
      ],
      [
        -54,
        -26
      ],
      [
        -125,
        7
      ],
      [
        -62,
        12
      ],
      [
        35,
        -43
      ],
      [
        -7,
        -20
      ],
      [
        -69,
        -12
      ],
      [
        -49,
        -25
      ],
      [
        -34,
        6
      ],
      [
        -96,
        -25
      ],
      [
        37,
        0
      ],
      [
        190,
        21
      ],
      [
        42,
        -58
      ],
      [
        -73,
        -32
      ],
      [
        -121,
        12
      ],
      [
        -6,
        -6
      ],
      [
        96,
        -31
      ],
      [
        -52,
        -37
      ],
      [
        -45,
        7
      ],
      [
        14,
        -20
      ],
      [
        -42,
        -4
      ],
      [
        -41,
        34
      ],
      [
        8,
        -31
      ],
      [
        -40,
        3
      ],
      [
        -49,
        47
      ],
      [
        -8,
        26
      ],
      [
        43,
        37
      ],
      [
        74,
        13
      ],
      [
        -97,
        0
      ],
      [
        -4,
        -16
      ],
      [
        -72,
        -34
      ],
      [
        35,
        -38
      ],
      [
        57,
        -31
      ],
      [
        12,
        -44
      ],
      [
        -117,
        20
      ],
      [
        -28,
        -20
      ],
      [
        41,
        -11
      ],
      [
        28,
        -26
      ],
      [
        -104,
        -25
      ],
      [
        -54,
        -42
      ],
      [
        -88,
        -29
      ],
      [
        -121,
        70
      ],
      [
        22,
        1
      ],
      [
        118,
        52
      ],
      [
        49,
        -2
      ],
      [
        -49,
        25
      ],
      [
        51,
        15
      ],
      [
        61,
        0
      ],
      [
        13,
        22
      ],
      [
        -59,
        1
      ],
      [
        -55,
        19
      ],
      [
        -86,
        3
      ],
      [
        -76,
        28
      ],
      [
        54,
        32
      ],
      [
        125,
        25
      ],
      [
        -124,
        -14
      ],
      [
        34,
        38
      ],
      [
        -52,
        -16
      ],
      [
        -52,
        57
      ],
      [
        35,
        40
      ],
      [
        -20,
        13
      ],
      [
        96,
        7
      ],
      [
        -38,
        10
      ],
      [
        24,
        40
      ],
      [
        124,
        -25
      ],
      [
        -29,
        -6
      ],
      [
        49,
        -38
      ],
      [
        18,
        18
      ],
      [
        73,
        12
      ],
      [
        60,
        -31
      ],
      [
        29,
        19
      ],
      [
        -45,
        33
      ],
      [
        -30,
        5
      ],
      [
        -36,
        50
      ],
      [
        104,
        50
      ],
      [
        96,
        10
      ],
      [
        277,
        103
      ],
      [
        78,
        45
      ],
      [
        62,
        -28
      ],
      [
        39,
        -57
      ],
      [
        -48,
        -48
      ],
      [
        47,
        -19
      ]
    ],
    [
      [
        2010,
        4929
      ],
      [
        -37,
        -8
      ],
      [
        -73,
        2
      ],
      [
        49,
        12
      ],
      [
        61,
        -6
      ]
    ],
    [
      [
        2083,
        4639
      ],
      [
        -38,
        -1
      ],
      [
        -53,
        39
      ]
    ],
    [
      [
        1992,
        4677
      ],
      [
        -37,
        37
      ],
      [
        2,
        47
      ],
      [
        -97,
        -15
      ],
      [
        -55,
        31
      ],
      [
        -48,
        -11
      ],
      [
        -10,
        15
      ],
      [
        -80,
        6
      ]
    ],
    [
      [
        1667,
        4787
      ],
      [
        -16,
        57
      ],
      [
        -14,
        13
      ]
    ],
    [
      [
        1637,
        4857
      ],
      [
        70,
        22
      ],
      [
        60,
        -16
      ],
      [
        38,
        13
      ],
      [
        124,
        -32
      ],
      [
        96,
        10
      ],
      [
        59,
        -9
      ],
      [
        63,
        -40
      ],
      [
        -16,
        -95
      ],
      [
        73,
        -8
      ]
    ],
    [
      [
        2204,
        4702
      ],
      [
        -31,
        -20
      ],
      [
        -90,
        -43
      ]
    ],
    [
      [
        1896,
        0
      ],
      [
        -21,
        0
      ],
      [
        10,
        19
      ],
      [
        15,
        -11
      ],
      [
        -4,
        -8
      ]
    ],
    [
      [
        4750,
        5563
      ],
      [
        119,
        -3
      ],
      [
        27,
        -15
      ],
      [
        183,
        -8
      ],
      [
        44,
        -20
      ]
    ],
    [
      [
        5123,
        5517
      ],
      [
        -9,
        -51
      ],
      [
        -103,
        -8
      ],
      [
        -171,
        -65
      ]
    ],
    [
      [
        4840,
        5393
      ],
      [
        -28,
        8
      ],
      [
        -8,
        -3
      ]
    ],
    [
      [
        4804,
        5398
      ],
      [
        2,
        69
      ],
      [
        -56,
        21
      ],
      [
        0,
        75
      ]
    ],
    [
      [
        7148,
        2452
      ],
      [
        -58,
        -27
      ],
      [
        -45,
        9
      ],
      [
        -13,
        57
      ],
      [
        20,
        16
      ],
      [
        88,
        -7
      ],
      [
        8,
        -48
      ]
    ],
    [
      [
        6626,
        2534
      ],
      [
        48,
        19
      ],
      [
        3,
        40
      ],
      [
        57,
        -1
      ],
      [
        81,
        38
      ],
      [
        25,
        38
      ],
      [
        69,
        28
      ],
      [
        39,
        0
      ]
    ],
    [
      [
        6948,
        2696
      ],
      [
        3,
        -58
      ],
      [
        72,
        -24
      ],
      [
        89,
        32
      ],
      [
        121,
        0
      ],
      [
        10,
        17
      ],
      [
        121,
        61
      ],
      [
        30,
        44
      ],
      [
        52,
        19
      ]
    ],
    [
      [
        7446,
        2787
      ],
      [
        24,
        -31
      ],
      [
        -20,
        -30
      ],
      [
        41,
        -27
      ],
      [
        47,
        -54
      ],
      [
        25,
        -54
      ]
    ],
    [
      [
        7563,
        2591
      ],
      [
        -77,
        -28
      ],
      [
        -77,
        -7
      ],
      [
        4,
        -104
      ],
      [
        35,
        -57
      ],
      [
        35,
        -24
      ]
    ],
    [
      [
        7483,
        2371
      ],
      [
        -141,
        -1
      ],
      [
        -14,
        -54
      ],
      [
        -78,
        16
      ],
      [
        -71,
        -18
      ],
      [
        -13,
        -39
      ],
      [
        -55,
        21
      ],
      [
        -56,
        -43
      ],
      [
        -30,
        3
      ]
    ],
    [
      [
        7025,
        2256
      ],
      [
        -107,
        90
      ],
      [
        -104,
        30
      ],
      [
        -21,
        21
      ],
      [
        -129,
        42
      ],
      [
        -14,
        37
      ],
      [
        26,
        19
      ],
      [
        -47,
        31
      ]
    ],
    [
      [
        6629,
        2526
      ],
      [
        -3,
        8
      ]
    ],
    [
      [
        6626,
        2534
      ],
      [
        -57,
        0
      ],
      [
        -7,
        19
      ],
      [
        -54,
        19
      ],
      [
        28,
        29
      ],
      [
        44,
        12
      ],
      [
        38,
        36
      ],
      [
        -40,
        28
      ],
      [
        -91,
        4
      ],
      [
        -34,
        19
      ],
      [
        -69,
        8
      ],
      [
        -17,
        45
      ],
      [
        29,
        34
      ],
      [
        55,
        19
      ],
      [
        -14,
        99
      ],
      [
        -29,
        46
      ],
      [
        -57,
        33
      ],
      [
        -120,
        27
      ]
    ],
    [
      [
        6231,
        3011
      ],
      [
        -15,
        32
      ],
      [
        -7,
        86
      ],
      [
        -19,
        32
      ]
    ],
    [
      [
        6190,
        3161
      ],
      [
        35,
        25
      ],
      [
        -30,
        13
      ]
    ],
    [
      [
        6195,
        3199
      ],
      [
        30,
        29
      ],
      [
        4,
        23
      ]
    ],
    [
      [
        6229,
        3251
      ],
      [
        15,
        23
      ],
      [
        44,
        6
      ],
      [
        22,
        29
      ]
    ],
    [
      [
        6310,
        3309
      ],
      [
        27,
        -1
      ],
      [
        54,
        -14
      ]
    ],
    [
      [
        6391,
        3294
      ],
      [
        29,
        -43
      ],
      [
        57,
        -26
      ],
      [
        -3,
        -27
      ],
      [
        88,
        -31
      ],
      [
        -3,
        -23
      ],
      [
        68,
        -23
      ],
      [
        -32,
        -17
      ],
      [
        84,
        -17
      ],
      [
        138,
        33
      ]
    ],
    [
      [
        6817,
        3120
      ],
      [
        60,
        -25
      ],
      [
        22,
        14
      ],
      [
        70,
        -21
      ],
      [
        66,
        2
      ]
    ],
    [
      [
        7035,
        3090
      ],
      [
        16,
        -28
      ],
      [
        -36,
        -27
      ],
      [
        5,
        -59
      ],
      [
        -86,
        -13
      ],
      [
        -36,
        -21
      ],
      [
        21,
        -43
      ],
      [
        -38,
        -31
      ],
      [
        8,
        -34
      ],
      [
        38,
        -25
      ],
      [
        13,
        -79
      ],
      [
        39,
        -17
      ],
      [
        -31,
        -17
      ]
    ],
    [
      [
        6789,
        2687
      ],
      [
        19,
        53
      ],
      [
        -86,
        25
      ],
      [
        -59,
        -56
      ],
      [
        53,
        -26
      ],
      [
        73,
        4
      ]
    ],
    [
      [
        1702,
        4452
      ],
      [
        92,
        -5
      ],
      [
        36,
        17
      ],
      [
        141,
        -12
      ],
      [
        61,
        23
      ],
      [
        69,
        -15
      ]
    ],
    [
      [
        2101,
        4460
      ],
      [
        38,
        -15
      ],
      [
        -17,
        -24
      ],
      [
        23,
        -31
      ],
      [
        -11,
        -40
      ],
      [
        28,
        -8
      ]
    ],
    [
      [
        2162,
        4342
      ],
      [
        -39,
        -11
      ],
      [
        -3,
        -25
      ]
    ],
    [
      [
        2120,
        4306
      ],
      [
        -73,
        -4
      ],
      [
        -92,
        -25
      ],
      [
        -34,
        1
      ]
    ],
    [
      [
        1921,
        4278
      ],
      [
        -70,
        6
      ],
      [
        -104,
        -27
      ]
    ],
    [
      [
        1747,
        4257
      ],
      [
        16,
        78
      ],
      [
        -79,
        47
      ]
    ],
    [
      [
        1684,
        4382
      ],
      [
        29,
        56
      ],
      [
        -11,
        14
      ]
    ],
    [
      [
        1702,
        4452
      ],
      [
        10,
        41
      ],
      [
        -37,
        81
      ]
    ],
    [
      [
        1675,
        4574
      ],
      [
        75,
        -5
      ],
      [
        10,
        26
      ],
      [
        -28,
        20
      ],
      [
        59,
        14
      ],
      [
        65,
        0
      ],
      [
        3,
        25
      ],
      [
        38,
        -2
      ],
      [
        95,
        25
      ]
    ],
    [
      [
        2083,
        4639
      ],
      [
        79,
        -48
      ],
      [
        -16,
        -34
      ],
      [
        12,
        -35
      ],
      [
        63,
        -3
      ],
      [
        5,
        -32
      ],
      [
        -60,
        -2
      ],
      [
        13,
        -18
      ]
    ],
    [
      [
        2179,
        4467
      ],
      [
        -78,
        -7
      ]
    ],
    [
      [
        7069,
        2724
      ],
      [
        -59,
        -12
      ],
      [
        -28,
        33
      ],
      [
        11,
        49
      ],
      [
        27,
        21
      ],
      [
        55,
        -9
      ],
      [
        32,
        -58
      ],
      [
        -38,
        -24
      ]
    ],
    [
      [
        4008,
        468
      ],
      [
        28,
        30
      ],
      [
        -44,
        -7
      ]
    ],
    [
      [
        3992,
        491
      ],
      [
        -33,
        11
      ],
      [
        19,
        29
      ],
      [
        27,
        0
      ],
      [
        -27,
        35
      ],
      [
        -53,
        9
      ],
      [
        -32,
        41
      ],
      [
        6,
        35
      ],
      [
        -39,
        15
      ],
      [
        -27,
        46
      ],
      [
        -16,
        66
      ],
      [
        -36,
        -4
      ],
      [
        -67,
        29
      ],
      [
        30,
        6
      ],
      [
        32,
        52
      ],
      [
        -40,
        60
      ],
      [
        -91,
        2
      ]
    ],
    [
      [
        3645,
        923
      ],
      [
        26,
        45
      ],
      [
        -4,
        39
      ],
      [
        90,
        -1
      ],
      [
        100,
        -16
      ],
      [
        35,
        10
      ],
      [
        95,
        63
      ],
      [
        -48,
        68
      ],
      [
        33,
        -1
      ],
      [
        -6,
        39
      ],
      [
        77,
        17
      ],
      [
        313,
        21
      ],
      [
        73,
        13
      ],
      [
        57,
        -9
      ]
    ],
    [
      [
        4486,
        1211
      ],
      [
        -12,
        -55
      ],
      [
        -98,
        -1
      ],
      [
        -4,
        -32
      ],
      [
        110,
        -54
      ],
      [
        37,
        -1
      ],
      [
        91,
        -25
      ],
      [
        -11,
        -39
      ],
      [
        70,
        -4
      ],
      [
        54,
        26
      ],
      [
        96,
        -17
      ],
      [
        9,
        -33
      ],
      [
        50,
        -2
      ],
      [
        53,
        -29
      ],
      [
        113,
        1
      ],
      [
        -21,
        -31
      ],
      [
        31,
        -16
      ],
      [
        100,
        8
      ],
      [
        17,
        -50
      ],
      [
        68,
        -1
      ],
      [
        14,
        -25
      ]
    ],
    [
      [
        5253,
        831
      ],
      [
        68,
        -23
      ],
      [
        -66,
        -24
      ],
      [
        1,
        -42
      ]
    ],
    [
      [
        5256,
        742
      ],
      [
        -53,
        -16
      ],
      [
        -61,
        5
      ],
      [
        -57,
        -23
      ],
      [
        -51,
        4
      ],
      [
        -94,
        -17
      ],
      [
        -36,
        -33
      ],
      [
        -73,
        -19
      ],
      [
        -38,
        4
      ],
      [
        -53,
        51
      ],
      [
        26,
        -61
      ],
      [
        -61,
        -57
      ],
      [
        -11,
        -37
      ]
    ],
    [
      [
        4694,
        543
      ],
      [
        -82,
        1
      ],
      [
        -56,
        -41
      ],
      [
        -7,
        -29
      ],
      [
        30,
        -24
      ],
      [
        101,
        -28
      ]
    ],
    [
      [
        4680,
        422
      ],
      [
        -20,
        -28
      ],
      [
        -94,
        -30
      ],
      [
        -21,
        -56
      ],
      [
        7,
        -22
      ],
      [
        -72,
        -13
      ],
      [
        -72,
        0
      ],
      [
        -162,
        98
      ],
      [
        -83,
        -23
      ],
      [
        -83,
        48
      ]
    ],
    [
      [
        4080,
        396
      ],
      [
        77,
        29
      ],
      [
        -2,
        18
      ],
      [
        -84,
        34
      ],
      [
        -63,
        -9
      ]
    ],
    [
      [
        4401,
        6416
      ],
      [
        108,
        -9
      ],
      [
        27,
        8
      ],
      [
        92,
        -7
      ],
      [
        2,
        -25
      ],
      [
        66,
        -4
      ],
      [
        42,
        -13
      ],
      [
        66,
        6
      ]
    ],
    [
      [
        4804,
        6372
      ],
      [
        3,
        -27
      ],
      [
        37,
        -51
      ],
      [
        20,
        -67
      ],
      [
        74,
        -49
      ],
      [
        107,
        -20
      ],
      [
        26,
        -29
      ],
      [
        46,
        -9
      ],
      [
        -59,
        -34
      ],
      [
        -28,
        -48
      ],
      [
        24,
        -24
      ],
      [
        68,
        -14
      ]
    ],
    [
      [
        5122,
        6000
      ],
      [
        13,
        -6
      ],
      [
        11,
        -15
      ]
    ],
    [
      [
        5146,
        5979
      ],
      [
        -79,
        -23
      ],
      [
        -129,
        -68
      ]
    ],
    [
      [
        4938,
        5888
      ],
      [
        20,
        -36
      ],
      [
        -48,
        -10
      ],
      [
        -10,
        -19
      ],
      [
        -64,
        -15
      ],
      [
        16,
        -26
      ],
      [
        59,
        -4
      ],
      [
        28,
        -33
      ],
      [
        -36,
        -10
      ],
      [
        6,
        -21
      ],
      [
        -69,
        0
      ],
      [
        -27,
        -24
      ],
      [
        -143,
        5
      ],
      [
        -22,
        9
      ],
      [
        -80,
        -21
      ]
    ],
    [
      [
        4568,
        5683
      ],
      [
        -12,
        24
      ],
      [
        80,
        20
      ],
      [
        -49,
        19
      ],
      [
        -112,
        -7
      ],
      [
        -36,
        24
      ],
      [
        -66,
        -22
      ]
    ],
    [
      [
        4373,
        5741
      ],
      [
        -19,
        24
      ],
      [
        -35,
        -4
      ],
      [
        -119,
        51
      ],
      [
        -79,
        5
      ],
      [
        -96,
        23
      ],
      [
        -49,
        27
      ],
      [
        -4,
        46
      ],
      [
        37,
        10
      ],
      [
        -1,
        60
      ],
      [
        92,
        10
      ],
      [
        -26,
        32
      ],
      [
        -55,
        7
      ],
      [
        -108,
        -27
      ],
      [
        -40,
        48
      ],
      [
        -278,
        -38
      ],
      [
        -39,
        -19
      ]
    ],
    [
      [
        3554,
        5997
      ],
      [
        -38,
        18
      ]
    ],
    [
      [
        3676,
        5346
      ],
      [
        1,
        3
      ]
    ],
    [
      [
        3677,
        5349
      ],
      [
        76,
        22
      ],
      [
        84,
        29
      ]
    ],
    [
      [
        3837,
        5400
      ],
      [
        10,
        -23
      ],
      [
        91,
        9
      ],
      [
        16,
        -10
      ]
    ],
    [
      [
        3954,
        5376
      ],
      [
        -18,
        -29
      ],
      [
        34,
        -24
      ],
      [
        0,
        -40
      ],
      [
        -26,
        -5
      ]
    ],
    [
      [
        3944,
        5278
      ],
      [
        -257,
        60
      ],
      [
        -11,
        8
      ]
    ],
    [
      [
        3944,
        5278
      ],
      [
        78,
        -80
      ],
      [
        -33,
        -24
      ],
      [
        10,
        -18
      ],
      [
        132,
        1
      ],
      [
        72,
        16
      ],
      [
        32,
        -28
      ],
      [
        -22,
        -73
      ]
    ],
    [
      [
        4213,
        5072
      ],
      [
        -20,
        -24
      ],
      [
        -91,
        -35
      ],
      [
        7,
        -45
      ],
      [
        -49,
        -57
      ],
      [
        -54,
        27
      ],
      [
        -108,
        -6
      ],
      [
        -53,
        -41
      ],
      [
        -54,
        -100
      ],
      [
        -29,
        -10
      ],
      [
        -5,
        30
      ],
      [
        -30,
        -16
      ]
    ],
    [
      [
        3727,
        4795
      ],
      [
        23,
        40
      ],
      [
        -1,
        73
      ],
      [
        -89,
        53
      ],
      [
        -44,
        38
      ],
      [
        9,
        15
      ],
      [
        103,
        -10
      ],
      [
        -14,
        66
      ],
      [
        47,
        23
      ],
      [
        -10,
        56
      ],
      [
        -141,
        43
      ]
    ],
    [
      [
        3610,
        5192
      ],
      [
        74,
        27
      ],
      [
        9,
        23
      ],
      [
        -110,
        10
      ],
      [
        -8,
        18
      ],
      [
        59,
        34
      ],
      [
        42,
        42
      ]
    ],
    [
      [
        3837,
        5400
      ],
      [
        1,
        12
      ],
      [
        1,
        29
      ]
    ],
    [
      [
        3839,
        5441
      ],
      [
        0,
        23
      ],
      [
        4,
        15
      ]
    ],
    [
      [
        3843,
        5479
      ],
      [
        57,
        -6
      ],
      [
        26,
        16
      ],
      [
        55,
        -24
      ],
      [
        53,
        1
      ]
    ],
    [
      [
        4034,
        5466
      ],
      [
        43,
        -21
      ],
      [
        40,
        0
      ],
      [
        -6,
        -38
      ]
    ],
    [
      [
        4111,
        5407
      ],
      [
        -92,
        4
      ],
      [
        -25,
        -43
      ],
      [
        -40,
        8
      ]
    ],
    [
      [
        3843,
        5479
      ],
      [
        -8,
        6
      ],
      [
        -6,
        58
      ]
    ],
    [
      [
        3829,
        5543
      ],
      [
        91,
        -15
      ],
      [
        -2,
        60
      ],
      [
        103,
        -13
      ],
      [
        31,
        16
      ],
      [
        17,
        -21
      ]
    ],
    [
      [
        4069,
        5570
      ],
      [
        6,
        -39
      ],
      [
        73,
        -5
      ],
      [
        3,
        -30
      ],
      [
        -25,
        -15
      ],
      [
        -81,
        2
      ],
      [
        -11,
        -17
      ]
    ],
    [
      [
        3303,
        5442
      ],
      [
        16,
        66
      ],
      [
        87,
        18
      ],
      [
        63,
        -15
      ],
      [
        97,
        -10
      ]
    ],
    [
      [
        3566,
        5501
      ],
      [
        36,
        -44
      ],
      [
        -18,
        -36
      ],
      [
        -119,
        6
      ],
      [
        -24,
        8
      ]
    ],
    [
      [
        3441,
        5435
      ],
      [
        -25,
        11
      ],
      [
        -113,
        -4
      ]
    ],
    [
      [
        3610,
        5192
      ],
      [
        -67,
        -26
      ],
      [
        -17,
        -1
      ]
    ],
    [
      [
        3526,
        5165
      ],
      [
        -4,
        20
      ],
      [
        -52,
        32
      ],
      [
        -96,
        17
      ],
      [
        8,
        15
      ],
      [
        -112,
        50
      ],
      [
        60,
        44
      ],
      [
        -27,
        99
      ]
    ],
    [
      [
        3441,
        5435
      ],
      [
        36,
        -41
      ],
      [
        82,
        -42
      ],
      [
        118,
        -3
      ]
    ],
    [
      [
        4069,
        5570
      ],
      [
        44,
        19
      ],
      [
        65,
        0
      ],
      [
        7,
        -12
      ]
    ],
    [
      [
        4185,
        5577
      ],
      [
        39,
        -6
      ],
      [
        51,
        -44
      ],
      [
        57,
        -2
      ],
      [
        -30,
        -21
      ],
      [
        87,
        -34
      ]
    ],
    [
      [
        4389,
        5470
      ],
      [
        15,
        -22
      ],
      [
        66,
        11
      ],
      [
        -17,
        -23
      ],
      [
        26,
        -42
      ],
      [
        -15,
        -27
      ]
    ],
    [
      [
        4464,
        5367
      ],
      [
        -149,
        -46
      ],
      [
        -15,
        2
      ],
      [
        -169,
        71
      ],
      [
        -20,
        13
      ]
    ],
    [
      [
        3566,
        5501
      ],
      [
        121,
        -10
      ],
      [
        19,
        7
      ]
    ],
    [
      [
        3706,
        5498
      ],
      [
        47,
        -20
      ],
      [
        86,
        -37
      ]
    ],
    [
      [
        3727,
        4795
      ],
      [
        -72,
        3
      ],
      [
        -109,
        -37
      ],
      [
        16,
        -61
      ],
      [
        -70,
        -11
      ],
      [
        -100,
        2
      ],
      [
        -71,
        -7
      ],
      [
        -54,
        -35
      ],
      [
        -63,
        9
      ],
      [
        -46,
        -13
      ]
    ],
    [
      [
        3158,
        4645
      ],
      [
        -18,
        51
      ],
      [
        43,
        84
      ],
      [
        60,
        24
      ],
      [
        67,
        47
      ],
      [
        39,
        52
      ],
      [
        10,
        51
      ],
      [
        60,
        35
      ],
      [
        24,
        41
      ],
      [
        99,
        31
      ],
      [
        33,
        43
      ],
      [
        -49,
        61
      ]
    ],
    [
      [
        4464,
        5367
      ],
      [
        124,
        19
      ],
      [
        45,
        -15
      ],
      [
        108,
        -16
      ]
    ],
    [
      [
        4741,
        5355
      ],
      [
        22,
        -47
      ],
      [
        42,
        -10
      ],
      [
        -85,
        -54
      ],
      [
        1,
        -33
      ],
      [
        -50,
        -11
      ],
      [
        41,
        -37
      ],
      [
        2,
        -41
      ],
      [
        -28,
        -21
      ],
      [
        -22,
        -49
      ],
      [
        34,
        -26
      ]
    ],
    [
      [
        4698,
        5026
      ],
      [
        -67,
        -24
      ],
      [
        -4,
        -50
      ],
      [
        -72,
        -36
      ],
      [
        -59,
        28
      ],
      [
        -6,
        38
      ],
      [
        -36,
        9
      ],
      [
        -26,
        34
      ],
      [
        -56,
        34
      ],
      [
        -159,
        13
      ]
    ],
    [
      [
        3706,
        5498
      ],
      [
        6,
        2
      ],
      [
        -110,
        12
      ]
    ],
    [
      [
        3595,
        5636
      ],
      [
        78,
        -5
      ],
      [
        92,
        -28
      ],
      [
        -41,
        -12
      ],
      [
        12,
        -23
      ],
      [
        50,
        -25
      ],
      [
        43,
        0
      ]
    ],
    [
      [
        6164,
        6691
      ],
      [
        -27,
        -51
      ],
      [
        4,
        -68
      ]
    ],
    [
      [
        6141,
        6572
      ],
      [
        -39,
        10
      ],
      [
        -231,
        -27
      ],
      [
        -11,
        49
      ],
      [
        56,
        0
      ],
      [
        22,
        26
      ],
      [
        -33,
        50
      ],
      [
        32,
        19
      ],
      [
        61,
        0
      ],
      [
        34,
        -17
      ],
      [
        59,
        16
      ],
      [
        73,
        -7
      ]
    ],
    [
      [
        4519,
        6567
      ],
      [
        59,
        -12
      ],
      [
        193,
        0
      ],
      [
        83,
        7
      ],
      [
        23,
        21
      ],
      [
        -22,
        33
      ],
      [
        12,
        25
      ],
      [
        52,
        12
      ],
      [
        92,
        62
      ],
      [
        67,
        19
      ],
      [
        93,
        -10
      ],
      [
        64,
        55
      ],
      [
        -2,
        33
      ],
      [
        -37,
        34
      ],
      [
        -6,
        44
      ],
      [
        20,
        26
      ],
      [
        101,
        40
      ],
      [
        82,
        0
      ],
      [
        78,
        -14
      ],
      [
        27,
        22
      ],
      [
        -76,
        51
      ],
      [
        -43,
        44
      ],
      [
        2,
        64
      ]
    ],
    [
      [
        5381,
        7123
      ],
      [
        63,
        0
      ],
      [
        28,
        -13
      ],
      [
        73,
        8
      ],
      [
        133,
        -26
      ],
      [
        29,
        12
      ],
      [
        99,
        -13
      ],
      [
        70,
        5
      ],
      [
        55,
        19
      ],
      [
        64,
        -18
      ],
      [
        102,
        27
      ],
      [
        112,
        -1
      ],
      [
        25,
        -26
      ],
      [
        40,
        7
      ],
      [
        105,
        -63
      ],
      [
        29,
        -80
      ],
      [
        40,
        -26
      ],
      [
        1,
        -22
      ],
      [
        -71,
        -43
      ],
      [
        -21,
        -29
      ],
      [
        -104,
        -49
      ],
      [
        -26,
        -20
      ],
      [
        -63,
        -81
      ]
    ],
    [
      [
        6141,
        6572
      ],
      [
        -91,
        -73
      ],
      [
        -44,
        -66
      ],
      [
        13,
        -31
      ],
      [
        -33,
        -38
      ],
      [
        -49,
        -25
      ],
      [
        -68,
        -50
      ],
      [
        -100,
        -46
      ]
    ],
    [
      [
        5769,
        6243
      ],
      [
        -59,
        3
      ],
      [
        -41,
        25
      ],
      [
        -84,
        13
      ],
      [
        -50,
        37
      ],
      [
        15,
        57
      ],
      [
        -107,
        64
      ],
      [
        -47,
        0
      ],
      [
        -66,
        24
      ],
      [
        -57,
        -14
      ],
      [
        -98,
        2
      ],
      [
        -62,
        -24
      ],
      [
        -20,
        -44
      ],
      [
        -91,
        11
      ],
      [
        -77,
        19
      ],
      [
        -18,
        -27
      ],
      [
        -103,
        -17
      ]
    ],
    [
      [
        4459,
        5612
      ],
      [
        83,
        -38
      ],
      [
        79,
        7
      ],
      [
        73,
        -10
      ]
    ],
    [
      [
        4694,
        5571
      ],
      [
        -35,
        -18
      ],
      [
        -59,
        4
      ],
      [
        -69,
        -44
      ],
      [
        -52,
        -10
      ],
      [
        -90,
        -33
      ]
    ],
    [
      [
        4185,
        5577
      ],
      [
        90,
        22
      ],
      [
        184,
        13
      ]
    ],
    [
      [
        4360,
        5664
      ],
      [
        59,
        -23
      ],
      [
        40,
        -29
      ]
    ],
    [
      [
        4373,
        5741
      ],
      [
        -37,
        -57
      ],
      [
        24,
        -20
      ]
    ],
    [
      [
        4451,
        5632
      ],
      [
        -56,
        31
      ],
      [
        -35,
        1
      ]
    ],
    [
      [
        4568,
        5683
      ],
      [
        -1,
        -21
      ],
      [
        -85,
        -8
      ],
      [
        -31,
        -22
      ]
    ],
    [
      [
        5383,
        5997
      ],
      [
        -237,
        -18
      ]
    ],
    [
      [
        5122,
        6000
      ],
      [
        15,
        23
      ],
      [
        136,
        15
      ],
      [
        85,
        0
      ],
      [
        25,
        -41
      ]
    ],
    [
      [
        4938,
        5888
      ],
      [
        114,
        21
      ],
      [
        200,
        51
      ],
      [
        65,
        24
      ],
      [
        82,
        -27
      ],
      [
        -5,
        -34
      ],
      [
        -29,
        -23
      ],
      [
        69,
        -31
      ],
      [
        92,
        -3
      ],
      [
        101,
        -41
      ],
      [
        -72,
        -51
      ],
      [
        -72,
        -10
      ],
      [
        -63,
        -23
      ],
      [
        -48,
        -1
      ],
      [
        -62,
        16
      ],
      [
        -73,
        -3
      ],
      [
        -127,
        -67
      ],
      [
        -37,
        -8
      ],
      [
        -51,
        -60
      ],
      [
        -70,
        -1
      ],
      [
        -95,
        -26
      ],
      [
        -79,
        -3
      ],
      [
        -162,
        25
      ],
      [
        -90,
        -1
      ],
      [
        -75,
        20
      ]
    ],
    [
      [
        5123,
        5517
      ],
      [
        17,
        1
      ]
    ],
    [
      [
        5140,
        5518
      ],
      [
        34,
        -34
      ],
      [
        207,
        -82
      ]
    ],
    [
      [
        5381,
        5402
      ],
      [
        -65,
        -30
      ],
      [
        -47,
        -2
      ],
      [
        -10,
        27
      ],
      [
        -132,
        -59
      ],
      [
        -47,
        -36
      ],
      [
        -64,
        82
      ],
      [
        -45,
        -23
      ],
      [
        -40,
        -3
      ],
      [
        -91,
        35
      ]
    ],
    [
      [
        4694,
        5571
      ],
      [
        56,
        -8
      ]
    ],
    [
      [
        4804,
        5398
      ],
      [
        -39,
        -18
      ],
      [
        -24,
        -25
      ]
    ],
    [
      [
        5381,
        5402
      ],
      [
        41,
        15
      ],
      [
        45,
        -9
      ],
      [
        82,
        19
      ],
      [
        60,
        -19
      ],
      [
        62,
        26
      ],
      [
        108,
        7
      ],
      [
        26,
        21
      ],
      [
        -36,
        7
      ],
      [
        75,
        53
      ]
    ],
    [
      [
        5844,
        5522
      ],
      [
        53,
        -16
      ],
      [
        162,
        -16
      ],
      [
        19,
        -25
      ],
      [
        48,
        -19
      ],
      [
        59,
        -59
      ]
    ],
    [
      [
        6185,
        5387
      ],
      [
        -57,
        -13
      ],
      [
        -14,
        -31
      ],
      [
        -71,
        -31
      ],
      [
        -79,
        -66
      ],
      [
        -65,
        -5
      ],
      [
        -21,
        -18
      ],
      [
        49,
        -33
      ],
      [
        22,
        -37
      ],
      [
        74,
        -79
      ],
      [
        -29,
        -26
      ],
      [
        -114,
        -33
      ],
      [
        -35,
        -33
      ],
      [
        -104,
        -1
      ],
      [
        -89,
        -43
      ],
      [
        -74,
        -47
      ],
      [
        -5,
        -36
      ],
      [
        -54,
        -29
      ]
    ],
    [
      [
        5519,
        4826
      ],
      [
        -35,
        -22
      ],
      [
        -104,
        -30
      ],
      [
        -28,
        -21
      ]
    ],
    [
      [
        5352,
        4753
      ],
      [
        -39,
        40
      ],
      [
        17,
        98
      ],
      [
        -73,
        23
      ],
      [
        -53,
        -18
      ],
      [
        -37,
        5
      ],
      [
        -70,
        72
      ],
      [
        -61,
        -2
      ],
      [
        -43,
        21
      ],
      [
        -97,
        -27
      ],
      [
        0,
        38
      ],
      [
        63,
        31
      ],
      [
        -75,
        17
      ],
      [
        -29,
        -23
      ],
      [
        -100,
        -7
      ],
      [
        -57,
        5
      ]
    ],
    [
      [
        6870,
        4534
      ],
      [
        44,
        -84
      ],
      [
        51,
        -50
      ]
    ],
    [
      [
        6965,
        4400
      ],
      [
        -48,
        -13
      ],
      [
        -32,
        -27
      ],
      [
        -8,
        -31
      ],
      [
        -56,
        -20
      ]
    ],
    [
      [
        6821,
        4309
      ],
      [
        -7,
        -10
      ],
      [
        -17,
        -14
      ]
    ],
    [
      [
        6797,
        4285
      ],
      [
        -71,
        -25
      ],
      [
        -89,
        0
      ],
      [
        -57,
        21
      ],
      [
        -43,
        -4
      ],
      [
        -10,
        -55
      ]
    ],
    [
      [
        6527,
        4222
      ],
      [
        -86,
        -2
      ],
      [
        -20,
        -43
      ],
      [
        -37,
        19
      ],
      [
        -27,
        -20
      ],
      [
        -106,
        -24
      ],
      [
        -90,
        23
      ],
      [
        -110,
        -21
      ]
    ],
    [
      [
        6051,
        4154
      ],
      [
        -8,
        65
      ],
      [
        -122,
        55
      ],
      [
        -22,
        36
      ],
      [
        15,
        35
      ],
      [
        -63,
        23
      ],
      [
        49,
        85
      ]
    ],
    [
      [
        5900,
        4453
      ],
      [
        33,
        8
      ],
      [
        61,
        -12
      ],
      [
        51,
        22
      ],
      [
        32,
        31
      ],
      [
        48,
        -6
      ],
      [
        89,
        31
      ],
      [
        90,
        -27
      ],
      [
        38,
        12
      ],
      [
        47,
        51
      ]
    ],
    [
      [
        6389,
        4563
      ],
      [
        118,
        -8
      ],
      [
        125,
        -9
      ]
    ],
    [
      [
        6632,
        4546
      ],
      [
        72,
        -78
      ],
      [
        94,
        1
      ],
      [
        22,
        54
      ],
      [
        50,
        11
      ]
    ],
    [
      [
        6797,
        4285
      ],
      [
        11,
        -32
      ],
      [
        -33,
        -27
      ],
      [
        24,
        -21
      ],
      [
        -22,
        -29
      ]
    ],
    [
      [
        6777,
        4176
      ],
      [
        -34,
        12
      ],
      [
        21,
        -39
      ],
      [
        -26,
        -3
      ],
      [
        -23,
        28
      ],
      [
        -38,
        -12
      ],
      [
        -68,
        43
      ],
      [
        -82,
        17
      ]
    ],
    [
      [
        6965,
        4400
      ],
      [
        75,
        -22
      ],
      [
        -21,
        -7
      ],
      [
        27,
        -38
      ],
      [
        -27,
        -29
      ]
    ],
    [
      [
        7019,
        4304
      ],
      [
        -17,
        -13
      ],
      [
        -3,
        0
      ]
    ],
    [
      [
        6999,
        4291
      ],
      [
        -108,
        5
      ],
      [
        -70,
        13
      ]
    ],
    [
      [
        6992,
        4263
      ],
      [
        1,
        -20
      ],
      [
        38,
        -46
      ]
    ],
    [
      [
        7031,
        4197
      ],
      [
        -55,
        -4
      ],
      [
        -15,
        -11
      ]
    ],
    [
      [
        6961,
        4182
      ],
      [
        -43,
        14
      ],
      [
        -1,
        39
      ],
      [
        35,
        30
      ],
      [
        40,
        -2
      ]
    ],
    [
      [
        6992,
        4263
      ],
      [
        2,
        19
      ],
      [
        5,
        9
      ]
    ],
    [
      [
        7019,
        4304
      ],
      [
        46,
        -2
      ],
      [
        8,
        26
      ],
      [
        36,
        -20
      ],
      [
        110,
        -25
      ],
      [
        215,
        -37
      ]
    ],
    [
      [
        7434,
        4246
      ],
      [
        -59,
        -37
      ],
      [
        1,
        -27
      ],
      [
        -43,
        8
      ],
      [
        -53,
        -8
      ],
      [
        -44,
        12
      ],
      [
        -53,
        -7
      ],
      [
        -46,
        12
      ],
      [
        -106,
        -2
      ]
    ],
    [
      [
        6961,
        4182
      ],
      [
        -77,
        -23
      ],
      [
        -44,
        25
      ],
      [
        -63,
        -8
      ]
    ],
    [
      [
        7284,
        847
      ],
      [
        -43,
        6
      ],
      [
        -23,
        0
      ]
    ],
    [
      [
        7123,
        856
      ],
      [
        -77,
        -6
      ],
      [
        35,
        -17
      ],
      [
        5,
        -33
      ],
      [
        -26,
        -7
      ],
      [
        -167,
        69
      ]
    ],
    [
      [
        6893,
        862
      ],
      [
        9,
        59
      ],
      [
        -60,
        22
      ],
      [
        -73,
        -10
      ],
      [
        -9,
        -21
      ]
    ],
    [
      [
        6760,
        912
      ],
      [
        128,
        -79
      ],
      [
        5,
        -22
      ],
      [
        -101,
        -11
      ],
      [
        13,
        -13
      ],
      [
        -88,
        -16
      ],
      [
        -33,
        3
      ],
      [
        -36,
        -37
      ],
      [
        -112,
        18
      ]
    ],
    [
      [
        6536,
        755
      ],
      [
        -61,
        14
      ],
      [
        -1,
        21
      ],
      [
        -53,
        -9
      ],
      [
        -23,
        31
      ],
      [
        5,
        60
      ],
      [
        -35,
        22
      ],
      [
        35,
        34
      ],
      [
        -76,
        -3
      ],
      [
        -70,
        57
      ]
    ],
    [
      [
        6257,
        982
      ],
      [
        113,
        19
      ],
      [
        28,
        -15
      ],
      [
        112,
        -16
      ],
      [
        44,
        -22
      ],
      [
        44,
        8
      ],
      [
        -10,
        32
      ],
      [
        25,
        21
      ],
      [
        -26,
        15
      ],
      [
        0,
        68
      ],
      [
        -31,
        16
      ],
      [
        -3,
        42
      ],
      [
        -41,
        60
      ],
      [
        69,
        -3
      ],
      [
        49,
        22
      ],
      [
        41,
        -12
      ],
      [
        19,
        53
      ],
      [
        -7,
        24
      ],
      [
        39,
        3
      ]
    ],
    [
      [
        6722,
        1297
      ],
      [
        54,
        3
      ],
      [
        34,
        32
      ],
      [
        155,
        -2
      ],
      [
        127,
        -13
      ],
      [
        60,
        17
      ],
      [
        28,
        -16
      ]
    ],
    [
      [
        7180,
        1318
      ],
      [
        114,
        4
      ],
      [
        67,
        -9
      ]
    ],
    [
      [
        7361,
        1313
      ],
      [
        33,
        -1
      ],
      [
        55,
        -16
      ]
    ],
    [
      [
        7449,
        1296
      ],
      [
        35,
        -36
      ],
      [
        -1,
        -44
      ],
      [
        -68,
        -4
      ],
      [
        -41,
        -33
      ],
      [
        16,
        -47
      ],
      [
        33,
        -5
      ],
      [
        43,
        -32
      ],
      [
        -6,
        -21
      ]
    ],
    [
      [
        7460,
        1074
      ],
      [
        -35,
        -26
      ],
      [
        -40,
        3
      ],
      [
        -35,
        -18
      ],
      [
        -68,
        -92
      ],
      [
        9,
        -21
      ],
      [
        -31,
        -26
      ],
      [
        30,
        -24
      ],
      [
        -6,
        -23
      ]
    ],
    [
      [
        6893,
        862
      ],
      [
        -22,
        15
      ],
      [
        -111,
        35
      ]
    ],
    [
      [
        5528,
        1712
      ],
      [
        -9,
        -55
      ],
      [
        22,
        -46
      ],
      [
        -21,
        -15
      ],
      [
        18,
        -39
      ]
    ],
    [
      [
        5538,
        1557
      ],
      [
        -49,
        -27
      ],
      [
        -84,
        -22
      ]
    ],
    [
      [
        5405,
        1508
      ],
      [
        -56,
        20
      ],
      [
        64,
        43
      ],
      [
        -46,
        16
      ],
      [
        -61,
        -21
      ],
      [
        -66,
        1
      ]
    ],
    [
      [
        5240,
        1567
      ],
      [
        -14,
        75
      ],
      [
        -47,
        17
      ],
      [
        -26,
        51
      ],
      [
        -80,
        9
      ]
    ],
    [
      [
        5073,
        1719
      ],
      [
        -13,
        6
      ],
      [
        -16,
        9
      ]
    ],
    [
      [
        5044,
        1734
      ],
      [
        69,
        17
      ],
      [
        53,
        52
      ],
      [
        -28,
        48
      ],
      [
        12,
        41
      ]
    ],
    [
      [
        5150,
        1892
      ],
      [
        100,
        -68
      ],
      [
        79,
        19
      ],
      [
        98,
        -50
      ],
      [
        47,
        -34
      ],
      [
        80,
        -15
      ]
    ],
    [
      [
        5554,
        1744
      ],
      [
        2,
        1
      ]
    ],
    [
      [
        5556,
        1745
      ],
      [
        1,
        0
      ],
      [
        -29,
        -33
      ]
    ],
    [
      [
        5528,
        1712
      ],
      [
        26,
        32
      ]
    ],
    [
      [
        5556,
        1745
      ],
      [
        142,
        53
      ],
      [
        72,
        15
      ],
      [
        1,
        17
      ],
      [
        -48,
        39
      ],
      [
        20,
        57
      ],
      [
        33,
        -24
      ],
      [
        77,
        19
      ]
    ],
    [
      [
        5853,
        1921
      ],
      [
        45,
        -37
      ],
      [
        73,
        -9
      ],
      [
        59,
        40
      ],
      [
        11,
        30
      ],
      [
        51,
        1
      ],
      [
        -29,
        -33
      ],
      [
        112,
        -5
      ],
      [
        61,
        23
      ],
      [
        67,
        5
      ],
      [
        74,
        -21
      ],
      [
        2,
        24
      ],
      [
        -35,
        26
      ],
      [
        50,
        6
      ],
      [
        56,
        34
      ]
    ],
    [
      [
        6450,
        2005
      ],
      [
        42,
        -19
      ],
      [
        42,
        -50
      ],
      [
        62,
        -4
      ],
      [
        -39,
        -39
      ]
    ],
    [
      [
        6557,
        1893
      ],
      [
        -5,
        -23
      ],
      [
        45,
        -25
      ],
      [
        -64,
        -70
      ],
      [
        -17,
        -85
      ],
      [
        16,
        -52
      ],
      [
        28,
        -29
      ],
      [
        -35,
        4
      ]
    ],
    [
      [
        6525,
        1613
      ],
      [
        -17,
        3
      ],
      [
        -49,
        -21
      ]
    ],
    [
      [
        6459,
        1595
      ],
      [
        -28,
        2
      ],
      [
        -19,
        31
      ],
      [
        -37,
        -34
      ],
      [
        -56,
        14
      ],
      [
        20,
        -24
      ],
      [
        -71,
        15
      ],
      [
        -10,
        -21
      ],
      [
        -109,
        22
      ],
      [
        -92,
        -68
      ],
      [
        -43,
        8
      ],
      [
        -80,
        -19
      ]
    ],
    [
      [
        5934,
        1521
      ],
      [
        -1,
        32
      ],
      [
        -112,
        -9
      ],
      [
        4,
        30
      ],
      [
        -157,
        35
      ]
    ],
    [
      [
        5668,
        1609
      ],
      [
        71,
        48
      ],
      [
        61,
        14
      ],
      [
        24,
        19
      ],
      [
        -17,
        19
      ],
      [
        -22,
        -27
      ],
      [
        -63,
        -10
      ],
      [
        -40,
        -33
      ],
      [
        -60,
        -23
      ],
      [
        -84,
        -59
      ]
    ],
    [
      [
        7557,
        1860
      ],
      [
        -66,
        2
      ],
      [
        -145,
        76
      ]
    ],
    [
      [
        7346,
        1938
      ],
      [
        40,
        28
      ],
      [
        -51,
        47
      ],
      [
        53,
        11
      ],
      [
        19,
        23
      ],
      [
        31,
        -5
      ],
      [
        121,
        42
      ]
    ],
    [
      [
        7559,
        2084
      ],
      [
        35,
        -16
      ],
      [
        -11,
        -26
      ],
      [
        58,
        -46
      ]
    ],
    [
      [
        7641,
        1996
      ],
      [
        -85,
        -53
      ],
      [
        28,
        -9
      ],
      [
        -24,
        -37
      ],
      [
        -3,
        -37
      ]
    ],
    [
      [
        7557,
        1860
      ],
      [
        -31,
        -41
      ],
      [
        128,
        -44
      ],
      [
        27,
        -33
      ]
    ],
    [
      [
        7681,
        1742
      ],
      [
        -45,
        -16
      ],
      [
        -76,
        9
      ],
      [
        -20,
        29
      ],
      [
        -39,
        4
      ],
      [
        -17,
        -18
      ],
      [
        52,
        -29
      ],
      [
        5,
        -24
      ],
      [
        43,
        -19
      ],
      [
        42,
        0
      ],
      [
        40,
        -30
      ],
      [
        12,
        -38
      ],
      [
        39,
        -7
      ],
      [
        -26,
        -24
      ],
      [
        30,
        -45
      ]
    ],
    [
      [
        7721,
        1534
      ],
      [
        22,
        -38
      ],
      [
        -26,
        -66
      ]
    ],
    [
      [
        7717,
        1430
      ],
      [
        -15,
        -2
      ]
    ],
    [
      [
        7702,
        1428
      ],
      [
        -10,
        28
      ],
      [
        -46,
        19
      ],
      [
        -82,
        -7
      ],
      [
        15,
        -24
      ]
    ],
    [
      [
        7579,
        1444
      ],
      [
        -67,
        13
      ],
      [
        17,
        39
      ],
      [
        -58,
        11
      ],
      [
        -104,
        -18
      ]
    ],
    [
      [
        7367,
        1489
      ],
      [
        -36,
        8
      ],
      [
        -6,
        -3
      ]
    ],
    [
      [
        7325,
        1494
      ],
      [
        -44,
        20
      ],
      [
        20,
        18
      ],
      [
        -33,
        28
      ],
      [
        24,
        43
      ],
      [
        44,
        -2
      ],
      [
        -8,
        47
      ],
      [
        -27,
        22
      ],
      [
        -55,
        15
      ],
      [
        -74,
        -12
      ],
      [
        -69,
        33
      ],
      [
        -8,
        53
      ],
      [
        70,
        -4
      ],
      [
        -35,
        59
      ],
      [
        35,
        39
      ],
      [
        -35,
        11
      ],
      [
        29,
        37
      ],
      [
        -56,
        15
      ]
    ],
    [
      [
        7103,
        1916
      ],
      [
        -34,
        8
      ],
      [
        46,
        24
      ],
      [
        74,
        18
      ],
      [
        83,
        8
      ],
      [
        40,
        -50
      ],
      [
        34,
        14
      ]
    ],
    [
      [
        5570,
        1343
      ],
      [
        71,
        -2
      ],
      [
        40,
        35
      ]
    ],
    [
      [
        5681,
        1376
      ],
      [
        20,
        -12
      ],
      [
        107,
        -2
      ],
      [
        116,
        15
      ]
    ],
    [
      [
        5924,
        1377
      ],
      [
        2,
        -43
      ],
      [
        -54,
        -23
      ],
      [
        43,
        -21
      ]
    ],
    [
      [
        5915,
        1290
      ],
      [
        -55,
        -23
      ],
      [
        -60,
        0
      ],
      [
        -18,
        -16
      ],
      [
        -66,
        -6
      ],
      [
        -52,
        22
      ],
      [
        -81,
        -15
      ],
      [
        -48,
        26
      ],
      [
        -44,
        7
      ]
    ],
    [
      [
        5491,
        1285
      ],
      [
        10,
        31
      ],
      [
        56,
        -3
      ],
      [
        13,
        30
      ]
    ],
    [
      [
        5570,
        1343
      ],
      [
        4,
        55
      ],
      [
        -100,
        49
      ]
    ],
    [
      [
        5474,
        1447
      ],
      [
        33,
        15
      ],
      [
        18,
        17
      ]
    ],
    [
      [
        5525,
        1479
      ],
      [
        11,
        -10
      ],
      [
        150,
        -44
      ],
      [
        -5,
        -49
      ]
    ],
    [
      [
        5491,
        1285
      ],
      [
        -100,
        8
      ],
      [
        23,
        -28
      ],
      [
        -91,
        4
      ],
      [
        -96,
        -8
      ],
      [
        -18,
        26
      ]
    ],
    [
      [
        5209,
        1287
      ],
      [
        40,
        70
      ],
      [
        32,
        -3
      ],
      [
        106,
        72
      ],
      [
        87,
        21
      ]
    ],
    [
      [
        5525,
        1479
      ],
      [
        72,
        69
      ],
      [
        26,
        11
      ],
      [
        45,
        50
      ]
    ],
    [
      [
        5934,
        1521
      ],
      [
        26,
        -54
      ],
      [
        -75,
        -32
      ],
      [
        33,
        -2
      ],
      [
        6,
        -56
      ]
    ],
    [
      [
        6410,
        740
      ],
      [
        -60,
        4
      ],
      [
        -40,
        -11
      ]
    ],
    [
      [
        6310,
        733
      ],
      [
        -24,
        3
      ],
      [
        1,
        28
      ]
    ],
    [
      [
        6287,
        764
      ],
      [
        51,
        2
      ],
      [
        72,
        -26
      ]
    ],
    [
      [
        6536,
        755
      ],
      [
        -81,
        -16
      ],
      [
        -45,
        1
      ]
    ],
    [
      [
        6287,
        764
      ],
      [
        -75,
        19
      ],
      [
        -32,
        -41
      ]
    ],
    [
      [
        6180,
        742
      ],
      [
        -12,
        13
      ],
      [
        -44,
        -38
      ],
      [
        47,
        14
      ],
      [
        34,
        -29
      ],
      [
        49,
        -4
      ],
      [
        21,
        -30
      ],
      [
        -51,
        -44
      ],
      [
        -100,
        1
      ],
      [
        -75,
        21
      ],
      [
        -187,
        13
      ],
      [
        -34,
        12
      ],
      [
        -59,
        -10
      ],
      [
        -30,
        -47
      ],
      [
        38,
        -25
      ],
      [
        -31,
        -28
      ],
      [
        -2,
        35
      ],
      [
        -24,
        23
      ],
      [
        -210,
        93
      ],
      [
        -173,
        37
      ],
      [
        -81,
        -7
      ]
    ],
    [
      [
        5253,
        831
      ],
      [
        28,
        17
      ],
      [
        133,
        12
      ],
      [
        137,
        30
      ],
      [
        39,
        -2
      ],
      [
        15,
        83
      ],
      [
        49,
        2
      ],
      [
        8,
        22
      ],
      [
        46,
        -7
      ],
      [
        26,
        -29
      ],
      [
        70,
        2
      ],
      [
        64,
        17
      ],
      [
        -34,
        14
      ],
      [
        47,
        40
      ],
      [
        2,
        38
      ]
    ],
    [
      [
        5883,
        1070
      ],
      [
        85,
        -11
      ],
      [
        44,
        -26
      ],
      [
        50,
        -52
      ],
      [
        45,
        -28
      ],
      [
        150,
        29
      ]
    ],
    [
      [
        6310,
        733
      ],
      [
        -42,
        -23
      ],
      [
        -10,
        21
      ],
      [
        -78,
        11
      ]
    ],
    [
      [
        8071,
        1971
      ],
      [
        38,
        -46
      ],
      [
        97,
        30
      ],
      [
        63,
        -8
      ],
      [
        30,
        -37
      ]
    ],
    [
      [
        8299,
        1910
      ],
      [
        30,
        -27
      ],
      [
        31,
        -82
      ],
      [
        49,
        6
      ],
      [
        -17,
        -38
      ],
      [
        16,
        -29
      ],
      [
        -32,
        -24
      ],
      [
        -123,
        -20
      ],
      [
        -35,
        -32
      ],
      [
        -12,
        -51
      ]
    ],
    [
      [
        8206,
        1613
      ],
      [
        -138,
        10
      ],
      [
        -16,
        -16
      ]
    ],
    [
      [
        8052,
        1607
      ],
      [
        -90,
        -25
      ],
      [
        -40,
        -5
      ]
    ],
    [
      [
        7922,
        1577
      ],
      [
        -80,
        -22
      ],
      [
        -27,
        1
      ]
    ],
    [
      [
        7815,
        1556
      ],
      [
        -81,
        1
      ],
      [
        -13,
        -23
      ]
    ],
    [
      [
        7681,
        1742
      ],
      [
        19,
        -15
      ],
      [
        63,
        41
      ]
    ],
    [
      [
        7763,
        1768
      ],
      [
        72,
        -21
      ],
      [
        46,
        24
      ],
      [
        -51,
        64
      ]
    ],
    [
      [
        7830,
        1835
      ],
      [
        -12,
        31
      ],
      [
        23,
        21
      ],
      [
        85,
        15
      ],
      [
        36,
        -14
      ],
      [
        53,
        28
      ],
      [
        -3,
        19
      ],
      [
        59,
        36
      ]
    ],
    [
      [
        8071,
        1971
      ],
      [
        14,
        59
      ],
      [
        -85,
        -1
      ],
      [
        -37,
        54
      ]
    ],
    [
      [
        7963,
        2083
      ],
      [
        -41,
        30
      ],
      [
        -62,
        2
      ],
      [
        -15,
        38
      ],
      [
        -48,
        9
      ],
      [
        -40,
        28
      ]
    ],
    [
      [
        7757,
        2190
      ],
      [
        -27,
        52
      ],
      [
        59,
        16
      ],
      [
        91,
        66
      ],
      [
        -12,
        31
      ],
      [
        -60,
        21
      ],
      [
        -7,
        43
      ]
    ],
    [
      [
        7801,
        2419
      ],
      [
        88,
        -47
      ],
      [
        40,
        -3
      ],
      [
        73,
        44
      ],
      [
        74,
        23
      ],
      [
        78,
        7
      ],
      [
        14,
        66
      ]
    ],
    [
      [
        8168,
        2509
      ],
      [
        82,
        -9
      ],
      [
        25,
        21
      ],
      [
        -4,
        27
      ],
      [
        120,
        22
      ]
    ],
    [
      [
        8391,
        2570
      ],
      [
        -16,
        -50
      ],
      [
        41,
        -8
      ],
      [
        -13,
        -29
      ],
      [
        62,
        -25
      ],
      [
        -27,
        -16
      ],
      [
        4,
        -57
      ],
      [
        30,
        -32
      ],
      [
        76,
        15
      ],
      [
        120,
        -66
      ]
    ],
    [
      [
        8668,
        2302
      ],
      [
        -55,
        -21
      ],
      [
        -3,
        -17
      ],
      [
        57,
        -45
      ],
      [
        -13,
        -28
      ],
      [
        38,
        -1
      ],
      [
        38,
        -25
      ],
      [
        -15,
        -15
      ],
      [
        -64,
        -10
      ],
      [
        -63,
        33
      ],
      [
        -19,
        -30
      ],
      [
        44,
        -30
      ],
      [
        70,
        14
      ],
      [
        55,
        -27
      ],
      [
        -19,
        -45
      ],
      [
        -38,
        2
      ],
      [
        -64,
        -54
      ],
      [
        12,
        -41
      ]
    ],
    [
      [
        8629,
        1962
      ],
      [
        -18,
        -22
      ],
      [
        -105,
        45
      ],
      [
        -80,
        -3
      ],
      [
        -14,
        -23
      ],
      [
        -54,
        -13
      ],
      [
        -34,
        12
      ],
      [
        -25,
        -48
      ]
    ],
    [
      [
        7920,
        3498
      ],
      [
        -136,
        -23
      ],
      [
        -19,
        0
      ]
    ],
    [
      [
        7765,
        3475
      ],
      [
        25,
        55
      ],
      [
        85,
        12
      ],
      [
        45,
        -44
      ]
    ],
    [
      [
        8018,
        3398
      ],
      [
        103,
        -48
      ],
      [
        49,
        -6
      ],
      [
        69,
        -42
      ]
    ],
    [
      [
        8239,
        3302
      ],
      [
        -80,
        -13
      ],
      [
        -35,
        -44
      ],
      [
        20,
        -19
      ],
      [
        -40,
        -13
      ],
      [
        -78,
        46
      ],
      [
        -8,
        53
      ],
      [
        28,
        26
      ],
      [
        -38,
        2
      ],
      [
        -74,
        36
      ]
    ],
    [
      [
        7934,
        3376
      ],
      [
        8,
        10
      ],
      [
        76,
        12
      ]
    ],
    [
      [
        8385,
        1451
      ],
      [
        -18,
        4
      ],
      [
        -28,
        -2
      ]
    ],
    [
      [
        8339,
        1453
      ],
      [
        -24,
        -5
      ]
    ],
    [
      [
        8315,
        1448
      ],
      [
        2,
        17
      ],
      [
        -25,
        24
      ]
    ],
    [
      [
        8292,
        1489
      ],
      [
        54,
        10
      ],
      [
        25,
        42
      ]
    ],
    [
      [
        8371,
        1541
      ],
      [
        7,
        -32
      ],
      [
        34,
        -14
      ],
      [
        -27,
        -44
      ]
    ],
    [
      [
        8385,
        1451
      ],
      [
        24,
        -16
      ],
      [
        35,
        5
      ]
    ],
    [
      [
        8444,
        1440
      ],
      [
        -9,
        -10
      ],
      [
        7,
        -5
      ]
    ],
    [
      [
        8442,
        1425
      ],
      [
        -63,
        -51
      ],
      [
        5,
        -16
      ]
    ],
    [
      [
        8384,
        1358
      ],
      [
        -57,
        13
      ],
      [
        -29,
        16
      ]
    ],
    [
      [
        8298,
        1387
      ],
      [
        9,
        33
      ],
      [
        32,
        33
      ]
    ],
    [
      [
        8442,
        1425
      ],
      [
        52,
        -12
      ],
      [
        48,
        7
      ],
      [
        16,
        -16
      ],
      [
        46,
        3
      ]
    ],
    [
      [
        8604,
        1407
      ],
      [
        64,
        7
      ],
      [
        64,
        25
      ]
    ],
    [
      [
        8732,
        1439
      ],
      [
        -29,
        -23
      ],
      [
        30,
        -32
      ],
      [
        -8,
        -23
      ],
      [
        -58,
        -58
      ],
      [
        89,
        3
      ],
      [
        58,
        -28
      ],
      [
        56,
        23
      ],
      [
        21,
        49
      ]
    ],
    [
      [
        8891,
        1350
      ],
      [
        44,
        -5
      ],
      [
        13,
        31
      ],
      [
        38,
        -50
      ],
      [
        215,
        -13
      ],
      [
        123,
        21
      ],
      [
        325,
        17
      ],
      [
        25,
        -8
      ],
      [
        -29,
        -48
      ],
      [
        -36,
        0
      ],
      [
        -4,
        -23
      ],
      [
        33,
        -76
      ],
      [
        -8,
        -35
      ],
      [
        -48,
        -48
      ],
      [
        -95,
        -25
      ],
      [
        -44,
        -2
      ],
      [
        -46,
        -22
      ],
      [
        -66,
        -1
      ],
      [
        -80,
        -32
      ],
      [
        -62,
        -54
      ],
      [
        14,
        -59
      ],
      [
        -35,
        -8
      ],
      [
        -76,
        15
      ]
    ],
    [
      [
        9092,
        925
      ],
      [
        -3,
        16
      ],
      [
        -45,
        1
      ],
      [
        -36,
        41
      ],
      [
        -91,
        6
      ],
      [
        -37,
        17
      ],
      [
        -89,
        -13
      ],
      [
        -91,
        28
      ],
      [
        -6,
        16
      ],
      [
        -58,
        16
      ],
      [
        -85,
        49
      ],
      [
        -64,
        -8
      ],
      [
        -47,
        10
      ],
      [
        -80,
        -8
      ],
      [
        13,
        25
      ],
      [
        -92,
        -4
      ]
    ],
    [
      [
        8281,
        1117
      ],
      [
        -19,
        68
      ],
      [
        19,
        30
      ],
      [
        -9,
        43
      ]
    ],
    [
      [
        8272,
        1258
      ],
      [
        40,
        -1
      ],
      [
        3,
        20
      ],
      [
        59,
        40
      ],
      [
        10,
        41
      ]
    ],
    [
      [
        9114,
        1378
      ],
      [
        41,
        -21
      ],
      [
        4,
        -24
      ],
      [
        -25,
        -7
      ],
      [
        -117,
        6
      ],
      [
        -61,
        38
      ],
      [
        33,
        33
      ],
      [
        125,
        -25
      ]
    ],
    [
      [
        8272,
        1258
      ],
      [
        -32,
        0
      ],
      [
        -9,
        29
      ]
    ],
    [
      [
        8231,
        1287
      ],
      [
        -33,
        44
      ],
      [
        -58,
        41
      ]
    ],
    [
      [
        8140,
        1372
      ],
      [
        2,
        4
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        8143,
        1376
      ],
      [
        3,
        1
      ],
      [
        4,
        1
      ]
    ],
    [
      [
        8150,
        1378
      ],
      [
        68,
        -9
      ],
      [
        42,
        8
      ],
      [
        -17,
        17
      ]
    ],
    [
      [
        8243,
        1394
      ],
      [
        41,
        -14
      ],
      [
        14,
        7
      ]
    ],
    [
      [
        8012,
        1498
      ],
      [
        22,
        -16
      ],
      [
        4,
        -6
      ]
    ],
    [
      [
        8038,
        1476
      ],
      [
        -24,
        0
      ],
      [
        -8,
        -5
      ]
    ],
    [
      [
        8006,
        1471
      ],
      [
        -10,
        2
      ],
      [
        -17,
        1
      ]
    ],
    [
      [
        7979,
        1474
      ],
      [
        -58,
        4
      ],
      [
        -30,
        17
      ]
    ],
    [
      [
        7891,
        1495
      ],
      [
        12,
        25
      ],
      [
        47,
        23
      ]
    ],
    [
      [
        7950,
        1543
      ],
      [
        31,
        -32
      ],
      [
        31,
        -13
      ]
    ],
    [
      [
        8012,
        1498
      ],
      [
        19,
        2
      ],
      [
        24,
        11
      ]
    ],
    [
      [
        8055,
        1511
      ],
      [
        12,
        1
      ],
      [
        18,
        -3
      ]
    ],
    [
      [
        8085,
        1509
      ],
      [
        6,
        -9
      ],
      [
        23,
        -28
      ]
    ],
    [
      [
        8114,
        1472
      ],
      [
        7,
        -8
      ],
      [
        -2,
        -5
      ]
    ],
    [
      [
        8119,
        1459
      ],
      [
        -4,
        -1
      ],
      [
        -6,
        -3
      ]
    ],
    [
      [
        8109,
        1455
      ],
      [
        -4,
        -2
      ]
    ],
    [
      [
        8105,
        1453
      ],
      [
        -39,
        26
      ],
      [
        -28,
        -3
      ]
    ],
    [
      [
        7979,
        1474
      ],
      [
        2,
        -15
      ],
      [
        -8,
        -14
      ]
    ],
    [
      [
        7973,
        1445
      ],
      [
        -123,
        -5
      ],
      [
        -26,
        5
      ]
    ],
    [
      [
        7824,
        1445
      ],
      [
        20,
        18
      ],
      [
        -36,
        15
      ],
      [
        40,
        16
      ]
    ],
    [
      [
        7848,
        1494
      ],
      [
        43,
        1
      ]
    ],
    [
      [
        8206,
        1613
      ],
      [
        -1,
        -26
      ],
      [
        9,
        -2
      ]
    ],
    [
      [
        8214,
        1585
      ],
      [
        -13,
        -24
      ],
      [
        -14,
        -19
      ]
    ],
    [
      [
        8187,
        1542
      ],
      [
        -100,
        7
      ]
    ],
    [
      [
        8087,
        1549
      ],
      [
        11,
        19
      ],
      [
        -47,
        21
      ],
      [
        1,
        18
      ]
    ],
    [
      [
        8243,
        1394
      ],
      [
        -11,
        24
      ],
      [
        -37,
        22
      ]
    ],
    [
      [
        8195,
        1440
      ],
      [
        18,
        -9
      ],
      [
        24,
        21
      ]
    ],
    [
      [
        8237,
        1452
      ],
      [
        29,
        -10
      ],
      [
        49,
        6
      ]
    ],
    [
      [
        8006,
        1471
      ],
      [
        11,
        -30
      ],
      [
        28,
        -16
      ]
    ],
    [
      [
        8045,
        1425
      ],
      [
        -26,
        -4
      ],
      [
        -15,
        5
      ]
    ],
    [
      [
        8004,
        1426
      ],
      [
        -14,
        9
      ],
      [
        -11,
        4
      ]
    ],
    [
      [
        7979,
        1439
      ],
      [
        -2,
        4
      ],
      [
        -4,
        2
      ]
    ],
    [
      [
        7979,
        1439
      ],
      [
        -128,
        -34
      ],
      [
        -19,
        -34
      ]
    ],
    [
      [
        7832,
        1371
      ],
      [
        -48,
        16
      ],
      [
        -11,
        21
      ]
    ],
    [
      [
        7773,
        1408
      ],
      [
        16,
        -2
      ],
      [
        35,
        39
      ]
    ],
    [
      [
        8085,
        1509
      ],
      [
        17,
        6
      ],
      [
        21,
        -9
      ]
    ],
    [
      [
        8123,
        1506
      ],
      [
        24,
        -15
      ],
      [
        -17,
        -16
      ]
    ],
    [
      [
        8130,
        1475
      ],
      [
        -10,
        -1
      ],
      [
        -6,
        -2
      ]
    ],
    [
      [
        8006,
        1471
      ],
      [
        42,
        -26
      ],
      [
        26,
        -10
      ]
    ],
    [
      [
        8074,
        1435
      ],
      [
        -14,
        -5
      ],
      [
        -15,
        -5
      ]
    ],
    [
      [
        8085,
        1347
      ],
      [
        13,
        6
      ],
      [
        -8,
        13
      ]
    ],
    [
      [
        8090,
        1366
      ],
      [
        24,
        8
      ],
      [
        26,
        -2
      ]
    ],
    [
      [
        8231,
        1287
      ],
      [
        -40,
        9
      ],
      [
        -102,
        -38
      ],
      [
        -36,
        27
      ]
    ],
    [
      [
        8053,
        1285
      ],
      [
        54,
        26
      ],
      [
        -22,
        36
      ]
    ],
    [
      [
        8085,
        1347
      ],
      [
        -81,
        -7
      ],
      [
        -12,
        5
      ]
    ],
    [
      [
        7992,
        1345
      ],
      [
        -12,
        14
      ],
      [
        -8,
        29
      ]
    ],
    [
      [
        7972,
        1388
      ],
      [
        57,
        4
      ],
      [
        56,
        -17
      ]
    ],
    [
      [
        8085,
        1375
      ],
      [
        -5,
        -7
      ],
      [
        10,
        -2
      ]
    ],
    [
      [
        8292,
        1489
      ],
      [
        -20,
        18
      ],
      [
        -31,
        -7
      ]
    ],
    [
      [
        8241,
        1500
      ],
      [
        -3,
        28
      ],
      [
        8,
        38
      ]
    ],
    [
      [
        8246,
        1566
      ],
      [
        56,
        -23
      ],
      [
        65,
        15
      ]
    ],
    [
      [
        8367,
        1558
      ],
      [
        2,
        -4
      ],
      [
        2,
        -13
      ]
    ],
    [
      [
        8004,
        1426
      ],
      [
        -27,
        -11
      ],
      [
        -5,
        -27
      ]
    ],
    [
      [
        7972,
        1388
      ],
      [
        -59,
        -4
      ],
      [
        -3,
        -39
      ]
    ],
    [
      [
        7910,
        1345
      ],
      [
        -44,
        14
      ],
      [
        -34,
        12
      ]
    ],
    [
      [
        8053,
        1285
      ],
      [
        -14,
        19
      ],
      [
        -42,
        -11
      ],
      [
        -24,
        42
      ]
    ],
    [
      [
        7973,
        1335
      ],
      [
        6,
        4
      ],
      [
        13,
        6
      ]
    ],
    [
      [
        8195,
        1440
      ],
      [
        -1,
        7
      ],
      [
        -44,
        11
      ]
    ],
    [
      [
        8150,
        1458
      ],
      [
        3,
        0
      ],
      [
        -8,
        7
      ]
    ],
    [
      [
        8145,
        1465
      ],
      [
        18,
        15
      ],
      [
        44,
        10
      ]
    ],
    [
      [
        8207,
        1490
      ],
      [
        14,
        -27
      ],
      [
        16,
        -11
      ]
    ],
    [
      [
        8241,
        1500
      ],
      [
        -33,
        -2
      ]
    ],
    [
      [
        8208,
        1498
      ],
      [
        -28,
        7
      ],
      [
        -15,
        13
      ]
    ],
    [
      [
        8165,
        1518
      ],
      [
        6,
        8
      ],
      [
        16,
        16
      ]
    ],
    [
      [
        8214,
        1585
      ],
      [
        25,
        -9
      ],
      [
        7,
        -10
      ]
    ],
    [
      [
        8074,
        1435
      ],
      [
        8,
        4
      ],
      [
        7,
        4
      ]
    ],
    [
      [
        8089,
        1443
      ],
      [
        -13,
        -28
      ],
      [
        9,
        -40
      ]
    ],
    [
      [
        8105,
        1453
      ],
      [
        -16,
        -9
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        8168,
        2509
      ],
      [
        -88,
        -17
      ],
      [
        -62,
        15
      ],
      [
        -64,
        -7
      ],
      [
        -53,
        15
      ],
      [
        -87,
        -25
      ]
    ],
    [
      [
        7814,
        2490
      ],
      [
        -65,
        6
      ],
      [
        -25,
        -6
      ]
    ],
    [
      [
        7724,
        2490
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        7724,
        2490
      ],
      [
        76,
        46
      ],
      [
        -101,
        21
      ],
      [
        -49,
        28
      ],
      [
        -87,
        6
      ]
    ],
    [
      [
        7446,
        2787
      ],
      [
        -14,
        41
      ],
      [
        42,
        27
      ],
      [
        51,
        12
      ],
      [
        -23,
        31
      ],
      [
        6,
        71
      ],
      [
        -33,
        1
      ],
      [
        8,
        27
      ],
      [
        67,
        11
      ],
      [
        27,
        29
      ],
      [
        -68,
        5
      ],
      [
        -72,
        -6
      ],
      [
        30,
        89
      ],
      [
        -34,
        38
      ],
      [
        -16,
        73
      ]
    ],
    [
      [
        7417,
        3236
      ],
      [
        49,
        31
      ],
      [
        8,
        25
      ],
      [
        125,
        -8
      ],
      [
        -6,
        -37
      ],
      [
        52,
        -13
      ],
      [
        103,
        20
      ],
      [
        8,
        29
      ],
      [
        60,
        5
      ],
      [
        0,
        20
      ],
      [
        -78,
        3
      ],
      [
        61,
        29
      ],
      [
        89,
        -7
      ],
      [
        46,
        43
      ]
    ],
    [
      [
        8239,
        3302
      ],
      [
        75,
        -33
      ],
      [
        56,
        -11
      ],
      [
        24,
        -36
      ],
      [
        70,
        -43
      ],
      [
        97,
        -150
      ],
      [
        15,
        -74
      ],
      [
        -27,
        -54
      ],
      [
        -47,
        -11
      ],
      [
        -123,
        -60
      ],
      [
        -79,
        -64
      ],
      [
        -61,
        -24
      ],
      [
        -11,
        -23
      ],
      [
        82,
        5
      ],
      [
        79,
        -28
      ],
      [
        77,
        -61
      ],
      [
        32,
        9
      ]
    ],
    [
      [
        8498,
        2644
      ],
      [
        -2,
        -44
      ],
      [
        -78,
        -32
      ],
      [
        -27,
        2
      ]
    ],
    [
      [
        2272,
        4328
      ],
      [
        7,
        -38
      ],
      [
        37,
        16
      ]
    ],
    [
      [
        2316,
        4306
      ],
      [
        62,
        -7
      ]
    ],
    [
      [
        2378,
        4299
      ],
      [
        -8,
        -20
      ],
      [
        -79,
        -10
      ],
      [
        -60,
        -25
      ]
    ],
    [
      [
        2231,
        4244
      ],
      [
        -77,
        24
      ],
      [
        -34,
        38
      ]
    ],
    [
      [
        2162,
        4342
      ],
      [
        59,
        -14
      ],
      [
        51,
        0
      ]
    ],
    [
      [
        763,
        4600
      ],
      [
        10,
        54
      ],
      [
        51,
        35
      ],
      [
        160,
        15
      ],
      [
        45,
        -9
      ]
    ],
    [
      [
        1029,
        4695
      ],
      [
        -24,
        -15
      ],
      [
        43,
        -44
      ],
      [
        45,
        0
      ],
      [
        3,
        -54
      ],
      [
        30,
        -12
      ],
      [
        14,
        -67
      ],
      [
        30,
        -21
      ]
    ],
    [
      [
        1170,
        4482
      ],
      [
        -60,
        -9
      ],
      [
        -41,
        8
      ],
      [
        -53,
        33
      ],
      [
        -32,
        -5
      ],
      [
        -14,
        35
      ],
      [
        -68,
        4
      ],
      [
        14,
        24
      ],
      [
        -112,
        4
      ],
      [
        -41,
        24
      ]
    ],
    [
      [
        1533,
        3895
      ],
      [
        44,
        41
      ],
      [
        68,
        15
      ],
      [
        26,
        -8
      ],
      [
        27,
        25
      ],
      [
        85,
        21
      ],
      [
        40,
        1
      ]
    ],
    [
      [
        1823,
        3990
      ],
      [
        169,
        -29
      ],
      [
        147,
        1
      ]
    ],
    [
      [
        2139,
        3962
      ],
      [
        -16,
        -15
      ],
      [
        30,
        -54
      ],
      [
        67,
        21
      ],
      [
        41,
        -14
      ],
      [
        59,
        5
      ]
    ],
    [
      [
        2320,
        3905
      ],
      [
        -17,
        -58
      ],
      [
        -29,
        -27
      ],
      [
        -129,
        -50
      ],
      [
        -73,
        7
      ],
      [
        28,
        11
      ],
      [
        -90,
        17
      ],
      [
        -11,
        17
      ],
      [
        -78,
        11
      ],
      [
        -64,
        -7
      ],
      [
        -28,
        11
      ],
      [
        -23,
        -43
      ],
      [
        -57,
        -7
      ],
      [
        -44,
        12
      ],
      [
        -139,
        -28
      ],
      [
        -57,
        28
      ],
      [
        7,
        43
      ],
      [
        32,
        32
      ],
      [
        -15,
        21
      ]
    ],
    [
      [
        1533,
        3895
      ],
      [
        -58,
        24
      ],
      [
        -26,
        -15
      ],
      [
        -56,
        18
      ],
      [
        -49,
        53
      ],
      [
        -45,
        15
      ],
      [
        26,
        14
      ],
      [
        -14,
        30
      ]
    ],
    [
      [
        1311,
        4034
      ],
      [
        39,
        15
      ],
      [
        35,
        65
      ],
      [
        79,
        -8
      ],
      [
        19,
        37
      ],
      [
        41,
        18
      ],
      [
        45,
        -14
      ],
      [
        59,
        13
      ]
    ],
    [
      [
        1628,
        4160
      ],
      [
        71,
        -62
      ],
      [
        49,
        -17
      ],
      [
        30,
        16
      ]
    ],
    [
      [
        1778,
        4097
      ],
      [
        31,
        -49
      ],
      [
        -3,
        -44
      ],
      [
        17,
        -14
      ]
    ],
    [
      [
        1778,
        4097
      ],
      [
        169,
        3
      ],
      [
        26,
        32
      ]
    ],
    [
      [
        1973,
        4132
      ],
      [
        45,
        10
      ],
      [
        107,
        -33
      ],
      [
        -4,
        -17
      ],
      [
        55,
        -11
      ],
      [
        59,
        2
      ]
    ],
    [
      [
        2235,
        4083
      ],
      [
        -20,
        -35
      ],
      [
        24,
        -46
      ],
      [
        -21,
        -37
      ],
      [
        -70,
        12
      ],
      [
        -9,
        -15
      ]
    ],
    [
      [
        1628,
        4160
      ],
      [
        -29,
        41
      ],
      [
        55,
        29
      ]
    ],
    [
      [
        1654,
        4230
      ],
      [
        46,
        13
      ],
      [
        47,
        14
      ]
    ],
    [
      [
        1921,
        4278
      ],
      [
        -34,
        -21
      ],
      [
        23,
        -43
      ],
      [
        35,
        -19
      ],
      [
        -13,
        -14
      ],
      [
        41,
        -49
      ]
    ],
    [
      [
        1311,
        4034
      ],
      [
        -52,
        44
      ],
      [
        -64,
        27
      ],
      [
        -65,
        8
      ],
      [
        -78,
        -57
      ],
      [
        -63,
        -12
      ]
    ],
    [
      [
        989,
        4044
      ],
      [
        -64,
        -8
      ],
      [
        -24,
        33
      ],
      [
        -55,
        7
      ],
      [
        2,
        29
      ],
      [
        -35,
        25
      ]
    ],
    [
      [
        813,
        4130
      ],
      [
        226,
        41
      ],
      [
        102,
        26
      ],
      [
        66,
        31
      ],
      [
        12,
        36
      ]
    ],
    [
      [
        1219,
        4264
      ],
      [
        66,
        -11
      ],
      [
        72,
        10
      ],
      [
        86,
        -3
      ],
      [
        34,
        -23
      ],
      [
        67,
        17
      ],
      [
        110,
        -24
      ]
    ],
    [
      [
        1219,
        4264
      ],
      [
        11,
        27
      ],
      [
        -50,
        63
      ],
      [
        5,
        51
      ],
      [
        26,
        9
      ]
    ],
    [
      [
        1211,
        4414
      ],
      [
        80,
        -12
      ],
      [
        64,
        12
      ],
      [
        65,
        -5
      ],
      [
        79,
        -36
      ],
      [
        124,
        28
      ],
      [
        61,
        -19
      ]
    ],
    [
      [
        2231,
        4244
      ],
      [
        32,
        -14
      ],
      [
        55,
        -56
      ]
    ],
    [
      [
        2318,
        4174
      ],
      [
        -48,
        -26
      ],
      [
        -35,
        -65
      ]
    ],
    [
      [
        1211,
        4414
      ],
      [
        33,
        10
      ],
      [
        7,
        15
      ]
    ],
    [
      [
        1251,
        4439
      ],
      [
        28,
        6
      ],
      [
        -16,
        38
      ]
    ],
    [
      [
        1263,
        4483
      ],
      [
        28,
        32
      ],
      [
        78,
        -4
      ],
      [
        36,
        16
      ],
      [
        -6,
        43
      ]
    ],
    [
      [
        1399,
        4570
      ],
      [
        45,
        16
      ],
      [
        43,
        -12
      ],
      [
        55,
        17
      ],
      [
        55,
        -12
      ],
      [
        66,
        21
      ]
    ],
    [
      [
        1663,
        4600
      ],
      [
        14,
        -20
      ],
      [
        -2,
        -6
      ]
    ],
    [
      [
        813,
        4130
      ],
      [
        -56,
        6
      ],
      [
        -88,
        -29
      ],
      [
        -51,
        22
      ],
      [
        -19,
        70
      ],
      [
        29,
        55
      ],
      [
        -49,
        -4
      ],
      [
        -73,
        16
      ],
      [
        -22,
        20
      ]
    ],
    [
      [
        484,
        4286
      ],
      [
        40,
        23
      ],
      [
        172,
        23
      ],
      [
        40,
        -7
      ],
      [
        52,
        44
      ],
      [
        60,
        16
      ],
      [
        23,
        21
      ],
      [
        39,
        -3
      ],
      [
        63,
        22
      ],
      [
        97,
        -3
      ],
      [
        109,
        25
      ],
      [
        72,
        -8
      ]
    ],
    [
      [
        2204,
        4702
      ],
      [
        14,
        -11
      ],
      [
        -18,
        -57
      ],
      [
        55,
        -9
      ],
      [
        102,
        -79
      ],
      [
        29,
        -59
      ],
      [
        67,
        -14
      ],
      [
        -64,
        35
      ],
      [
        46,
        12
      ],
      [
        50,
        -29
      ],
      [
        11,
        -50
      ]
    ],
    [
      [
        2496,
        4441
      ],
      [
        -63,
        -16
      ],
      [
        -37,
        22
      ],
      [
        -99,
        -7
      ]
    ],
    [
      [
        2297,
        4440
      ],
      [
        -102,
        3
      ],
      [
        -16,
        24
      ]
    ],
    [
      [
        2496,
        4441
      ],
      [
        -39,
        -38
      ],
      [
        -89,
        -18
      ],
      [
        -59,
        -24
      ]
    ],
    [
      [
        2309,
        4361
      ],
      [
        -29,
        27
      ],
      [
        17,
        52
      ]
    ],
    [
      [
        2309,
        4361
      ],
      [
        -14,
        -9
      ],
      [
        -23,
        -24
      ]
    ],
    [
      [
        2316,
        4306
      ],
      [
        32,
        25
      ],
      [
        91,
        28
      ],
      [
        54,
        -11
      ],
      [
        120,
        10
      ],
      [
        10,
        -7
      ]
    ],
    [
      [
        2623,
        4351
      ],
      [
        -12,
        -17
      ],
      [
        -73,
        -32
      ],
      [
        -80,
        9
      ],
      [
        -28,
        -12
      ]
    ],
    [
      [
        2430,
        4299
      ],
      [
        -34,
        4
      ],
      [
        -18,
        -4
      ]
    ],
    [
      [
        2318,
        4174
      ],
      [
        33,
        12
      ],
      [
        16,
        0
      ]
    ],
    [
      [
        2367,
        4186
      ],
      [
        29,
        -24
      ],
      [
        75,
        -16
      ],
      [
        78,
        15
      ]
    ],
    [
      [
        2549,
        4161
      ],
      [
        12,
        -21
      ],
      [
        -34,
        -56
      ],
      [
        -49,
        -26
      ],
      [
        130,
        30
      ],
      [
        30,
        -18
      ],
      [
        -3,
        -61
      ],
      [
        -104,
        -62
      ],
      [
        -22,
        15
      ],
      [
        -101,
        0
      ],
      [
        -83,
        -15
      ],
      [
        -5,
        -42
      ]
    ],
    [
      [
        1399,
        4570
      ],
      [
        -26,
        53
      ],
      [
        1,
        92
      ],
      [
        -14,
        29
      ],
      [
        -41,
        21
      ],
      [
        23,
        46
      ]
    ],
    [
      [
        1342,
        4811
      ],
      [
        85,
        3
      ],
      [
        115,
        27
      ],
      [
        69,
        3
      ],
      [
        26,
        13
      ]
    ],
    [
      [
        1667,
        4787
      ],
      [
        -57,
        -16
      ],
      [
        -6,
        -30
      ],
      [
        -35,
        -20
      ],
      [
        31,
        -33
      ],
      [
        0,
        -42
      ],
      [
        63,
        -46
      ]
    ],
    [
      [
        2430,
        4299
      ],
      [
        2,
        -29
      ],
      [
        -70,
        -52
      ],
      [
        5,
        -32
      ]
    ],
    [
      [
        3499,
        2006
      ],
      [
        -4,
        -36
      ],
      [
        56,
        -4
      ],
      [
        83,
        -24
      ]
    ],
    [
      [
        3634,
        1942
      ],
      [
        64,
        -62
      ],
      [
        -22,
        -19
      ],
      [
        -115,
        -36
      ],
      [
        -62,
        -1
      ],
      [
        -46,
        -36
      ],
      [
        15,
        -21
      ],
      [
        -42,
        -19
      ],
      [
        104,
        0
      ],
      [
        23,
        -18
      ],
      [
        0,
        -67
      ]
    ],
    [
      [
        3553,
        1663
      ],
      [
        -38,
        -14
      ],
      [
        -35,
        -62
      ],
      [
        -137,
        -3
      ],
      [
        -93,
        -45
      ],
      [
        -105,
        27
      ],
      [
        -5,
        28
      ],
      [
        -49,
        7
      ],
      [
        -14,
        18
      ],
      [
        77,
        -6
      ],
      [
        193,
        39
      ],
      [
        -29,
        16
      ],
      [
        11,
        40
      ],
      [
        -59,
        -2
      ],
      [
        29,
        -36
      ],
      [
        -18,
        -20
      ],
      [
        -100,
        -11
      ],
      [
        -140,
        11
      ],
      [
        -7,
        -19
      ],
      [
        -74,
        30
      ],
      [
        123,
        53
      ],
      [
        -10,
        51
      ],
      [
        -23,
        18
      ],
      [
        -96,
        7
      ],
      [
        -56,
        -7
      ],
      [
        2,
        49
      ],
      [
        56,
        5
      ],
      [
        29,
        18
      ],
      [
        85,
        15
      ],
      [
        33,
        16
      ],
      [
        6,
        41
      ],
      [
        66,
        4
      ],
      [
        54,
        -16
      ],
      [
        42,
        19
      ],
      [
        88,
        -9
      ],
      [
        -5,
        27
      ],
      [
        61,
        15
      ],
      [
        56,
        44
      ],
      [
        28,
        -5
      ]
    ],
    [
      [
        3499,
        2006
      ],
      [
        56,
        28
      ],
      [
        124,
        -2
      ],
      [
        144,
        67
      ],
      [
        55,
        7
      ],
      [
        120,
        57
      ],
      [
        59,
        47
      ],
      [
        42,
        52
      ],
      [
        18,
        60
      ],
      [
        23,
        32
      ],
      [
        -7,
        30
      ],
      [
        47,
        1
      ],
      [
        70,
        26
      ]
    ],
    [
      [
        4250,
        2411
      ],
      [
        19,
        2
      ]
    ],
    [
      [
        4269,
        2413
      ],
      [
        89,
        -4
      ],
      [
        26,
        -61
      ],
      [
        89,
        16
      ],
      [
        -36,
        -57
      ],
      [
        40,
        -15
      ],
      [
        31,
        -52
      ],
      [
        39,
        -15
      ],
      [
        -80,
        -26
      ],
      [
        30,
        -41
      ],
      [
        -33,
        -15
      ],
      [
        -19,
        -72
      ],
      [
        11,
        -52
      ]
    ],
    [
      [
        4456,
        2019
      ],
      [
        -22,
        -14
      ],
      [
        -104,
        16
      ],
      [
        -69,
        -1
      ],
      [
        -54,
        -23
      ],
      [
        -71,
        8
      ],
      [
        -61,
        -15
      ],
      [
        -115,
        -54
      ],
      [
        -175,
        -3
      ],
      [
        -151,
        9
      ]
    ],
    [
      [
        4250,
        2411
      ],
      [
        -107,
        -8
      ],
      [
        -73,
        57
      ],
      [
        19,
        45
      ],
      [
        51,
        43
      ],
      [
        68,
        31
      ],
      [
        -60,
        -11
      ],
      [
        -78,
        52
      ],
      [
        -24,
        30
      ],
      [
        32,
        17
      ],
      [
        -12,
        54
      ],
      [
        29,
        22
      ],
      [
        -128,
        5
      ],
      [
        -111,
        -25
      ],
      [
        -69,
        1
      ],
      [
        -75,
        -38
      ],
      [
        -35,
        -56
      ],
      [
        -67,
        22
      ],
      [
        -65,
        -13
      ],
      [
        -56,
        3
      ],
      [
        -60,
        -12
      ],
      [
        28,
        37
      ],
      [
        140,
        89
      ],
      [
        73,
        15
      ],
      [
        166,
        77
      ],
      [
        17,
        77
      ],
      [
        21,
        -10
      ],
      [
        58,
        48
      ],
      [
        112,
        68
      ],
      [
        85,
        0
      ],
      [
        67,
        19
      ]
    ],
    [
      [
        4196,
        3050
      ],
      [
        73,
        -44
      ],
      [
        -22,
        -40
      ],
      [
        -55,
        -43
      ],
      [
        29,
        -46
      ],
      [
        -4,
        -58
      ],
      [
        85,
        11
      ],
      [
        35,
        -41
      ],
      [
        72,
        -25
      ],
      [
        120,
        48
      ],
      [
        69,
        17
      ],
      [
        33,
        -39
      ],
      [
        75,
        0
      ],
      [
        31,
        10
      ]
    ],
    [
      [
        4737,
        2800
      ],
      [
        36,
        -2
      ],
      [
        -50,
        -37
      ],
      [
        24,
        -28
      ],
      [
        -18,
        -37
      ]
    ],
    [
      [
        4729,
        2696
      ],
      [
        -20,
        -25
      ],
      [
        -89,
        -14
      ],
      [
        -18,
        -32
      ],
      [
        25,
        -50
      ],
      [
        -31,
        -32
      ],
      [
        -96,
        -18
      ],
      [
        -100,
        0
      ],
      [
        -36,
        -31
      ],
      [
        -5,
        -38
      ],
      [
        -90,
        -43
      ]
    ],
    [
      [
        5060,
        2636
      ],
      [
        -11,
        31
      ],
      [
        31,
        23
      ],
      [
        -8,
        23
      ],
      [
        49,
        34
      ],
      [
        77,
        29
      ],
      [
        71,
        -14
      ],
      [
        86,
        3
      ],
      [
        68,
        -34
      ],
      [
        59,
        16
      ],
      [
        -7,
        44
      ]
    ],
    [
      [
        5475,
        2791
      ],
      [
        105,
        18
      ]
    ],
    [
      [
        5580,
        2809
      ],
      [
        47,
        -30
      ],
      [
        50,
        -6
      ],
      [
        96,
        17
      ],
      [
        53,
        23
      ]
    ],
    [
      [
        5826,
        2813
      ],
      [
        3,
        -37
      ],
      [
        -44,
        -13
      ],
      [
        -30,
        -45
      ],
      [
        15,
        -17
      ],
      [
        69,
        15
      ],
      [
        -31,
        -57
      ]
    ],
    [
      [
        5808,
        2659
      ],
      [
        -193,
        -49
      ],
      [
        -57,
        -9
      ],
      [
        4,
        -34
      ],
      [
        182,
        -95
      ],
      [
        36,
        -10
      ],
      [
        101,
        129
      ]
    ],
    [
      [
        5881,
        2591
      ],
      [
        31,
        -61
      ],
      [
        63,
        -10
      ],
      [
        -6,
        -52
      ],
      [
        -67,
        -4
      ],
      [
        -7,
        -15
      ],
      [
        59,
        -27
      ],
      [
        -4,
        -41
      ],
      [
        -44,
        -38
      ],
      [
        13,
        -29
      ]
    ],
    [
      [
        5919,
        2314
      ],
      [
        -64,
        -19
      ],
      [
        30,
        -35
      ],
      [
        -71,
        -1
      ],
      [
        -19,
        -19
      ],
      [
        -60,
        -6
      ],
      [
        -5,
        -27
      ],
      [
        -51,
        11
      ],
      [
        -31,
        -28
      ],
      [
        -43,
        -3
      ],
      [
        -43,
        24
      ]
    ],
    [
      [
        5562,
        2211
      ],
      [
        -54,
        -26
      ],
      [
        -52,
        19
      ],
      [
        15,
        25
      ],
      [
        -49,
        1
      ],
      [
        -58,
        35
      ],
      [
        -119,
        -46
      ]
    ],
    [
      [
        5245,
        2219
      ],
      [
        -114,
        6
      ],
      [
        -129,
        60
      ],
      [
        -17,
        24
      ],
      [
        25,
        27
      ],
      [
        83,
        24
      ],
      [
        77,
        2
      ],
      [
        55,
        37
      ],
      [
        -28,
        27
      ],
      [
        -106,
        -36
      ],
      [
        -6,
        54
      ],
      [
        43,
        19
      ],
      [
        37,
        39
      ],
      [
        27,
        56
      ],
      [
        48,
        21
      ],
      [
        -37,
        20
      ],
      [
        -59,
        9
      ]
    ],
    [
      [
        5144,
        2608
      ],
      [
        -83,
        28
      ]
    ],
    [
      [
        5061,
        2636
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        5060,
        2636
      ],
      [
        84,
        -28
      ]
    ],
    [
      [
        5245,
        2219
      ],
      [
        -43,
        -40
      ],
      [
        41,
        -24
      ],
      [
        -96,
        -37
      ],
      [
        -54,
        -52
      ],
      [
        33,
        -19
      ],
      [
        -48,
        -19
      ],
      [
        22,
        -17
      ],
      [
        -23,
        -34
      ],
      [
        37,
        -22
      ],
      [
        36,
        -63
      ]
    ],
    [
      [
        5044,
        1734
      ],
      [
        -117,
        4
      ],
      [
        -15,
        -19
      ]
    ],
    [
      [
        4912,
        1719
      ],
      [
        -46,
        -3
      ]
    ],
    [
      [
        4866,
        1716
      ],
      [
        -72,
        34
      ],
      [
        -30,
        -10
      ]
    ],
    [
      [
        4764,
        1740
      ],
      [
        -37,
        0
      ],
      [
        -7,
        -24
      ],
      [
        -68,
        -15
      ],
      [
        -37,
        -21
      ]
    ],
    [
      [
        4615,
        1680
      ],
      [
        -66,
        26
      ],
      [
        -74,
        -6
      ],
      [
        -41,
        -14
      ],
      [
        -36,
        25
      ]
    ],
    [
      [
        4398,
        1711
      ],
      [
        48,
        57
      ],
      [
        41,
        32
      ],
      [
        0,
        46
      ],
      [
        24,
        14
      ],
      [
        -9,
        37
      ],
      [
        52,
        39
      ],
      [
        -24,
        41
      ],
      [
        -43,
        9
      ],
      [
        5,
        27
      ],
      [
        -36,
        6
      ]
    ],
    [
      [
        4729,
        2696
      ],
      [
        34,
        -5
      ],
      [
        45,
        10
      ]
    ],
    [
      [
        4808,
        2701
      ],
      [
        92,
        -37
      ],
      [
        59,
        -44
      ],
      [
        101,
        16
      ]
    ],
    [
      [
        4866,
        1716
      ],
      [
        59,
        -104
      ],
      [
        -27,
        -25
      ]
    ],
    [
      [
        4898,
        1587
      ],
      [
        -136,
        96
      ],
      [
        24,
        10
      ],
      [
        -22,
        47
      ]
    ],
    [
      [
        4623,
        1377
      ],
      [
        -88,
        51
      ],
      [
        -75,
        14
      ],
      [
        -15,
        39
      ]
    ],
    [
      [
        4445,
        1481
      ],
      [
        62,
        -7
      ],
      [
        51,
        15
      ],
      [
        -42,
        41
      ],
      [
        29,
        49
      ],
      [
        104,
        1
      ]
    ],
    [
      [
        4649,
        1580
      ],
      [
        60,
        -22
      ],
      [
        29,
        -25
      ],
      [
        -15,
        -73
      ]
    ],
    [
      [
        4723,
        1460
      ],
      [
        -48,
        -16
      ],
      [
        -2,
        -53
      ],
      [
        -50,
        -14
      ]
    ],
    [
      [
        4912,
        1719
      ],
      [
        56,
        -50
      ],
      [
        63,
        -12
      ],
      [
        55,
        -23
      ]
    ],
    [
      [
        5086,
        1634
      ],
      [
        44,
        -18
      ],
      [
        -4,
        -47
      ],
      [
        44,
        -22
      ]
    ],
    [
      [
        5170,
        1547
      ],
      [
        -78,
        -17
      ],
      [
        26,
        -22
      ],
      [
        -19,
        -18
      ]
    ],
    [
      [
        5099,
        1490
      ],
      [
        -55,
        9
      ],
      [
        -71,
        -7
      ]
    ],
    [
      [
        4973,
        1492
      ],
      [
        -30,
        30
      ],
      [
        -45,
        65
      ]
    ],
    [
      [
        4973,
        1492
      ],
      [
        -49,
        -27
      ],
      [
        -15,
        -14
      ]
    ],
    [
      [
        4909,
        1451
      ],
      [
        -81,
        6
      ],
      [
        -21,
        -10
      ],
      [
        -50,
        18
      ],
      [
        -34,
        -5
      ]
    ],
    [
      [
        4649,
        1580
      ],
      [
        -20,
        28
      ],
      [
        -14,
        72
      ]
    ],
    [
      [
        5124,
        1457
      ],
      [
        -55,
        -25
      ],
      [
        -41,
        -24
      ]
    ],
    [
      [
        5028,
        1408
      ],
      [
        -89,
        15
      ],
      [
        -30,
        28
      ]
    ],
    [
      [
        5099,
        1490
      ],
      [
        35,
        -16
      ],
      [
        -10,
        -17
      ]
    ],
    [
      [
        5028,
        1408
      ],
      [
        12,
        -20
      ],
      [
        -24,
        -31
      ],
      [
        -35,
        4
      ],
      [
        -70,
        -16
      ],
      [
        -252,
        13
      ],
      [
        -36,
        19
      ]
    ],
    [
      [
        4445,
        1481
      ],
      [
        -29,
        40
      ],
      [
        -52,
        35
      ],
      [
        -55,
        5
      ]
    ],
    [
      [
        4309,
        1561
      ],
      [
        58,
        61
      ],
      [
        -104,
        68
      ]
    ],
    [
      [
        4263,
        1690
      ],
      [
        38,
        1
      ],
      [
        29,
        34
      ],
      [
        68,
        -14
      ]
    ],
    [
      [
        4309,
        1561
      ],
      [
        -75,
        -5
      ],
      [
        -38,
        -23
      ],
      [
        25,
        -25
      ],
      [
        -78,
        5
      ],
      [
        -18,
        -12
      ],
      [
        -52,
        10
      ],
      [
        -45,
        -22
      ],
      [
        -47,
        -3
      ],
      [
        -76,
        15
      ],
      [
        0,
        57
      ],
      [
        56,
        25
      ],
      [
        13,
        -19
      ],
      [
        131,
        14
      ],
      [
        20,
        33
      ]
    ],
    [
      [
        4125,
        1611
      ],
      [
        48,
        63
      ],
      [
        45,
        20
      ],
      [
        45,
        -4
      ]
    ],
    [
      [
        5740,
        3393
      ],
      [
        31,
        18
      ],
      [
        58,
        -8
      ]
    ],
    [
      [
        5829,
        3403
      ],
      [
        15,
        -43
      ],
      [
        25,
        -50
      ]
    ],
    [
      [
        5869,
        3310
      ],
      [
        -106,
        18
      ],
      [
        -70,
        -13
      ]
    ],
    [
      [
        5693,
        3315
      ],
      [
        -8,
        15
      ],
      [
        -39,
        40
      ]
    ],
    [
      [
        5646,
        3370
      ],
      [
        53,
        25
      ]
    ],
    [
      [
        5699,
        3395
      ],
      [
        2,
        1
      ]
    ],
    [
      [
        5701,
        3396
      ],
      [
        39,
        -3
      ]
    ],
    [
      [
        5740,
        3393
      ],
      [
        -41,
        2
      ]
    ],
    [
      [
        5699,
        3395
      ],
      [
        -1,
        3
      ]
    ],
    [
      [
        5698,
        3398
      ],
      [
        -21,
        22
      ]
    ],
    [
      [
        5677,
        3420
      ],
      [
        2,
        77
      ],
      [
        29,
        21
      ],
      [
        79,
        4
      ],
      [
        61,
        -92
      ]
    ],
    [
      [
        5848,
        3430
      ],
      [
        -3,
        -14
      ],
      [
        -16,
        -13
      ]
    ],
    [
      [
        5677,
        3420
      ],
      [
        13,
        -16
      ],
      [
        8,
        -6
      ]
    ],
    [
      [
        5698,
        3398
      ],
      [
        3,
        -2
      ]
    ],
    [
      [
        5646,
        3370
      ],
      [
        -33,
        13
      ],
      [
        -96,
        -12
      ],
      [
        -27,
        -64
      ],
      [
        -39,
        -17
      ]
    ],
    [
      [
        5451,
        3290
      ],
      [
        -25,
        15
      ],
      [
        -38,
        -34
      ]
    ],
    [
      [
        5388,
        3271
      ],
      [
        -24,
        17
      ],
      [
        -58,
        12
      ]
    ],
    [
      [
        5306,
        3300
      ],
      [
        -59,
        21
      ],
      [
        -4,
        -27
      ],
      [
        -74,
        24
      ],
      [
        38,
        78
      ],
      [
        31,
        -2
      ],
      [
        31,
        32
      ],
      [
        -16,
        45
      ]
    ],
    [
      [
        5253,
        3471
      ],
      [
        49,
        24
      ],
      [
        -121,
        9
      ]
    ],
    [
      [
        5181,
        3504
      ],
      [
        67,
        57
      ],
      [
        8,
        36
      ],
      [
        -22,
        44
      ],
      [
        -51,
        33
      ]
    ],
    [
      [
        5183,
        3674
      ],
      [
        93,
        19
      ],
      [
        38,
        -6
      ],
      [
        59,
        64
      ],
      [
        -66,
        -13
      ],
      [
        -23,
        30
      ],
      [
        60,
        42
      ],
      [
        32,
        8
      ],
      [
        30,
        33
      ],
      [
        -40,
        39
      ]
    ],
    [
      [
        5366,
        3890
      ],
      [
        45,
        21
      ],
      [
        59,
        -7
      ],
      [
        63,
        -22
      ],
      [
        42,
        36
      ],
      [
        52,
        -3
      ],
      [
        120,
        40
      ],
      [
        10,
        -8
      ]
    ],
    [
      [
        5757,
        3947
      ],
      [
        -6,
        -12
      ],
      [
        -95,
        -61
      ],
      [
        3,
        -33
      ],
      [
        78,
        -32
      ],
      [
        9,
        -29
      ],
      [
        105,
        -4
      ],
      [
        19,
        -48
      ],
      [
        47,
        -18
      ],
      [
        61,
        11
      ],
      [
        55,
        -43
      ],
      [
        69,
        -20
      ],
      [
        7,
        -23
      ],
      [
        65,
        -38
      ]
    ],
    [
      [
        6174,
        3597
      ],
      [
        -15,
        -21
      ],
      [
        -73,
        -31
      ],
      [
        -1,
        -32
      ],
      [
        -38,
        -28
      ],
      [
        8,
        -26
      ]
    ],
    [
      [
        6055,
        3459
      ],
      [
        -75,
        -22
      ],
      [
        -30,
        -23
      ],
      [
        -2,
        -31
      ]
    ],
    [
      [
        5948,
        3383
      ],
      [
        -23,
        48
      ],
      [
        -77,
        -1
      ]
    ],
    [
      [
        7765,
        3475
      ],
      [
        -95,
        -4
      ],
      [
        -34,
        17
      ],
      [
        -59,
        4
      ],
      [
        -90,
        -29
      ],
      [
        27,
        -9
      ]
    ],
    [
      [
        7514,
        3454
      ],
      [
        -145,
        -71
      ],
      [
        -16,
        -1
      ]
    ],
    [
      [
        7353,
        3382
      ],
      [
        0,
        19
      ],
      [
        -82,
        22
      ],
      [
        -54,
        2
      ],
      [
        -80,
        -11
      ]
    ],
    [
      [
        7137,
        3414
      ],
      [
        -36,
        26
      ],
      [
        17,
        34
      ],
      [
        73,
        -17
      ],
      [
        96,
        26
      ],
      [
        -38,
        19
      ],
      [
        43,
        59
      ],
      [
        -20,
        54
      ]
    ],
    [
      [
        7272,
        3615
      ],
      [
        21,
        70
      ],
      [
        -9,
        26
      ]
    ],
    [
      [
        7284,
        3711
      ],
      [
        40,
        32
      ],
      [
        156,
        14
      ],
      [
        66,
        -14
      ],
      [
        27,
        47
      ],
      [
        70,
        24
      ],
      [
        58,
        -1
      ],
      [
        67,
        22
      ],
      [
        32,
        50
      ],
      [
        42,
        3
      ],
      [
        80,
        -27
      ],
      [
        72,
        -3
      ],
      [
        23,
        18
      ]
    ],
    [
      [
        8017,
        3876
      ],
      [
        89,
        -19
      ],
      [
        37,
        -18
      ],
      [
        -90,
        -26
      ],
      [
        -56,
        -55
      ],
      [
        69,
        -113
      ],
      [
        286,
        -235
      ],
      [
        16,
        -31
      ],
      [
        -94,
        29
      ],
      [
        -42,
        3
      ],
      [
        -59,
        -17
      ],
      [
        -86,
        19
      ],
      [
        -96,
        67
      ],
      [
        -71,
        18
      ]
    ],
    [
      [
        7272,
        3615
      ],
      [
        -84,
        -9
      ],
      [
        -118,
        2
      ],
      [
        -77,
        50
      ],
      [
        -14,
        50
      ],
      [
        55,
        10
      ],
      [
        31,
        44
      ],
      [
        55,
        12
      ],
      [
        85,
        -12
      ],
      [
        21,
        -49
      ],
      [
        58,
        -2
      ]
    ],
    [
      [
        4737,
        2800
      ],
      [
        -16,
        73
      ],
      [
        -39,
        22
      ],
      [
        -69,
        7
      ],
      [
        88,
        52
      ],
      [
        24,
        24
      ],
      [
        -3,
        38
      ],
      [
        -42,
        35
      ],
      [
        5,
        54
      ]
    ],
    [
      [
        4685,
        3105
      ],
      [
        142,
        38
      ],
      [
        12,
        0
      ]
    ],
    [
      [
        4839,
        3143
      ],
      [
        -22,
        -49
      ],
      [
        42,
        -22
      ],
      [
        -6,
        -39
      ],
      [
        49,
        -49
      ],
      [
        46,
        -23
      ],
      [
        61,
        -4
      ],
      [
        70,
        -74
      ]
    ],
    [
      [
        5079,
        2883
      ],
      [
        -19,
        -64
      ],
      [
        46,
        -30
      ],
      [
        -106,
        -23
      ],
      [
        -112,
        -5
      ],
      [
        -80,
        -60
      ]
    ],
    [
      [
        4839,
        3143
      ],
      [
        30,
        1
      ],
      [
        80,
        -36
      ],
      [
        130,
        -46
      ],
      [
        34,
        -25
      ],
      [
        4,
        21
      ]
    ],
    [
      [
        5117,
        3058
      ],
      [
        65,
        -10
      ],
      [
        106,
        -58
      ],
      [
        -42,
        -36
      ]
    ],
    [
      [
        5246,
        2954
      ],
      [
        -36,
        -5
      ],
      [
        -131,
        -66
      ]
    ],
    [
      [
        5246,
        2954
      ],
      [
        58,
        -38
      ],
      [
        48,
        -78
      ],
      [
        44,
        -30
      ],
      [
        79,
        -17
      ]
    ],
    [
      [
        5073,
        1719
      ],
      [
        17,
        -26
      ],
      [
        -4,
        -59
      ]
    ],
    [
      [
        5405,
        1508
      ],
      [
        -61,
        -16
      ],
      [
        -85,
        -3
      ],
      [
        -31,
        19
      ],
      [
        -43,
        -29
      ],
      [
        -61,
        -22
      ]
    ],
    [
      [
        5170,
        1547
      ],
      [
        61,
        19
      ],
      [
        9,
        1
      ]
    ],
    [
      [
        1263,
        4483
      ],
      [
        -25,
        11
      ],
      [
        -68,
        -12
      ]
    ],
    [
      [
        1029,
        4695
      ],
      [
        85,
        -4
      ],
      [
        48,
        25
      ],
      [
        44,
        59
      ],
      [
        12,
        54
      ],
      [
        78,
        -18
      ],
      [
        46,
        0
      ]
    ],
    [
      [
        484,
        4286
      ],
      [
        -16,
        3
      ]
    ],
    [
      [
        468,
        4289
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        468,
        4290
      ],
      [
        -3,
        18
      ],
      [
        -43,
        -9
      ],
      [
        -61,
        22
      ],
      [
        -24,
        -7
      ],
      [
        -69,
        27
      ],
      [
        -23,
        33
      ],
      [
        85,
        31
      ],
      [
        76,
        -23
      ],
      [
        34,
        1
      ],
      [
        86,
        35
      ],
      [
        108,
        -4
      ],
      [
        0,
        48
      ],
      [
        73,
        47
      ],
      [
        26,
        36
      ],
      [
        -5,
        33
      ],
      [
        35,
        22
      ]
    ],
    [
      [
        989,
        4044
      ],
      [
        -19,
        -39
      ],
      [
        63,
        -38
      ],
      [
        -7,
        -26
      ],
      [
        -77,
        -14
      ],
      [
        -32,
        -25
      ],
      [
        -2,
        -37
      ],
      [
        -34,
        -13
      ],
      [
        3,
        36
      ],
      [
        -39,
        -21
      ],
      [
        23,
        -26
      ],
      [
        -84,
        7
      ],
      [
        -46,
        23
      ],
      [
        -62,
        -20
      ],
      [
        -108,
        13
      ],
      [
        -24,
        27
      ],
      [
        -73,
        28
      ],
      [
        -132,
        4
      ],
      [
        -33,
        21
      ],
      [
        -4,
        40
      ],
      [
        -22,
        21
      ],
      [
        -56,
        6
      ],
      [
        -52,
        53
      ],
      [
        -78,
        20
      ],
      [
        -94,
        75
      ],
      [
        119,
        33
      ],
      [
        54,
        42
      ],
      [
        115,
        -11
      ],
      [
        38,
        8
      ],
      [
        101,
        50
      ],
      [
        41,
        8
      ]
    ],
    [
      [
        468,
        4290
      ],
      [
        16,
        -4
      ]
    ],
    [
      [
        7434,
        4246
      ],
      [
        217,
        -73
      ],
      [
        41,
        -28
      ],
      [
        2,
        -24
      ],
      [
        58,
        -28
      ],
      [
        33,
        -37
      ],
      [
        32,
        -73
      ],
      [
        37,
        -24
      ],
      [
        84,
        -24
      ],
      [
        18,
        -37
      ],
      [
        61,
        -22
      ]
    ],
    [
      [
        7137,
        3414
      ],
      [
        -51,
        -12
      ],
      [
        -75,
        4
      ],
      [
        -31,
        -16
      ]
    ],
    [
      [
        6980,
        3390
      ],
      [
        -15,
        47
      ],
      [
        34,
        25
      ],
      [
        -96,
        35
      ]
    ],
    [
      [
        6903,
        3497
      ],
      [
        20,
        19
      ],
      [
        -18,
        55
      ],
      [
        -39,
        37
      ],
      [
        40,
        1
      ],
      [
        11,
        59
      ],
      [
        -40,
        18
      ],
      [
        -54,
        -5
      ],
      [
        -68,
        -30
      ],
      [
        -53,
        4
      ],
      [
        -26,
        22
      ],
      [
        -15,
        -24
      ],
      [
        -181,
        -5
      ]
    ],
    [
      [
        6480,
        3648
      ],
      [
        -69,
        36
      ],
      [
        -49,
        -10
      ],
      [
        -32,
        29
      ],
      [
        -66,
        -5
      ],
      [
        -30,
        -37
      ],
      [
        -4,
        -44
      ]
    ],
    [
      [
        6230,
        3617
      ],
      [
        -25,
        0
      ],
      [
        -31,
        -20
      ]
    ],
    [
      [
        5757,
        3947
      ],
      [
        48,
        -2
      ],
      [
        48,
        20
      ],
      [
        43,
        -6
      ],
      [
        3,
        70
      ],
      [
        -41,
        28
      ],
      [
        64,
        29
      ],
      [
        -12,
        33
      ],
      [
        50,
        27
      ],
      [
        91,
        8
      ]
    ],
    [
      [
        4080,
        396
      ],
      [
        11,
        22
      ],
      [
        -62,
        4
      ],
      [
        -21,
        46
      ]
    ],
    [
      [
        4694,
        543
      ],
      [
        18,
        -44
      ],
      [
        -45,
        -4
      ],
      [
        -25,
        -21
      ],
      [
        25,
        -20
      ],
      [
        45,
        1
      ],
      [
        -32,
        -33
      ]
    ],
    [
      [
        8867,
        1483
      ],
      [
        -78,
        -25
      ],
      [
        -22,
        9
      ]
    ],
    [
      [
        8767,
        1467
      ],
      [
        -65,
        23
      ],
      [
        -162,
        13
      ]
    ],
    [
      [
        8540,
        1503
      ],
      [
        -50,
        33
      ],
      [
        -22,
        31
      ],
      [
        -101,
        -9
      ]
    ],
    [
      [
        8629,
        1962
      ],
      [
        81,
        9
      ],
      [
        35,
        -19
      ],
      [
        112,
        24
      ],
      [
        66,
        -7
      ],
      [
        20,
        -51
      ],
      [
        67,
        -52
      ],
      [
        128,
        13
      ],
      [
        104,
        -17
      ],
      [
        60,
        0
      ]
    ],
    [
      [
        9302,
        1862
      ],
      [
        185,
        -10
      ],
      [
        16,
        -11
      ],
      [
        -79,
        -45
      ],
      [
        65,
        -13
      ],
      [
        12,
        -17
      ],
      [
        -58,
        -31
      ],
      [
        -84,
        -27
      ],
      [
        -99,
        0
      ],
      [
        -58,
        57
      ],
      [
        -2,
        -17
      ],
      [
        -90,
        -40
      ],
      [
        -13,
        -32
      ],
      [
        -52,
        -12
      ],
      [
        -57,
        5
      ],
      [
        -68,
        -17
      ],
      [
        51,
        -11
      ],
      [
        104,
        10
      ],
      [
        77,
        22
      ],
      [
        23,
        -59
      ],
      [
        -17,
        -39
      ],
      [
        17,
        -17
      ],
      [
        -28,
        -27
      ],
      [
        -97,
        -43
      ]
    ],
    [
      [
        9050,
        1488
      ],
      [
        -143,
        33
      ],
      [
        -38,
        -7
      ],
      [
        -2,
        -31
      ]
    ],
    [
      [
        8498,
        2644
      ],
      [
        47,
        -2
      ],
      [
        59,
        -32
      ],
      [
        -5,
        21
      ],
      [
        60,
        45
      ],
      [
        47,
        85
      ],
      [
        84,
        33
      ],
      [
        103,
        4
      ],
      [
        14,
        12
      ],
      [
        65,
        -11
      ],
      [
        86,
        0
      ],
      [
        134,
        -25
      ],
      [
        45,
        11
      ],
      [
        -48,
        14
      ],
      [
        311,
        -41
      ],
      [
        122,
        -35
      ],
      [
        249,
        -106
      ],
      [
        53,
        -41
      ],
      [
        50,
        -97
      ],
      [
        1,
        -84
      ]
    ],
    [
      [
        9975,
        2395
      ],
      [
        -58,
        8
      ],
      [
        -37,
        -29
      ],
      [
        47,
        -21
      ],
      [
        -60,
        -30
      ],
      [
        -56,
        15
      ],
      [
        -41,
        -12
      ],
      [
        -119,
        -3
      ],
      [
        19,
        -11
      ],
      [
        -82,
        -18
      ],
      [
        -40,
        -36
      ],
      [
        -49,
        -1
      ],
      [
        -72,
        -26
      ],
      [
        -169,
        19
      ],
      [
        -62,
        -13
      ],
      [
        -42,
        20
      ],
      [
        -95,
        12
      ],
      [
        -86,
        -15
      ],
      [
        -81,
        18
      ],
      [
        39,
        36
      ],
      [
        -151,
        7
      ],
      [
        -112,
        -13
      ]
    ],
    [
      [
        8235,
        796
      ],
      [
        -192,
        40
      ],
      [
        -35,
        2
      ]
    ],
    [
      [
        8008,
        838
      ],
      [
        -21,
        25
      ],
      [
        77,
        31
      ],
      [
        24,
        -8
      ]
    ],
    [
      [
        8088,
        886
      ],
      [
        118,
        -54
      ],
      [
        29,
        -36
      ]
    ],
    [
      [
        8540,
        1503
      ],
      [
        15,
        -16
      ],
      [
        -88,
        -19
      ],
      [
        -23,
        -28
      ]
    ],
    [
      [
        8767,
        1467
      ],
      [
        -91,
        -12
      ],
      [
        -27,
        -35
      ],
      [
        -45,
        -13
      ]
    ],
    [
      [
        9050,
        1488
      ],
      [
        -56,
        -12
      ],
      [
        -127,
        7
      ]
    ],
    [
      [
        8008,
        838
      ],
      [
        -62,
        1
      ],
      [
        -129,
        -27
      ],
      [
        -171,
        0
      ],
      [
        -165,
        -32
      ],
      [
        -40,
        -1
      ],
      [
        2,
        -26
      ],
      [
        -43,
        -2
      ],
      [
        -91,
        34
      ],
      [
        41,
        27
      ],
      [
        -66,
        35
      ]
    ],
    [
      [
        7460,
        1074
      ],
      [
        66,
        -16
      ],
      [
        61,
        13
      ],
      [
        87,
        -5
      ],
      [
        240,
        34
      ],
      [
        120,
        41
      ],
      [
        64,
        -25
      ],
      [
        141,
        1
      ]
    ],
    [
      [
        8239,
        1117
      ],
      [
        16,
        -22
      ],
      [
        -67,
        -31
      ],
      [
        49,
        -25
      ],
      [
        -35,
        -63
      ],
      [
        -52,
        11
      ],
      [
        -38,
        -21
      ],
      [
        -24,
        -80
      ]
    ],
    [
      [
        6450,
        2005
      ],
      [
        -29,
        21
      ],
      [
        -89,
        18
      ],
      [
        -16,
        -14
      ],
      [
        -53,
        29
      ],
      [
        42,
        41
      ],
      [
        -18,
        51
      ],
      [
        38,
        7
      ],
      [
        36,
        33
      ],
      [
        -30,
        32
      ],
      [
        33,
        35
      ]
    ],
    [
      [
        6364,
        2258
      ],
      [
        8,
        -3
      ]
    ],
    [
      [
        6372,
        2255
      ],
      [
        77,
        -39
      ],
      [
        45,
        16
      ],
      [
        75,
        -3
      ]
    ],
    [
      [
        6569,
        2229
      ],
      [
        50,
        21
      ],
      [
        54,
        -17
      ],
      [
        74,
        9
      ],
      [
        31,
        16
      ],
      [
        -23,
        50
      ],
      [
        -165,
        6
      ]
    ],
    [
      [
        6590,
        2314
      ],
      [
        -43,
        -18
      ],
      [
        -80,
        67
      ]
    ],
    [
      [
        6467,
        2363
      ],
      [
        8,
        12
      ],
      [
        -45,
        59
      ]
    ],
    [
      [
        6430,
        2434
      ],
      [
        113,
        0
      ],
      [
        31,
        11
      ],
      [
        4,
        50
      ],
      [
        51,
        31
      ]
    ],
    [
      [
        7025,
        2256
      ],
      [
        21,
        -30
      ],
      [
        -68,
        -19
      ],
      [
        30,
        -24
      ],
      [
        -21,
        -17
      ],
      [
        16,
        -30
      ],
      [
        -58,
        -20
      ],
      [
        18,
        -30
      ],
      [
        -73,
        -31
      ]
    ],
    [
      [
        6890,
        2055
      ],
      [
        -53,
        -39
      ],
      [
        -98,
        -27
      ],
      [
        -24,
        -26
      ],
      [
        -23,
        -67
      ],
      [
        -86,
        -29
      ],
      [
        -49,
        26
      ]
    ],
    [
      [
        7773,
        1408
      ],
      [
        -31,
        5
      ],
      [
        -25,
        17
      ]
    ],
    [
      [
        7815,
        1556
      ],
      [
        16,
        -35
      ],
      [
        17,
        -27
      ]
    ],
    [
      [
        7973,
        1335
      ],
      [
        -69,
        -45
      ],
      [
        6,
        55
      ]
    ],
    [
      [
        8281,
        1117
      ],
      [
        -42,
        0
      ]
    ],
    [
      [
        7449,
        1296
      ],
      [
        44,
        30
      ],
      [
        22,
        3
      ]
    ],
    [
      [
        7515,
        1329
      ],
      [
        80,
        19
      ],
      [
        43,
        52
      ]
    ],
    [
      [
        7638,
        1400
      ],
      [
        46,
        -10
      ],
      [
        18,
        38
      ]
    ],
    [
      [
        9092,
        925
      ],
      [
        -68,
        12
      ],
      [
        -40,
        -7
      ],
      [
        -98,
        -55
      ],
      [
        -41,
        -11
      ],
      [
        -217,
        -27
      ],
      [
        -43,
        -9
      ],
      [
        -94,
        -66
      ],
      [
        -150,
        12
      ],
      [
        -27,
        13
      ],
      [
        -79,
        9
      ]
    ],
    [
      [
        6624,
        1466
      ],
      [
        -62,
        47
      ],
      [
        -28,
        4
      ],
      [
        20,
        54
      ],
      [
        -29,
        42
      ]
    ],
    [
      [
        6890,
        2055
      ],
      [
        84,
        -60
      ],
      [
        -70,
        -17
      ],
      [
        42,
        -89
      ],
      [
        82,
        -1
      ],
      [
        75,
        28
      ]
    ],
    [
      [
        7325,
        1494
      ],
      [
        15,
        -37
      ],
      [
        -35,
        -28
      ],
      [
        -57,
        -20
      ]
    ],
    [
      [
        7248,
        1409
      ],
      [
        -77,
        25
      ],
      [
        -41,
        7
      ]
    ],
    [
      [
        7130,
        1441
      ],
      [
        -64,
        37
      ],
      [
        -39,
        -7
      ],
      [
        -81,
        9
      ],
      [
        -25,
        15
      ],
      [
        -49,
        -11
      ],
      [
        -111,
        -3
      ],
      [
        -38,
        12
      ],
      [
        -81,
        -1
      ],
      [
        -18,
        -26
      ]
    ],
    [
      [
        6624,
        1466
      ],
      [
        5,
        -13
      ]
    ],
    [
      [
        6629,
        1453
      ],
      [
        -118,
        -39
      ],
      [
        -64,
        2
      ],
      [
        -49,
        16
      ],
      [
        -25,
        25
      ],
      [
        3,
        54
      ],
      [
        83,
        84
      ]
    ],
    [
      [
        7724,
        2490
      ],
      [
        25,
        -26
      ],
      [
        -7,
        -37
      ],
      [
        59,
        -8
      ]
    ],
    [
      [
        7757,
        2190
      ],
      [
        -44,
        -5
      ],
      [
        -39,
        -52
      ],
      [
        -50,
        18
      ],
      [
        -52,
        -6
      ],
      [
        8,
        -40
      ],
      [
        -21,
        -21
      ]
    ],
    [
      [
        7483,
        2371
      ],
      [
        50,
        33
      ],
      [
        134,
        44
      ],
      [
        57,
        41
      ]
    ],
    [
      [
        8145,
        1465
      ],
      [
        -4,
        7
      ],
      [
        -11,
        3
      ]
    ],
    [
      [
        8123,
        1506
      ],
      [
        9,
        10
      ],
      [
        33,
        2
      ]
    ],
    [
      [
        8208,
        1498
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -3
      ]
    ],
    [
      [
        8055,
        1511
      ],
      [
        17,
        32
      ],
      [
        15,
        6
      ]
    ],
    [
      [
        7922,
        1577
      ],
      [
        1,
        -9
      ],
      [
        27,
        -25
      ]
    ],
    [
      [
        8109,
        1455
      ],
      [
        28,
        -40
      ],
      [
        6,
        -39
      ]
    ],
    [
      [
        8150,
        1378
      ],
      [
        34,
        28
      ],
      [
        11,
        34
      ]
    ],
    [
      [
        8119,
        1459
      ],
      [
        13,
        2
      ],
      [
        18,
        -3
      ]
    ],
    [
      [
        5562,
        2211
      ],
      [
        34,
        -83
      ],
      [
        81,
        2
      ],
      [
        39,
        20
      ],
      [
        41,
        -6
      ],
      [
        -11,
        -26
      ],
      [
        43,
        -10
      ],
      [
        6,
        -57
      ],
      [
        60,
        -46
      ],
      [
        -2,
        -84
      ]
    ],
    [
      [
        6430,
        2434
      ],
      [
        -37,
        14
      ],
      [
        -41,
        -14
      ]
    ],
    [
      [
        6352,
        2434
      ],
      [
        -40,
        39
      ],
      [
        -2,
        29
      ],
      [
        -37,
        14
      ],
      [
        -18,
        -25
      ],
      [
        -99,
        -18
      ]
    ],
    [
      [
        6156,
        2473
      ],
      [
        -81,
        10
      ],
      [
        -70,
        -45
      ],
      [
        43,
        -31
      ],
      [
        33,
        -2
      ]
    ],
    [
      [
        6081,
        2405
      ],
      [
        -9,
        -26
      ],
      [
        -44,
        -13
      ],
      [
        19,
        -22
      ],
      [
        6,
        -49
      ]
    ],
    [
      [
        6053,
        2295
      ],
      [
        -68,
        11
      ],
      [
        -66,
        8
      ]
    ],
    [
      [
        5881,
        2591
      ],
      [
        -44,
        32
      ],
      [
        -29,
        36
      ]
    ],
    [
      [
        5826,
        2813
      ],
      [
        13,
        56
      ],
      [
        61,
        25
      ],
      [
        62,
        7
      ]
    ],
    [
      [
        5962,
        2901
      ],
      [
        43,
        -112
      ],
      [
        23,
        -17
      ],
      [
        66,
        -5
      ],
      [
        14,
        45
      ],
      [
        -50,
        57
      ],
      [
        -44,
        29
      ],
      [
        -13,
        28
      ]
    ],
    [
      [
        6001,
        2926
      ],
      [
        65,
        51
      ],
      [
        72,
        -4
      ],
      [
        93,
        38
      ]
    ],
    [
      [
        6053,
        2295
      ],
      [
        71,
        12
      ],
      [
        52,
        0
      ]
    ],
    [
      [
        6176,
        2307
      ],
      [
        49,
        -18
      ],
      [
        -15,
        -35
      ],
      [
        97,
        12
      ],
      [
        57,
        -8
      ]
    ],
    [
      [
        6560,
        4713
      ],
      [
        -41,
        4
      ],
      [
        9,
        -21
      ],
      [
        -70,
        -43
      ]
    ],
    [
      [
        6458,
        4653
      ],
      [
        -50,
        -27
      ],
      [
        -19,
        -63
      ]
    ],
    [
      [
        5900,
        4453
      ],
      [
        -58,
        25
      ],
      [
        -38,
        34
      ],
      [
        -100,
        -39
      ],
      [
        -63,
        17
      ],
      [
        -4,
        31
      ],
      [
        -27,
        23
      ],
      [
        52,
        37
      ],
      [
        -50,
        40
      ],
      [
        32,
        41
      ],
      [
        78,
        25
      ],
      [
        -3,
        37
      ],
      [
        -62,
        0
      ],
      [
        -51,
        40
      ],
      [
        -44,
        8
      ],
      [
        -43,
        54
      ]
    ],
    [
      [
        6185,
        5387
      ],
      [
        144,
        -101
      ],
      [
        63,
        -56
      ],
      [
        47,
        8
      ],
      [
        14,
        -30
      ],
      [
        57,
        4
      ],
      [
        69,
        -26
      ],
      [
        45,
        -92
      ],
      [
        -5,
        -99
      ],
      [
        32,
        -44
      ],
      [
        -11,
        -38
      ],
      [
        49,
        -53
      ],
      [
        -2,
        -56
      ],
      [
        43,
        -75
      ],
      [
        24,
        -14
      ]
    ],
    [
      [
        6754,
        4715
      ],
      [
        -38,
        -19
      ],
      [
        -67,
        2
      ],
      [
        -89,
        15
      ]
    ],
    [
      [
        6560,
        4713
      ],
      [
        23,
        -21
      ],
      [
        137,
        -57
      ]
    ],
    [
      [
        6720,
        4635
      ],
      [
        -28,
        -13
      ],
      [
        -15,
        -13
      ]
    ],
    [
      [
        6677,
        4609
      ],
      [
        -125,
        20
      ],
      [
        -94,
        24
      ]
    ],
    [
      [
        6754,
        4715
      ],
      [
        27,
        -33
      ],
      [
        16,
        -30
      ]
    ],
    [
      [
        6797,
        4652
      ],
      [
        -77,
        -17
      ]
    ],
    [
      [
        6797,
        4652
      ],
      [
        51,
        -33
      ],
      [
        2,
        -44
      ]
    ],
    [
      [
        6850,
        4575
      ],
      [
        -98,
        -7
      ],
      [
        -68,
        11
      ]
    ],
    [
      [
        6684,
        4579
      ],
      [
        6,
        17
      ],
      [
        -13,
        13
      ]
    ],
    [
      [
        6850,
        4575
      ],
      [
        4,
        -11
      ],
      [
        16,
        -30
      ]
    ],
    [
      [
        6632,
        4546
      ],
      [
        20,
        31
      ],
      [
        32,
        2
      ]
    ],
    [
      [
        5392,
        3116
      ],
      [
        -33,
        2
      ],
      [
        -32,
        7
      ]
    ],
    [
      [
        5327,
        3125
      ],
      [
        2,
        60
      ],
      [
        -31,
        21
      ],
      [
        6,
        42
      ],
      [
        -34,
        25
      ]
    ],
    [
      [
        5270,
        3273
      ],
      [
        24,
        11
      ],
      [
        12,
        16
      ]
    ],
    [
      [
        5388,
        3271
      ],
      [
        22,
        -81
      ],
      [
        38,
        -22
      ]
    ],
    [
      [
        5448,
        3168
      ],
      [
        -33,
        -38
      ],
      [
        -23,
        -14
      ]
    ],
    [
      [
        5270,
        3273
      ],
      [
        -38,
        -6
      ],
      [
        -78,
        -5
      ]
    ],
    [
      [
        5154,
        3262
      ],
      [
        -50,
        58
      ],
      [
        -2,
        25
      ],
      [
        78,
        74
      ],
      [
        73,
        52
      ]
    ],
    [
      [
        5327,
        3125
      ],
      [
        -50,
        17
      ],
      [
        -56,
        40
      ],
      [
        -67,
        80
      ]
    ],
    [
      [
        5522,
        3168
      ],
      [
        33,
        12
      ],
      [
        -18,
        45
      ],
      [
        101,
        -5
      ]
    ],
    [
      [
        5638,
        3220
      ],
      [
        44,
        25
      ],
      [
        37,
        -1
      ]
    ],
    [
      [
        5719,
        3244
      ],
      [
        39,
        -39
      ]
    ],
    [
      [
        5758,
        3205
      ],
      [
        -14,
        -28
      ],
      [
        32,
        -8
      ]
    ],
    [
      [
        5776,
        3169
      ],
      [
        -18,
        -22
      ],
      [
        -63,
        -22
      ]
    ],
    [
      [
        5695,
        3125
      ],
      [
        -46,
        -18
      ],
      [
        -14,
        0
      ]
    ],
    [
      [
        5635,
        3107
      ],
      [
        -95,
        42
      ],
      [
        -18,
        19
      ]
    ],
    [
      [
        5522,
        3168
      ],
      [
        -60,
        9
      ],
      [
        -14,
        -9
      ]
    ],
    [
      [
        5451,
        3290
      ],
      [
        62,
        -36
      ],
      [
        86,
        0
      ],
      [
        39,
        -34
      ]
    ],
    [
      [
        5181,
        3504
      ],
      [
        -36,
        52
      ],
      [
        12,
        69
      ],
      [
        -13,
        26
      ],
      [
        39,
        23
      ]
    ],
    [
      [
        6310,
        3309
      ],
      [
        -80,
        56
      ],
      [
        -11,
        19
      ]
    ],
    [
      [
        6219,
        3384
      ],
      [
        -29,
        3
      ],
      [
        -7,
        19
      ]
    ],
    [
      [
        6183,
        3406
      ],
      [
        202,
        30
      ],
      [
        85,
        29
      ],
      [
        -18,
        33
      ]
    ],
    [
      [
        6452,
        3498
      ],
      [
        36,
        14
      ],
      [
        73,
        8
      ]
    ],
    [
      [
        6561,
        3520
      ],
      [
        67,
        -57
      ]
    ],
    [
      [
        6628,
        3463
      ],
      [
        -8,
        -37
      ],
      [
        -31,
        -11
      ],
      [
        20,
        -68
      ]
    ],
    [
      [
        6609,
        3347
      ],
      [
        -75,
        -22
      ],
      [
        -40,
        4
      ],
      [
        -92,
        -21
      ],
      [
        -11,
        -14
      ]
    ],
    [
      [
        6183,
        3406
      ],
      [
        -22,
        41
      ],
      [
        -53,
        -11
      ],
      [
        -53,
        23
      ]
    ],
    [
      [
        6230,
        3617
      ],
      [
        55,
        -42
      ],
      [
        43,
        -4
      ],
      [
        89,
        -43
      ],
      [
        35,
        -30
      ]
    ],
    [
      [
        6480,
        3648
      ],
      [
        52,
        -45
      ],
      [
        0,
        -56
      ],
      [
        51,
        -3
      ],
      [
        -22,
        -24
      ]
    ],
    [
      [
        6903,
        3497
      ],
      [
        -23,
        -19
      ],
      [
        -86,
        -22
      ],
      [
        -113,
        17
      ],
      [
        -53,
        -10
      ]
    ],
    [
      [
        6980,
        3390
      ],
      [
        -12,
        -22
      ],
      [
        -63,
        -20
      ],
      [
        -39,
        5
      ]
    ],
    [
      [
        6866,
        3353
      ],
      [
        -23,
        16
      ],
      [
        -168,
        -5
      ],
      [
        -26,
        12
      ],
      [
        -40,
        -29
      ]
    ],
    [
      [
        5719,
        3244
      ],
      [
        -17,
        49
      ],
      [
        -9,
        22
      ]
    ],
    [
      [
        5869,
        3310
      ],
      [
        31,
        -27
      ]
    ],
    [
      [
        5900,
        3283
      ],
      [
        6,
        -29
      ],
      [
        -21,
        -19
      ]
    ],
    [
      [
        5885,
        3235
      ],
      [
        -89,
        1
      ],
      [
        -38,
        -31
      ]
    ],
    [
      [
        5948,
        3383
      ],
      [
        4,
        -25
      ],
      [
        2,
        -33
      ]
    ],
    [
      [
        5954,
        3325
      ],
      [
        -28,
        -18
      ],
      [
        -26,
        -24
      ]
    ],
    [
      [
        6219,
        3384
      ],
      [
        -165,
        -44
      ],
      [
        -30,
        -37
      ]
    ],
    [
      [
        6024,
        3303
      ],
      [
        -70,
        22
      ]
    ],
    [
      [
        6229,
        3251
      ],
      [
        -56,
        22
      ],
      [
        -72,
        14
      ],
      [
        -99,
        -29
      ]
    ],
    [
      [
        6002,
        3258
      ],
      [
        15,
        25
      ],
      [
        7,
        20
      ]
    ],
    [
      [
        6195,
        3199
      ],
      [
        -112,
        -3
      ],
      [
        -102,
        26
      ]
    ],
    [
      [
        5981,
        3222
      ],
      [
        0,
        20
      ],
      [
        21,
        16
      ]
    ],
    [
      [
        6190,
        3161
      ],
      [
        -33,
        -17
      ],
      [
        -71,
        6
      ],
      [
        -39,
        -34
      ],
      [
        -16,
        22
      ],
      [
        -86,
        0
      ]
    ],
    [
      [
        5945,
        3138
      ],
      [
        -6,
        22
      ],
      [
        33,
        28
      ],
      [
        9,
        34
      ]
    ],
    [
      [
        5945,
        3138
      ],
      [
        -23,
        -3
      ],
      [
        -34,
        16
      ]
    ],
    [
      [
        5888,
        3151
      ],
      [
        -14,
        26
      ],
      [
        28,
        35
      ],
      [
        -17,
        23
      ]
    ],
    [
      [
        5888,
        3151
      ],
      [
        -48,
        2
      ],
      [
        -64,
        16
      ]
    ],
    [
      [
        6001,
        2926
      ],
      [
        -39,
        -25
      ]
    ],
    [
      [
        5580,
        2809
      ],
      [
        4,
        39
      ],
      [
        -48,
        18
      ],
      [
        14,
        39
      ],
      [
        165,
        52
      ],
      [
        2,
        36
      ],
      [
        38,
        -5
      ],
      [
        40,
        46
      ],
      [
        -12,
        23
      ],
      [
        -54,
        24
      ],
      [
        -34,
        44
      ]
    ],
    [
      [
        7035,
        3090
      ],
      [
        63,
        57
      ],
      [
        -4,
        21
      ]
    ],
    [
      [
        7094,
        3168
      ],
      [
        51,
        32
      ],
      [
        54,
        -4
      ],
      [
        43,
        49
      ],
      [
        52,
        23
      ]
    ],
    [
      [
        7294,
        3268
      ],
      [
        14,
        -27
      ],
      [
        109,
        -5
      ]
    ],
    [
      [
        6817,
        3120
      ],
      [
        -2,
        53
      ],
      [
        -11,
        25
      ]
    ],
    [
      [
        6804,
        3198
      ],
      [
        0,
        30
      ],
      [
        81,
        31
      ]
    ],
    [
      [
        6885,
        3259
      ],
      [
        68,
        -8
      ],
      [
        17,
        -32
      ],
      [
        124,
        -51
      ]
    ],
    [
      [
        6391,
        3294
      ],
      [
        229,
        -17
      ],
      [
        30,
        -25
      ],
      [
        95,
        -1
      ],
      [
        17,
        -35
      ],
      [
        42,
        -18
      ]
    ],
    [
      [
        6866,
        3353
      ],
      [
        50,
        -61
      ],
      [
        -31,
        -33
      ]
    ],
    [
      [
        7294,
        3268
      ],
      [
        -24,
        27
      ],
      [
        72,
        13
      ],
      [
        -34,
        37
      ],
      [
        44,
        9
      ],
      [
        1,
        28
      ]
    ],
    [
      [
        7514,
        3454
      ],
      [
        51,
        18
      ],
      [
        54,
        -3
      ],
      [
        66,
        -27
      ],
      [
        43,
        15
      ],
      [
        181,
        18
      ],
      [
        27,
        -6
      ],
      [
        82,
        -71
      ]
    ],
    [
      [
        6176,
        2307
      ],
      [
        5,
        25
      ]
    ],
    [
      [
        6181,
        2332
      ],
      [
        64,
        -2
      ],
      [
        -2,
        30
      ],
      [
        62,
        48
      ]
    ],
    [
      [
        6305,
        2408
      ],
      [
        31,
        11
      ],
      [
        16,
        15
      ]
    ],
    [
      [
        6467,
        2363
      ],
      [
        -49,
        -4
      ],
      [
        24,
        -28
      ],
      [
        -6,
        -42
      ],
      [
        -37,
        -5
      ],
      [
        -27,
        -29
      ]
    ],
    [
      [
        6181,
        2332
      ],
      [
        -64,
        23
      ],
      [
        24,
        25
      ],
      [
        -13,
        37
      ]
    ],
    [
      [
        6128,
        2417
      ],
      [
        23,
        10
      ]
    ],
    [
      [
        6151,
        2427
      ],
      [
        14,
        -13
      ],
      [
        53,
        11
      ],
      [
        87,
        -17
      ]
    ],
    [
      [
        6081,
        2405
      ],
      [
        8,
        15
      ],
      [
        39,
        -3
      ]
    ],
    [
      [
        6156,
        2473
      ],
      [
        16,
        -30
      ],
      [
        -21,
        -16
      ]
    ],
    [
      [
        6590,
        2314
      ],
      [
        -21,
        -85
      ]
    ],
    [
      [
        7641,
        1996
      ],
      [
        71,
        -23
      ],
      [
        44,
        5
      ],
      [
        66,
        -9
      ],
      [
        56,
        35
      ],
      [
        -6,
        34
      ],
      [
        19,
        33
      ],
      [
        72,
        12
      ]
    ],
    [
      [
        7830,
        1835
      ],
      [
        -80,
        -6
      ],
      [
        -12,
        -22
      ],
      [
        25,
        -39
      ]
    ],
    [
      [
        7248,
        1409
      ],
      [
        -20,
        -29
      ],
      [
        -70,
        -10
      ]
    ],
    [
      [
        7158,
        1370
      ],
      [
        -30,
        20
      ],
      [
        2,
        51
      ]
    ],
    [
      [
        7158,
        1370
      ],
      [
        17,
        -25
      ],
      [
        5,
        -27
      ]
    ],
    [
      [
        6722,
        1297
      ],
      [
        -11,
        31
      ],
      [
        -36,
        11
      ],
      [
        -30,
        31
      ],
      [
        42,
        12
      ],
      [
        -58,
        71
      ]
    ],
    [
      [
        7367,
        1489
      ],
      [
        16,
        -34
      ],
      [
        3,
        -32
      ]
    ],
    [
      [
        7386,
        1423
      ],
      [
        13,
        -66
      ],
      [
        -38,
        -44
      ]
    ],
    [
      [
        7386,
        1423
      ],
      [
        115,
        -16
      ],
      [
        33,
        -45
      ],
      [
        -35,
        -10
      ],
      [
        16,
        -23
      ]
    ],
    [
      [
        7579,
        1444
      ],
      [
        56,
        -16
      ],
      [
        3,
        -28
      ]
    ],
    [
      [
        5117,
        3058
      ],
      [
        0,
        16
      ],
      [
        -12,
        11
      ]
    ],
    [
      [
        5105,
        3085
      ],
      [
        30,
        16
      ],
      [
        122,
        -14
      ],
      [
        18,
        14
      ]
    ],
    [
      [
        5275,
        3101
      ],
      [
        46,
        -15
      ],
      [
        107,
        10
      ]
    ],
    [
      [
        5428,
        3096
      ],
      [
        40,
        -8
      ],
      [
        108,
        3
      ],
      [
        59,
        16
      ]
    ],
    [
      [
        5428,
        3096
      ],
      [
        61,
        49
      ],
      [
        -97,
        -29
      ]
    ],
    [
      [
        7724,
        2490
      ],
      [
        90,
        0
      ]
    ],
    [
      [
        7043,
        630
      ],
      [
        -112,
        -19
      ],
      [
        -35,
        7
      ],
      [
        -184,
        76
      ],
      [
        -72,
        -14
      ],
      [
        64,
        46
      ],
      [
        87,
        23
      ],
      [
        19,
        -10
      ],
      [
        57,
        35
      ],
      [
        48,
        12
      ],
      [
        152,
        -37
      ],
      [
        36,
        0
      ],
      [
        47,
        -37
      ],
      [
        -103,
        -47
      ],
      [
        -4,
        -35
      ]
    ],
    [
      [
        4443,
        7052
      ],
      [
        69,
        26
      ],
      [
        62,
        8
      ],
      [
        -22,
        -20
      ],
      [
        55,
        0
      ],
      [
        -21,
        25
      ],
      [
        77,
        -6
      ],
      [
        45,
        47
      ],
      [
        82,
        10
      ],
      [
        125,
        -3
      ],
      [
        75,
        -25
      ],
      [
        132,
        -22
      ],
      [
        85,
        6
      ],
      [
        78,
        25
      ],
      [
        96,
        0
      ]
    ],
    [
      [
        5769,
        6243
      ],
      [
        -16,
        -46
      ],
      [
        -35,
        -34
      ],
      [
        6,
        -25
      ],
      [
        -50,
        -41
      ],
      [
        -95,
        -34
      ],
      [
        -17,
        -19
      ],
      [
        -59,
        -18
      ],
      [
        -28,
        -31
      ],
      [
        -92,
        2
      ]
    ],
    [
      [
        5140,
        5518
      ],
      [
        122,
        19
      ],
      [
        70,
        57
      ],
      [
        67,
        31
      ],
      [
        169,
        -6
      ],
      [
        66,
        -31
      ],
      [
        -14,
        -20
      ],
      [
        55,
        -6
      ],
      [
        21,
        13
      ],
      [
        148,
        -53
      ]
    ],
    [
      [
        4486,
        1211
      ],
      [
        72,
        -11
      ],
      [
        82,
        2
      ],
      [
        125,
        -17
      ],
      [
        49,
        -21
      ],
      [
        116,
        2
      ],
      [
        107,
        16
      ],
      [
        107,
        1
      ],
      [
        29,
        12
      ],
      [
        7,
        -26
      ],
      [
        22,
        38
      ],
      [
        -11,
        71
      ],
      [
        18,
        9
      ]
    ],
    [
      [
        5915,
        1290
      ],
      [
        54,
        -55
      ],
      [
        -30,
        -51
      ],
      [
        -83,
        -83
      ],
      [
        27,
        -31
      ]
    ],
    [
      [
        4125,
        1611
      ],
      [
        -76,
        -8
      ],
      [
        -54,
        17
      ],
      [
        -94,
        -12
      ],
      [
        -49,
        17
      ],
      [
        -37,
        33
      ],
      [
        59,
        -2
      ],
      [
        -73,
        36
      ],
      [
        -56,
        2
      ],
      [
        23,
        -18
      ],
      [
        -34,
        -10
      ],
      [
        -115,
        5
      ],
      [
        -66,
        -8
      ]
    ],
    [
      [
        5105,
        3085
      ],
      [
        -90,
        82
      ],
      [
        28,
        29
      ],
      [
        100,
        24
      ],
      [
        47,
        -17
      ],
      [
        59,
        -84
      ],
      [
        26,
        -18
      ]
    ],
    [
      [
        3992,
        491
      ],
      [
        -32,
        -11
      ],
      [
        7,
        -38
      ],
      [
        -62,
        0
      ],
      [
        17,
        -14
      ],
      [
        56,
        5
      ],
      [
        -11,
        -16
      ],
      [
        48,
        -12
      ],
      [
        -35,
        -31
      ],
      [
        -38,
        30
      ],
      [
        -85,
        14
      ],
      [
        -46,
        -3
      ],
      [
        -112,
        -36
      ],
      [
        -167,
        -5
      ],
      [
        -27,
        18
      ],
      [
        -66,
        -11
      ],
      [
        -47,
        -93
      ],
      [
        -50,
        6
      ],
      [
        -98,
        -33
      ],
      [
        -56,
        -51
      ],
      [
        -18,
        44
      ],
      [
        -33,
        4
      ],
      [
        -40,
        -82
      ],
      [
        37,
        -42
      ],
      [
        -42,
        -42
      ],
      [
        -48,
        -4
      ],
      [
        -45,
        -47
      ],
      [
        -58,
        37
      ],
      [
        -4,
        26
      ],
      [
        -71,
        56
      ],
      [
        -152,
        38
      ],
      [
        -66,
        -16
      ],
      [
        5,
        -28
      ],
      [
        -44,
        -25
      ],
      [
        -90,
        -11
      ],
      [
        -37,
        9
      ],
      [
        -5,
        73
      ],
      [
        25,
        26
      ],
      [
        176,
        53
      ],
      [
        72,
        -23
      ],
      [
        51,
        42
      ],
      [
        73,
        13
      ],
      [
        116,
        70
      ],
      [
        54,
        23
      ],
      [
        -7,
        40
      ],
      [
        103,
        27
      ],
      [
        25,
        87
      ],
      [
        79,
        35
      ],
      [
        14,
        -39
      ],
      [
        77,
        7
      ],
      [
        -66,
        25
      ],
      [
        2,
        32
      ],
      [
        128,
        5
      ],
      [
        44,
        45
      ],
      [
        -6,
        13
      ],
      [
        98,
        48
      ],
      [
        20,
        28
      ],
      [
        61,
        30
      ],
      [
        27,
        32
      ],
      [
        2,
        104
      ]
    ],
    [
      [
        4196,
        3050
      ],
      [
        136,
        37
      ],
      [
        33,
        -1
      ],
      [
        -47,
        45
      ],
      [
        69,
        -19
      ],
      [
        42,
        2
      ],
      [
        52,
        -29
      ],
      [
        115,
        1
      ],
      [
        89,
        19
      ]
    ],
    [
      [
        2623,
        4351
      ],
      [
        28,
        -13
      ],
      [
        22,
        -55
      ],
      [
        37,
        -26
      ],
      [
        10,
        -49
      ],
      [
        34,
        -45
      ],
      [
        -30,
        -37
      ],
      [
        4,
        -31
      ],
      [
        -42,
        -48
      ],
      [
        -25,
        5
      ],
      [
        -50,
        53
      ],
      [
        28,
        37
      ],
      [
        2,
        41
      ],
      [
        -28,
        38
      ],
      [
        -71,
        35
      ],
      [
        -57,
        9
      ],
      [
        -13,
        -38
      ],
      [
        90,
        -18
      ],
      [
        -13,
        -48
      ]
    ],
    [
      [
        5352,
        4753
      ],
      [
        -72,
        -36
      ],
      [
        -32,
        -28
      ],
      [
        -76,
        4
      ],
      [
        -21,
        -59
      ]
    ],
    [
      [
        5151,
        4634
      ],
      [
        -86,
        -12
      ],
      [
        -320,
        13
      ],
      [
        -48,
        9
      ],
      [
        -25,
        -14
      ],
      [
        -44,
        17
      ],
      [
        -13,
        -25
      ],
      [
        14,
        -63
      ],
      [
        -30,
        -19
      ],
      [
        -119,
        2
      ],
      [
        -21,
        -19
      ],
      [
        -106,
        6
      ],
      [
        -14,
        -20
      ],
      [
        34,
        -18
      ],
      [
        -141,
        -49
      ],
      [
        -79,
        -2
      ],
      [
        -7,
        49
      ],
      [
        -40,
        -12
      ],
      [
        6,
        -30
      ],
      [
        -39,
        -4
      ],
      [
        -52,
        18
      ],
      [
        -35,
        31
      ],
      [
        8,
        37
      ],
      [
        -70,
        -25
      ],
      [
        -75,
        19
      ],
      [
        -57,
        43
      ],
      [
        -25,
        -34
      ],
      [
        24,
        -42
      ],
      [
        56,
        -15
      ],
      [
        -11,
        -33
      ],
      [
        10,
        -64
      ],
      [
        -24,
        -17
      ],
      [
        -134,
        20
      ],
      [
        -91,
        65
      ],
      [
        -119,
        38
      ],
      [
        -67,
        14
      ],
      [
        -19,
        26
      ],
      [
        -60,
        5
      ],
      [
        -47,
        -15
      ],
      [
        -47,
        -37
      ],
      [
        57,
        -96
      ],
      [
        30,
        -14
      ],
      [
        7,
        -52
      ],
      [
        -85,
        18
      ],
      [
        -16,
        21
      ],
      [
        6,
        49
      ],
      [
        -34,
        6
      ],
      [
        -16,
        33
      ],
      [
        -30,
        10
      ],
      [
        -95,
        60
      ],
      [
        -47,
        61
      ],
      [
        4,
        86
      ],
      [
        56,
        21
      ],
      [
        51,
        -51
      ],
      [
        4,
        -41
      ],
      [
        48,
        -20
      ],
      [
        25,
        23
      ],
      [
        -45,
        54
      ]
    ],
    [
      [
        5366,
        3890
      ],
      [
        -17,
        24
      ],
      [
        33,
        25
      ],
      [
        -85,
        -31
      ],
      [
        -16,
        -23
      ],
      [
        -63,
        -8
      ],
      [
        -27,
        18
      ],
      [
        -13,
        44
      ],
      [
        -37,
        -54
      ],
      [
        -58,
        -49
      ],
      [
        -28,
        -8
      ],
      [
        1,
        -33
      ],
      [
        -45,
        31
      ],
      [
        -52,
        13
      ],
      [
        26,
        62
      ],
      [
        8,
        76
      ],
      [
        -33,
        -38
      ],
      [
        8,
        -17
      ],
      [
        -75,
        -10
      ],
      [
        -101,
        79
      ],
      [
        3,
        37
      ],
      [
        -70,
        68
      ],
      [
        -161,
        109
      ],
      [
        45,
        48
      ],
      [
        25,
        71
      ],
      [
        64,
        76
      ],
      [
        33,
        9
      ],
      [
        37,
        41
      ],
      [
        -9,
        16
      ],
      [
        52,
        78
      ],
      [
        44,
        17
      ],
      [
        50,
        -13
      ],
      [
        40,
        11
      ],
      [
        -62,
        19
      ],
      [
        41,
        21
      ],
      [
        63,
        10
      ],
      [
        91,
        -19
      ],
      [
        102,
        19
      ],
      [
        -69,
        6
      ],
      [
        40,
        19
      ]
    ],
    [
      [
        9975,
        2395
      ],
      [
        24,
        -43
      ],
      [
        -45,
        -82
      ],
      [
        -44,
        -66
      ],
      [
        -53,
        -49
      ],
      [
        0,
        -65
      ],
      [
        -49,
        -108
      ],
      [
        -111,
        -23
      ],
      [
        -47,
        -49
      ],
      [
        -92,
        -57
      ],
      [
        -70,
        50
      ],
      [
        -79,
        28
      ],
      [
        -27,
        -4
      ],
      [
        57,
        -27
      ],
      [
        61,
        -13
      ],
      [
        -4,
        -19
      ],
      [
        -65,
        -3
      ],
      [
        -42,
        12
      ],
      [
        -87,
        -15
      ]
    ],
    [
      [
        8732,
        1439
      ],
      [
        24,
        3
      ],
      [
        161,
        -12
      ],
      [
        27,
        -29
      ],
      [
        -82,
        -2
      ],
      [
        -87,
        -29
      ],
      [
        32,
        -19
      ],
      [
        84,
        -1
      ]
    ],
    [
      [
        6601,
        8809
      ],
      [
        -2,
        -7
      ],
      [
        13,
        0
      ],
      [
        0,
        -6
      ],
      [
        -16,
        -6
      ],
      [
        -19,
        -8
      ],
      [
        -14,
        -3
      ],
      [
        -5,
        13
      ],
      [
        7,
        16
      ],
      [
        19,
        9
      ],
      [
        22,
        4
      ],
      [
        20,
        0
      ],
      [
        0,
        -4
      ],
      [
        -7,
        -3
      ],
      [
        -14,
        -1
      ],
      [
        -4,
        -4
      ]
    ],
    [
      [
        6890,
        9309
      ],
      [
        -2,
        -5
      ],
      [
        7,
        5
      ],
      [
        8,
        0
      ],
      [
        2,
        -6
      ],
      [
        -4,
        -10
      ],
      [
        -8,
        -9
      ],
      [
        -9,
        -14
      ],
      [
        -7,
        -7
      ],
      [
        -6,
        0
      ],
      [
        2,
        7
      ],
      [
        4,
        10
      ],
      [
        1,
        11
      ],
      [
        -2,
        2
      ],
      [
        -4,
        -11
      ],
      [
        -15,
        -12
      ],
      [
        -15,
        -6
      ],
      [
        -1,
        4
      ],
      [
        13,
        8
      ],
      [
        5,
        11
      ],
      [
        4,
        12
      ],
      [
        9,
        10
      ],
      [
        -3,
        6
      ],
      [
        -5,
        4
      ],
      [
        1,
        4
      ],
      [
        18,
        2
      ],
      [
        7,
        4
      ],
      [
        4,
        0
      ],
      [
        2,
        -9
      ],
      [
        -6,
        -11
      ]
    ],
    [
      [
        6158,
        9342
      ],
      [
        -15,
        -11
      ],
      [
        -23,
        5
      ],
      [
        -19,
        8
      ],
      [
        -7,
        6
      ],
      [
        2,
        6
      ],
      [
        7,
        5
      ],
      [
        16,
        4
      ],
      [
        23,
        2
      ],
      [
        12,
        -2
      ],
      [
        4,
        -7
      ],
      [
        0,
        -16
      ]
    ],
    [
      [
        7137,
        9391
      ],
      [
        3,
        -9
      ],
      [
        2,
        -8
      ],
      [
        7,
        0
      ],
      [
        12,
        4
      ],
      [
        0,
        -6
      ],
      [
        -2,
        -13
      ],
      [
        -6,
        -10
      ],
      [
        -7,
        -8
      ],
      [
        -8,
        -19
      ],
      [
        -11,
        -2
      ],
      [
        -28,
        10
      ],
      [
        -10,
        6
      ],
      [
        4,
        29
      ],
      [
        -18,
        12
      ],
      [
        2,
        10
      ],
      [
        19,
        1
      ],
      [
        19,
        -4
      ],
      [
        7,
        2
      ],
      [
        3,
        8
      ],
      [
        8,
        1
      ],
      [
        4,
        -4
      ]
    ],
    [
      [
        7236,
        9534
      ],
      [
        -39,
        -5
      ],
      [
        -19,
        6
      ],
      [
        10,
        8
      ],
      [
        8,
        11
      ],
      [
        10,
        7
      ],
      [
        11,
        2
      ],
      [
        11,
        1
      ],
      [
        9,
        3
      ],
      [
        8,
        5
      ],
      [
        35,
        1
      ],
      [
        21,
        4
      ],
      [
        1,
        -4
      ],
      [
        -8,
        -5
      ],
      [
        -13,
        -8
      ],
      [
        -17,
        -11
      ],
      [
        -28,
        -15
      ]
    ],
    [
      [
        7404,
        9780
      ],
      [
        9,
        -1
      ],
      [
        16,
        7
      ],
      [
        16,
        -2
      ],
      [
        10,
        -5
      ],
      [
        4,
        -8
      ],
      [
        -6,
        -10
      ],
      [
        -24,
        -10
      ],
      [
        -29,
        3
      ],
      [
        -29,
        8
      ],
      [
        -28,
        -1
      ],
      [
        -1,
        -7
      ],
      [
        6,
        -3
      ],
      [
        9,
        -9
      ],
      [
        -28,
        3
      ],
      [
        -22,
        15
      ],
      [
        -34,
        31
      ],
      [
        0,
        8
      ],
      [
        118,
        -1
      ],
      [
        10,
        -2
      ],
      [
        2,
        -6
      ],
      [
        -1,
        -7
      ],
      [
        2,
        -3
      ]
    ],
    [
      [
        6919,
        9772
      ],
      [
        -1,
        -6
      ],
      [
        -6,
        -4
      ],
      [
        -11,
        -1
      ],
      [
        9,
        -21
      ],
      [
        -9,
        -10
      ],
      [
        -14,
        -7
      ],
      [
        -13,
        -12
      ],
      [
        22,
        0
      ],
      [
        -11,
        -6
      ],
      [
        -10,
        -1
      ],
      [
        12,
        -5
      ],
      [
        9,
        -1
      ],
      [
        -22,
        -31
      ],
      [
        11,
        1
      ],
      [
        16,
        6
      ],
      [
        9,
        5
      ],
      [
        6,
        -5
      ],
      [
        -14,
        -15
      ],
      [
        -3,
        -5
      ],
      [
        3,
        -5
      ],
      [
        0,
        -8
      ],
      [
        -20,
        -3
      ],
      [
        -24,
        -32
      ],
      [
        -17,
        -8
      ],
      [
        -1,
        -7
      ],
      [
        14,
        -1
      ],
      [
        11,
        1
      ],
      [
        12,
        3
      ],
      [
        10,
        4
      ],
      [
        -1,
        17
      ],
      [
        28,
        9
      ],
      [
        63,
        5
      ],
      [
        -48,
        17
      ],
      [
        -14,
        8
      ],
      [
        10,
        7
      ],
      [
        14,
        5
      ],
      [
        10,
        -2
      ],
      [
        1,
        -15
      ],
      [
        10,
        5
      ],
      [
        20,
        16
      ],
      [
        4,
        6
      ],
      [
        9,
        3
      ],
      [
        19,
        -5
      ],
      [
        13,
        -9
      ],
      [
        -6,
        -11
      ],
      [
        12,
        -3
      ],
      [
        10,
        -4
      ],
      [
        8,
        -8
      ],
      [
        5,
        -10
      ],
      [
        -8,
        -6
      ],
      [
        15,
        -6
      ],
      [
        -14,
        -5
      ],
      [
        -22,
        6
      ],
      [
        -10,
        -4
      ],
      [
        -7,
        -7
      ],
      [
        -11,
        -4
      ],
      [
        -10,
        -3
      ],
      [
        3,
        -2
      ],
      [
        13,
        1
      ],
      [
        24,
        5
      ],
      [
        -15,
        -6
      ],
      [
        0,
        -7
      ],
      [
        33,
        9
      ],
      [
        13,
        -3
      ],
      [
        1,
        -18
      ],
      [
        8,
        0
      ],
      [
        4,
        9
      ],
      [
        9,
        -1
      ],
      [
        8,
        4
      ],
      [
        4,
        5
      ],
      [
        8,
        15
      ],
      [
        9,
        6
      ],
      [
        4,
        -6
      ],
      [
        1,
        -7
      ],
      [
        10,
        15
      ],
      [
        14,
        11
      ],
      [
        20,
        5
      ],
      [
        20,
        0
      ],
      [
        -15,
        -15
      ],
      [
        -70,
        -39
      ],
      [
        -6,
        -7
      ],
      [
        1,
        -7
      ],
      [
        6,
        -2
      ],
      [
        8,
        4
      ],
      [
        10,
        9
      ],
      [
        18,
        8
      ],
      [
        14,
        0
      ],
      [
        6,
        -10
      ],
      [
        -3,
        -15
      ],
      [
        -5,
        -9
      ],
      [
        -9,
        -4
      ],
      [
        -79,
        -4
      ],
      [
        -15,
        -3
      ],
      [
        21,
        -9
      ],
      [
        50,
        -6
      ],
      [
        26,
        -10
      ],
      [
        -47,
        -22
      ],
      [
        -15,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        4,
        -10
      ],
      [
        6,
        -1
      ],
      [
        7,
        5
      ],
      [
        13,
        -3
      ],
      [
        13,
        -1
      ],
      [
        6,
        -3
      ],
      [
        -40,
        -18
      ],
      [
        -19,
        -3
      ],
      [
        -16,
        2
      ],
      [
        -10,
        12
      ],
      [
        -8,
        7
      ],
      [
        -10,
        0
      ],
      [
        -6,
        -5
      ],
      [
        1,
        -6
      ],
      [
        4,
        -4
      ],
      [
        9,
        -4
      ],
      [
        0,
        -6
      ],
      [
        -11,
        0
      ],
      [
        -8,
        -1
      ],
      [
        -17,
        -5
      ],
      [
        0,
        -5
      ],
      [
        41,
        0
      ],
      [
        -12,
        -13
      ],
      [
        -8,
        -13
      ],
      [
        18,
        12
      ],
      [
        11,
        5
      ],
      [
        13,
        2
      ],
      [
        -30,
        -31
      ],
      [
        -5,
        -14
      ],
      [
        16,
        11
      ],
      [
        21,
        4
      ],
      [
        11,
        -4
      ],
      [
        -13,
        -16
      ],
      [
        34,
        -13
      ],
      [
        0,
        -6
      ],
      [
        -28,
        0
      ],
      [
        0,
        -7
      ],
      [
        8,
        0
      ],
      [
        -1,
        -6
      ],
      [
        -17,
        5
      ],
      [
        -10,
        -4
      ],
      [
        -10,
        -7
      ],
      [
        -18,
        1
      ],
      [
        14,
        -7
      ],
      [
        -4,
        -8
      ],
      [
        -6,
        -5
      ],
      [
        -7,
        -1
      ],
      [
        -10,
        0
      ],
      [
        -1,
        -5
      ],
      [
        8,
        -1
      ],
      [
        20,
        -5
      ],
      [
        -16,
        -11
      ],
      [
        8,
        -12
      ],
      [
        18,
        -9
      ],
      [
        11,
        0
      ],
      [
        -5,
        -12
      ],
      [
        -16,
        -7
      ],
      [
        -19,
        -2
      ],
      [
        -16,
        2
      ],
      [
        6,
        -12
      ],
      [
        22,
        -26
      ],
      [
        -9,
        -10
      ],
      [
        -14,
        0
      ],
      [
        -32,
        10
      ],
      [
        4,
        -19
      ],
      [
        -2,
        -19
      ],
      [
        -9,
        -18
      ],
      [
        -13,
        -12
      ],
      [
        -7,
        6
      ],
      [
        8,
        -11
      ],
      [
        3,
        -9
      ],
      [
        -3,
        -11
      ],
      [
        -8,
        -12
      ],
      [
        10,
        -7
      ],
      [
        3,
        -8
      ],
      [
        -3,
        -7
      ],
      [
        -11,
        -4
      ],
      [
        -4,
        4
      ],
      [
        -17,
        14
      ],
      [
        -7,
        -9
      ],
      [
        -9,
        2
      ],
      [
        -1,
        6
      ],
      [
        12,
        9
      ],
      [
        0,
        6
      ],
      [
        -16,
        6
      ],
      [
        -32,
        -4
      ],
      [
        -15,
        4
      ],
      [
        -13,
        12
      ],
      [
        19,
        11
      ],
      [
        -7,
        15
      ],
      [
        9,
        7
      ],
      [
        10,
        5
      ],
      [
        10,
        2
      ],
      [
        13,
        -2
      ],
      [
        0,
        6
      ],
      [
        -18,
        10
      ],
      [
        -9,
        3
      ],
      [
        0,
        6
      ],
      [
        26,
        0
      ],
      [
        -5,
        16
      ],
      [
        10,
        15
      ],
      [
        16,
        15
      ],
      [
        14,
        44
      ],
      [
        15,
        17
      ],
      [
        11,
        19
      ],
      [
        -5,
        24
      ],
      [
        -4,
        4
      ],
      [
        -12,
        0
      ],
      [
        -6,
        9
      ],
      [
        5,
        8
      ],
      [
        15,
        19
      ],
      [
        -10,
        0
      ],
      [
        -15,
        -6
      ],
      [
        -3,
        -2
      ],
      [
        -12,
        1
      ],
      [
        -2,
        3
      ],
      [
        3,
        7
      ],
      [
        15,
        24
      ],
      [
        7,
        9
      ],
      [
        9,
        8
      ],
      [
        10,
        4
      ],
      [
        1,
        7
      ],
      [
        -21,
        1
      ],
      [
        -14,
        -10
      ],
      [
        -27,
        -29
      ],
      [
        -14,
        21
      ],
      [
        -15,
        16
      ],
      [
        -21,
        9
      ],
      [
        -34,
        4
      ],
      [
        2,
        -7
      ],
      [
        19,
        -4
      ],
      [
        15,
        -8
      ],
      [
        15,
        -11
      ],
      [
        12,
        -13
      ],
      [
        -7,
        -14
      ],
      [
        -20,
        10
      ],
      [
        -9,
        3
      ],
      [
        -13,
        0
      ],
      [
        1,
        -16
      ],
      [
        -7,
        -13
      ],
      [
        -9,
        -2
      ],
      [
        -6,
        13
      ],
      [
        -11,
        -5
      ],
      [
        -5,
        -10
      ],
      [
        -3,
        -10
      ],
      [
        -7,
        -7
      ],
      [
        -11,
        0
      ],
      [
        -39,
        13
      ],
      [
        -2,
        2
      ],
      [
        -22,
        11
      ],
      [
        -3,
        0
      ],
      [
        -6,
        8
      ],
      [
        0,
        4
      ],
      [
        6,
        6
      ],
      [
        12,
        5
      ],
      [
        31,
        4
      ],
      [
        13,
        3
      ],
      [
        -13,
        4
      ],
      [
        -25,
        20
      ],
      [
        -4,
        -8
      ],
      [
        -6,
        -12
      ],
      [
        -12,
        -9
      ],
      [
        -12,
        -1
      ],
      [
        -11,
        17
      ],
      [
        -14,
        -2
      ],
      [
        -31,
        -9
      ],
      [
        -22,
        -1
      ],
      [
        -10,
        1
      ],
      [
        -6,
        4
      ],
      [
        -1,
        8
      ],
      [
        -9,
        1
      ],
      [
        -20,
        2
      ],
      [
        -9,
        6
      ],
      [
        -10,
        23
      ],
      [
        -10,
        18
      ],
      [
        3,
        5
      ],
      [
        15,
        8
      ],
      [
        14,
        6
      ],
      [
        19,
        5
      ],
      [
        19,
        3
      ],
      [
        18,
        -1
      ],
      [
        14,
        -6
      ],
      [
        10,
        -8
      ],
      [
        13,
        -5
      ],
      [
        16,
        0
      ],
      [
        -7,
        13
      ],
      [
        35,
        -6
      ],
      [
        0,
        6
      ],
      [
        -7,
        0
      ],
      [
        0,
        6
      ],
      [
        47,
        3
      ],
      [
        14,
        -8
      ],
      [
        1,
        -27
      ],
      [
        16,
        5
      ],
      [
        5,
        2
      ],
      [
        -4,
        5
      ],
      [
        -10,
        14
      ],
      [
        22,
        0
      ],
      [
        -8,
        13
      ],
      [
        24,
        5
      ],
      [
        26,
        -4
      ],
      [
        22,
        -12
      ],
      [
        11,
        -21
      ],
      [
        13,
        11
      ],
      [
        15,
        7
      ],
      [
        -29,
        14
      ],
      [
        21,
        24
      ],
      [
        7,
        -3
      ],
      [
        6,
        -2
      ],
      [
        15,
        0
      ],
      [
        -13,
        10
      ],
      [
        19,
        3
      ],
      [
        49,
        -1
      ],
      [
        -24,
        8
      ],
      [
        -29,
        3
      ],
      [
        -24,
        7
      ],
      [
        -6,
        20
      ],
      [
        -20,
        -11
      ],
      [
        -10,
        -3
      ],
      [
        -12,
        1
      ],
      [
        -10,
        7
      ],
      [
        -4,
        9
      ],
      [
        5,
        9
      ],
      [
        10,
        6
      ],
      [
        0,
        6
      ],
      [
        -32,
        0
      ],
      [
        -13,
        2
      ],
      [
        -10,
        5
      ],
      [
        3,
        12
      ],
      [
        -3,
        16
      ],
      [
        -7,
        29
      ],
      [
        -13,
        -18
      ],
      [
        -10,
        -10
      ],
      [
        -11,
        -4
      ],
      [
        -16,
        3
      ],
      [
        -3,
        7
      ],
      [
        6,
        9
      ],
      [
        12,
        6
      ],
      [
        -19,
        0
      ],
      [
        -18,
        -2
      ],
      [
        -14,
        0
      ],
      [
        -18,
        8
      ],
      [
        -9,
        -10
      ],
      [
        -14,
        -4
      ],
      [
        -34,
        1
      ],
      [
        -3,
        5
      ],
      [
        5,
        11
      ],
      [
        9,
        11
      ],
      [
        8,
        5
      ],
      [
        25,
        -1
      ],
      [
        6,
        1
      ],
      [
        6,
        6
      ],
      [
        -1,
        13
      ],
      [
        3,
        6
      ],
      [
        10,
        8
      ],
      [
        12,
        8
      ],
      [
        12,
        0
      ],
      [
        15,
        -10
      ],
      [
        11,
        -19
      ],
      [
        33,
        -15
      ],
      [
        39,
        -6
      ],
      [
        33,
        9
      ],
      [
        -11,
        4
      ],
      [
        -15,
        2
      ],
      [
        -26,
        0
      ],
      [
        -8,
        3
      ],
      [
        -8,
        7
      ],
      [
        -12,
        7
      ],
      [
        -16,
        2
      ],
      [
        9,
        6
      ],
      [
        13,
        16
      ],
      [
        5,
        3
      ],
      [
        12,
        1
      ],
      [
        29,
        11
      ],
      [
        -13,
        7
      ],
      [
        9,
        7
      ],
      [
        2,
        4
      ],
      [
        -5,
        8
      ],
      [
        26,
        5
      ],
      [
        26,
        -2
      ],
      [
        28,
        -6
      ],
      [
        25,
        -10
      ],
      [
        6,
        6
      ],
      [
        -18,
        9
      ],
      [
        2,
        10
      ],
      [
        24,
        19
      ],
      [
        10,
        -18
      ],
      [
        0,
        -7
      ],
      [
        -5,
        -6
      ],
      [
        4,
        -8
      ]
    ],
    [
      [
        7132,
        9896
      ],
      [
        11,
        -16
      ],
      [
        11,
        11
      ],
      [
        21,
        3
      ],
      [
        44,
        -2
      ],
      [
        0,
        -12
      ],
      [
        -2,
        -4
      ],
      [
        -6,
        -2
      ],
      [
        0,
        -7
      ],
      [
        15,
        -6
      ],
      [
        -11,
        -11
      ],
      [
        1,
        -8
      ],
      [
        17,
        -18
      ],
      [
        -6,
        -10
      ],
      [
        -8,
        -9
      ],
      [
        -33,
        17
      ],
      [
        -16,
        6
      ],
      [
        -21,
        2
      ],
      [
        13,
        -7
      ],
      [
        13,
        -12
      ],
      [
        23,
        -25
      ],
      [
        -14,
        -5
      ],
      [
        -13,
        -2
      ],
      [
        -14,
        2
      ],
      [
        -14,
        5
      ],
      [
        5,
        -10
      ],
      [
        13,
        -6
      ],
      [
        14,
        -3
      ],
      [
        16,
        0
      ],
      [
        -1,
        -4
      ],
      [
        -6,
        -2
      ],
      [
        17,
        -9
      ],
      [
        1,
        -12
      ],
      [
        -12,
        -9
      ],
      [
        -19,
        -2
      ],
      [
        14,
        -15
      ],
      [
        4,
        -8
      ],
      [
        3,
        -12
      ],
      [
        -3,
        -11
      ],
      [
        -8,
        -2
      ],
      [
        -25,
        5
      ],
      [
        -25,
        -1
      ],
      [
        -11,
        3
      ],
      [
        -6,
        7
      ],
      [
        -9,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        11,
        -6
      ],
      [
        0,
        -6
      ],
      [
        -34,
        4
      ],
      [
        -23,
        11
      ],
      [
        -14,
        21
      ],
      [
        -12,
        86
      ],
      [
        8,
        19
      ],
      [
        34,
        3
      ],
      [
        0,
        -5
      ],
      [
        -4,
        -11
      ],
      [
        12,
        -11
      ],
      [
        16,
        -7
      ],
      [
        10,
        3
      ],
      [
        -3,
        4
      ],
      [
        -14,
        24
      ],
      [
        -4,
        13
      ],
      [
        3,
        6
      ],
      [
        10,
        13
      ],
      [
        -8,
        6
      ],
      [
        -1,
        9
      ],
      [
        3,
        9
      ],
      [
        4,
        7
      ],
      [
        10,
        10
      ],
      [
        12,
        9
      ],
      [
        12,
        0
      ]
    ],
    [
      [
        7437,
        9947
      ],
      [
        -19,
        -5
      ],
      [
        -12,
        -7
      ],
      [
        5,
        -11
      ],
      [
        1,
        -7
      ],
      [
        -20,
        0
      ],
      [
        13,
        -3
      ],
      [
        7,
        -3
      ],
      [
        0,
        -6
      ],
      [
        -41,
        -20
      ],
      [
        -7,
        -5
      ],
      [
        6,
        -11
      ],
      [
        15,
        -10
      ],
      [
        7,
        -9
      ],
      [
        -15,
        -8
      ],
      [
        -11,
        -1
      ],
      [
        -23,
        8
      ],
      [
        -21,
        1
      ],
      [
        -44,
        -3
      ],
      [
        -16,
        2
      ],
      [
        -16,
        6
      ],
      [
        5,
        8
      ],
      [
        1,
        9
      ],
      [
        -1,
        8
      ],
      [
        -4,
        6
      ],
      [
        18,
        -6
      ],
      [
        4,
        7
      ],
      [
        -2,
        14
      ],
      [
        -7,
        10
      ],
      [
        18,
        4
      ],
      [
        9,
        12
      ],
      [
        -1,
        14
      ],
      [
        -12,
        7
      ],
      [
        -1,
        7
      ],
      [
        17,
        3
      ],
      [
        19,
        9
      ],
      [
        14,
        11
      ],
      [
        -1,
        9
      ],
      [
        9,
        9
      ],
      [
        12,
        0
      ],
      [
        10,
        -7
      ],
      [
        4,
        -12
      ],
      [
        -5,
        -11
      ],
      [
        -9,
        -5
      ],
      [
        -12,
        -6
      ],
      [
        -9,
        -7
      ],
      [
        3,
        -2
      ],
      [
        12,
        2
      ],
      [
        15,
        5
      ],
      [
        9,
        5
      ],
      [
        20,
        34
      ],
      [
        11,
        7
      ],
      [
        6,
        -5
      ],
      [
        6,
        -1
      ],
      [
        14,
        -1
      ],
      [
        12,
        -2
      ],
      [
        12,
        -5
      ],
      [
        8,
        -7
      ],
      [
        3,
        -11
      ],
      [
        -8,
        -1
      ],
      [
        -19,
        -5
      ],
      [
        19,
        -5
      ],
      [
        7,
        -1
      ],
      [
        -15,
        -8
      ]
    ]
  ],
  "bbox": [
    -8.173808449742808,
    49.91400295081506,
    1.771750783047154,
    60.8482398071735
  ],
  "transform": {
    "scale": [
      0.000994655388817878,
      0.0010935330389397378
    ],
    "translate": [
      -8.173808449742808,
      49.91400295081506
    ]
  },
  "title": "United Kingdom",
  "version": "1.1.4",
  "copyright": "Copyright (c) 2022 Highsoft AS, Based on data from Natural Earth",
  "copyrightShort": "Natural Earth",
  "copyrightUrl": "http://www.naturalearthdata.com"
}